
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kAaxz", function(module, exports) {
var $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f = /*#__PURE__*/ function(ConvoAIResponseState) {
    ConvoAIResponseState["Initialization"] = "Initialization";
    ConvoAIResponseState["ChannelId"] = "ChannelId";
    ConvoAIResponseState["AnswerPart"] = "AnswerPart";
    ConvoAIResponseState["FinalResponse"] = "FinalResponse";
    ConvoAIResponseState["FollowUp"] = "FollowUp";
    ConvoAIResponseState["Error"] = "Error";
    ConvoAIResponseState["Trace"] = "Trace";
    return ConvoAIResponseState;
}({});
function $a6056237f8f2f3cc$export$c25f824513be9f8a() {
    return {
        content: null,
        responseState: "Initialization"
    };
}
module.exports["ConvoAIResponseState"] = $a6056237f8f2f3cc$export$5ad15ff4d6b74b3f;
module.exports["getDefaultConvoAIStreamingState"] = $a6056237f8f2f3cc$export$c25f824513be9f8a;

});

parcelRegister("3j1mV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dv2RR = parcelRequire("dv2RR");

var $9ekTs = parcelRequire("9ekTs");

var $hLgiF = parcelRequire("hLgiF");

const $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1 = (siteId, contentId, contentType)=>{
    const pageAri = (0, $42omo.useMemo)(()=>{
        try {
            switch(contentType){
                case 'page':
                    return (0, $9ekTs.ConfluencePageAri).create({
                        siteId: siteId,
                        pageId: contentId
                    }).toString();
                case 'blogpost':
                    return (0, $dv2RR.ConfluenceBlogpostAri).create({
                        siteId: siteId,
                        blogpostId: contentId
                    }).toString();
                case 'whiteboard':
                    return (0, $hLgiF.ConfluenceWhiteboardAri).create({
                        siteId: siteId,
                        whiteboardId: contentId
                    }).toString();
            }
        } catch  {
            return null;
        }
    }, [
        contentType,
        siteId,
        contentId
    ]);
    return {
        pageAri: pageAri
    };
};
module.exports["useConfluencePageAri"] = $4fb0a6929b7f9ec7$export$baf23e7d4a1078c1;

});

parcelRegister("iIEgX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $augeV = parcelRequire("augeV");

function $5805e7f3f1b14b04$export$42102e336cc49836(onObservableInit, inputs) {
    const [inputSubject$] = (0, $42omo.useState)(()=>new (0, $augeV.Subject)());
    const [observable$] = (0, $42omo.useState)(()=>onObservableInit(inputSubject$));
    (0, $42omo.useEffect)(()=>{
        const subscription$ = observable$.subscribe();
        return ()=>{
            subscription$.unsubscribe();
        };
    }, [
        observable$
    ]);
    const callback = (0, $42omo.useCallback)((nextState)=>inputSubject$.next(nextState), [
        inputSubject$
    ]);
    (0, $42omo.useEffect)(()=>{
        inputSubject$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        callback
    ];
}
module.exports["useObservableEffect"] = $5805e7f3f1b14b04$export$42102e336cc49836;

});

parcelRegister("aXpOY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5yfLD = parcelRequire("5yfLD");


var $augeV = parcelRequire("augeV");

function $e8269ad00759219d$export$7e63706be514842f(onObservableInit, initialState) {
    const [inputSubject$] = (0, $42omo.useState)(()=>new (0, $augeV.Subject)());
    const [observable$] = (0, $42omo.useState)(()=>onObservableInit(inputSubject$));
    const stateSnapshot = (0, $42omo.useRef)(initialState);
    const subscribe = (0, $42omo.useCallback)((handleStoreChange)=>{
        const subscription = observable$.subscribe({
            next: (nextState)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(nextState, stateSnapshot.current)) {
                    stateSnapshot.current = nextState;
                    handleStoreChange();
                }
            },
            // eslint-disable-next-line no-console
            error: (err)=>console.error(err),
            complete: ()=>inputSubject$.complete()
        });
        return ()=>subscription.unsubscribe();
    }, [
        inputSubject$,
        observable$
    ]);
    const getSnapshot = (0, $42omo.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const callback = (0, $42omo.useCallback)((nextState)=>{
        inputSubject$.next(nextState);
    }, [
        inputSubject$
    ]);
    const state = (0, $42omo.useSyncExternalStore)(subscribe, getSnapshot);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableLazyEffect"] = $e8269ad00759219d$export$7e63706be514842f;

});

parcelRegister("cPtvM", function(module, exports) {

var $5yfLD = parcelRequire("5yfLD");


var $hu8We = parcelRequire("hu8We");


var $8QQGs = parcelRequire("8QQGs");


var $iBgx8 = parcelRequire("iBgx8");


var $fulrs = parcelRequire("fulrs");


var $2mnXV = parcelRequire("2mnXV");


var $eVpDl = parcelRequire("eVpDl");


var $2QGAA = parcelRequire("2QGAA");


var $3VDUL = parcelRequire("3VDUL");


var $j8M4E = parcelRequire("j8M4E");


var $i3vZV = parcelRequire("i3vZV");


var $ePuNq = parcelRequire("ePuNq");


var $93WqG = parcelRequire("93WqG");

const $616a3b6034357a30$export$39a530c281991f7b = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.apiPath}`
    };
};



var $7W3Ly = parcelRequire("7W3Ly");

const $6f61a4b2d82d43e7$export$7c03f5942efb8a41 = '/gateway/api/assist/api/ai';


const $7087f936648f12b4$var$baseUrl = (0, $7W3Ly.Lens).fromNullableProp()('baseUrl', (0, $6f61a4b2d82d43e7$export$7c03f5942efb8a41));
const $7087f936648f12b4$var$enablePartialJson = (0, $7W3Ly.Lens).fromNullableProp()('enablePartialJson', false);
const $7087f936648f12b4$var$enableFollowUp = (0, $7W3Ly.Lens).fromNullableProp()('enableFollowUp', false);
const $7087f936648f12b4$var$enableLocalVerboseLogs = (0, $7W3Ly.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $7087f936648f12b4$var$enableTraceMessage = (0, $7W3Ly.Lens).fromNullableProp()('enableTraceMessage', false);
const $7087f936648f12b4$var$skip = (0, $7W3Ly.Lens).fromNullableProp()('skip', false);
const $7087f936648f12b4$var$contentType = (0, $7W3Ly.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $7087f936648f12b4$var$xIssyntheticTraffic = (0, $7W3Ly.Lens).fromNullableProp()('x-issynthetic-traffic', 'false');
function $7087f936648f12b4$var$getHeaders(config) {
    const headers = {
        'content-type': $7087f936648f12b4$var$contentType.get(config.headers),
        'x-product': config.headers['x-product'],
        'x-experience-id': config.headers['x-experience-id'],
        'x-issynthetic-traffic': $7087f936648f12b4$var$xIssyntheticTraffic.get(config.headers)
    };
    if (config.headers['x-channel-id']) headers['x-channel-id'] = config.headers['x-channel-id'];
    return headers;
}
const $7087f936648f12b4$export$98f0249d9632eade = (config)=>({
        baseUrl: $7087f936648f12b4$var$baseUrl.get(config),
        apiPath: config.apiPath,
        enablePartialJson: $7087f936648f12b4$var$enablePartialJson.get(config),
        enableFollowUp: $7087f936648f12b4$var$enableFollowUp.get(config),
        enableTraceMessage: $7087f936648f12b4$var$enableTraceMessage.get(config),
        enableLocalVerboseLogs: $7087f936648f12b4$var$enableLocalVerboseLogs.get(config),
        timeoutDelay: config.timeoutDelay,
        skip: $7087f936648f12b4$var$skip.get(config),
        headers: $7087f936648f12b4$var$getHeaders(config)
    });



var $5h38X = parcelRequire("5h38X");


var $kAaxz = parcelRequire("kAaxz");


var $dWJ5i = parcelRequire("dWJ5i");




async function* $20c346f17ddaccf2$export$e45226161c660403(response) {
    // Read the response body only if the status is 200 and the body is not null
    if (response.status === 200 && response.body) try {
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            const decodedValue = decoder.decode(value);
            done = doneReading;
            buffer = `${buffer}${decodedValue}`;
            // Split the buffer by line breaks
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                const line = lines.shift();
                const parsedData = JSON.parse(line);
                yield parsedData;
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return;
    } catch (parsingError) {
        let errorText = '';
        if (typeof parsingError === 'string') errorText = parsingError.toUpperCase();
        else if (parsingError instanceof Error) errorText = parsingError.message;
        yield {
            type: 'ERROR',
            message: {
                content: `[Stream Error]: ${errorText}. locked status: ${response.body.locked}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
            }
        };
        return;
    }
    // parse the response body as text which should be safe
    const responseText = await response.text();
    try {
        // try to parse the response body as json
        const responseJson = JSON.parse(responseText);
        // covered HTTP errors only from this doc
        // https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3420210503/Error+message+formats+-+assistance-service
        // Kept for extra error handling security as we migrate to convo-ai from agent service
        yield (0, $dWJ5i.match)({
            status: response.status,
            body: response.body,
            text: responseText,
            json: responseJson
        }).returnType().with({
            status: 201
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: No answer was generated by Open AI. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 400
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: BAD_REQUEST or NO_AGENT or EXCEEDING_CONTEXT_LENGTH_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 403
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: FEATURE_DISABLED_ON_SITE or FEATURE_DISABLED or HIPAA_CONTENT_DETECTED. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).BAD_REQUEST,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 429
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: RATE_LIMIT or OPENAI_RATE_LIMIT_USER_ABUSE. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).RATE_LIMIT,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            status: 500
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: INTERNAL_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).with({
            body: (0, $dWJ5i.P).nullish
        }, ({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[Error]: response.body is missing. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            })).otherwise(({ text: text, status: status, json: json })=>({
                type: 'ERROR',
                message: {
                    content: `[HTTP Error]: OTHER_SERVER_ERROR. Raw error details: ${text}. statusCode: ${status}`,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: response.status
                },
                jsonRawResponse: json
            }));
    } catch (error) {
        yield {
            type: 'ERROR',
            message: {
                content: `[HTTP Error]: UNABLE_TO_PARSE_HTTP_ERROR. Raw error details: ${responseText}. statusCode: ${response.status}`,
                message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                status_code: response.status
            }
        };
    }
}


function $69c89c3d2d0641e2$export$2f20a85d8fafe2d9(requestConfig) {
    const behaviorSubject = new (0, $5h38X.BehaviorSubject)((0, $kAaxz.getDefaultConvoAIStreamingState)());
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $20c346f17ddaccf2$export$e45226161c660403)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'CHANNEL_ID':
                    const channelId = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).ChannelId,
                        content: channelId,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).FinalResponse,
                        content: bufferContent,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).FollowUp,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? []
                    });
                    break;
                case 'TRACE':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).Trace,
                        traceContent: chunk.message?.content ?? null,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                        answerChunkIndex: undefined,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}



var $8ogUZ = parcelRequire("8ogUZ");




function $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d(state, config) {
    if (state.responseState !== (0, $kAaxz.ConvoAIResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $8ogUZ.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}


const $ffa31632e87ec23b$export$7eba3e1ed428e5ae = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
};





function $00c22fcadb546387$export$a0d56a856e9914d2(input$) {
    return input$.pipe((0, $3VDUL.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $2mnXV.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $2QGAA.map)(({ inputs: [request, config] })=>({
            config: (0, $7087f936648f12b4$export$98f0249d9632eade)(config),
            request: request
        })), (0, $2QGAA.map)(({ request: request, config: config })=>({
            requestConfig: (0, $616a3b6034357a30$export$39a530c281991f7b)(request, config),
            config: config
        })), (0, $j8M4E.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $ffa31632e87ec23b$export$7eba3e1ed428e5ae)('pre request data', config, requestConfig);
        let $request = (0, $69c89c3d2d0641e2$export$2f20a85d8fafe2d9)(requestConfig);
        if (config.timeoutDelay) return $request.pipe((0, $ePuNq.timeout)(config.timeoutDelay), (0, $2QGAA.map)((state)=>({
                config: config,
                state: state
            })));
        return $request.pipe((0, $2QGAA.map)((state)=>({
                config: config,
                state: state
            })));
    }))// pipe() has an apparent limit of 9 operators
    // https://github.com/ReactiveX/rxjs/issues/4221#issuecomment-426774631
    .pipe((0, $eVpDl.filter)(({ config: config, state: state })=>{
        if (!config.enableFollowUp && state.responseState === (0, $kAaxz.ConvoAIResponseState).FollowUp) return false;
        if (!config.enableTraceMessage && state.responseState === (0, $kAaxz.ConvoAIResponseState).Trace) return false;
        return true;
    }), (0, $2QGAA.map)(({ config: config, state: state })=>{
        (0, $ffa31632e87ec23b$export$7eba3e1ed428e5ae)('response data', config, state);
        const nextState = (0, $b0fe2e92f6e87b5f$export$d2c9dfa182282b6d)(state, config);
        (0, $ffa31632e87ec23b$export$7eba3e1ed428e5ae)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $i3vZV.timeInterval)(), (0, $iBgx8.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $hu8We.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $hu8We.of)(state).pipe((0, $fulrs.delay)(time));
        return (0, $hu8We.of)(state);
    }), (0, $8QQGs.catchError)((error)=>{
        if (error.name === 'TimeoutError') {
            const timeoutErrorState = {
                responseState: (0, $kAaxz.ConvoAIResponseState).Error,
                content: null,
                answerChunkIndex: undefined,
                error: {
                    type: 'ERROR',
                    message: {
                        content: error.message,
                        message_template: (0, $93WqG.ConvoAIErrorMessage).TIMEOUT,
                        status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                    }
                }
            };
            return (0, $hu8We.of)(timeoutErrorState);
        }
        const unexpectedErrorState = {
            responseState: (0, $kAaxz.ConvoAIResponseState).Error,
            content: null,
            error: {
                type: 'ERROR',
                message: {
                    content: error.message,
                    message_template: (0, $93WqG.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: (0, $93WqG.CONVOAI_DEFAULT_ERROR_CODE)
                }
            }
        };
        return (0, $hu8We.of)(unexpectedErrorState);
    }));
}
module.exports["convoAIStreamingEffect"] = $00c22fcadb546387$export$a0d56a856e9914d2;

});

parcelRegister("93WqG", function(module, exports) {
var $855f7e526aba7e75$export$cb6667e6b65615 = /*#__PURE__*/ function(ConvoAIErrorMessage) {
    ConvoAIErrorMessage["RATE_LIMIT"] = "RATE_LIMIT";
    ConvoAIErrorMessage["ANSWER_UNAVAILABLE_FOR_CONTENT"] = "ANSWER_UNAVAILABLE_FOR_CONTENT";
    ConvoAIErrorMessage["ACCEPTABLE_USE_VIOLATIONS"] = "ACCEPTABLE_USE_VIOLATIONS";
    ConvoAIErrorMessage["NOT_ENOUGH_CONTENT_ERROR"] = "NOT_ENOUGH_CONTENT_ERROR";
    ConvoAIErrorMessage["NOT_FOUND"] = "NOT_FOUND";
    ConvoAIErrorMessage["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    ConvoAIErrorMessage["BAD_REQUEST"] = "BAD_REQUEST";
    ConvoAIErrorMessage["UNEXPECTED"] = "UNEXPECTED";
    ConvoAIErrorMessage["TIMEOUT"] = "TIMEOUT";
    return ConvoAIErrorMessage;
}({});
const $855f7e526aba7e75$export$26a36d98cab4996b = 0;
module.exports["ConvoAIErrorMessage"] = $855f7e526aba7e75$export$cb6667e6b65615;
module.exports["CONVOAI_DEFAULT_ERROR_CODE"] = $855f7e526aba7e75$export$26a36d98cab4996b;

});

parcelRegister("7W3Ly", function(module, exports) {
$parcel$export(module.exports, "Lens", () => Lens);
/**
 * @since 1.0.0
 */ /**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ var $ee6b3436e10e8e67$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $ee6b3436e10e8e67$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $ee6b3436e10e8e67$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $ee6b3436e10e8e67$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $ee6b3436e10e8e67$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $ee6b3436e10e8e67$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $ee6b3436e10e8e67$export$575097c1c561f76f = function(R) {
    var S = $ee6b3436e10e8e67$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $ee6b3436e10e8e67$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $ee6b3436e10e8e67$export$f0954fd7d5368655(a) {
    return a;
}
var $ee6b3436e10e8e67$export$401372c57776dc = $ee6b3436e10e8e67$export$f0954fd7d5368655;
function $ee6b3436e10e8e67$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $ee6b3436e10e8e67$export$a68382d9631f6c53 = /*#__PURE__*/ $ee6b3436e10e8e67$export$c983f826f44ff86(true);
var $ee6b3436e10e8e67$export$7349232f2648ca80 = /*#__PURE__*/ $ee6b3436e10e8e67$export$c983f826f44ff86(false);
var $ee6b3436e10e8e67$export$243c2ee5e7d8b05c = /*#__PURE__*/ $ee6b3436e10e8e67$export$c983f826f44ff86(null);
var $ee6b3436e10e8e67$export$3d16a43570087548 = /*#__PURE__*/ $ee6b3436e10e8e67$export$c983f826f44ff86(undefined);
var $ee6b3436e10e8e67$export$fe2a8306a887c223 = $ee6b3436e10e8e67$export$3d16a43570087548;
function $ee6b3436e10e8e67$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $ee6b3436e10e8e67$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $ee6b3436e10e8e67$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $ee6b3436e10e8e67$export$a2647aa13413c947(n) {
    return n + 1;
}
function $ee6b3436e10e8e67$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $ee6b3436e10e8e67$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $ee6b3436e10e8e67$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $ee6b3436e10e8e67$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $ee6b3436e10e8e67$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $ee6b3436e10e8e67$export$5cc5fd8bb7edf254 = $ee6b3436e10e8e67$export$f172309911142386;
var $ee6b3436e10e8e67$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $ee6b3436e10e8e67$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $ee6b3436e10e8e67$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $ee6b3436e10e8e67$export$ccc7b0636abaffc3(first, second);
        },
        empty: $ee6b3436e10e8e67$export$f0954fd7d5368655
    };
};
var $ee6b3436e10e8e67$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $ee6b3436e10e8e67$var$__spreadArray([
                self
            ], args, false));
        };
    };
};



var $54ef96f182e81a75$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $54ef96f182e81a75$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $54ef96f182e81a75$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $54ef96f182e81a75$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $54ef96f182e81a75$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $54ef96f182e81a75$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $54ef96f182e81a75$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $54ef96f182e81a75$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $54ef96f182e81a75$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $54ef96f182e81a75$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $54ef96f182e81a75$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $54ef96f182e81a75$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $54ef96f182e81a75$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $54ef96f182e81a75$export$6ca726a2417e0f3f = [];
var $54ef96f182e81a75$export$4de80339753b012b = {};
var $54ef96f182e81a75$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $54ef96f182e81a75$export$7e77326b0f0e268c = function(as) {
    return $54ef96f182e81a75$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $54ef96f182e81a75$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $54ef96f182e81a75$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $54ef96f182e81a75$export$79ffe56a765070d2(o));
        };
    };
};
var $54ef96f182e81a75$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($54ef96f182e81a75$export$e56af863d5645d5f(o) ? $54ef96f182e81a75$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $54ef96f182e81a75$export$79ffe56a765070d2(o.value));
        };
    };
};
var $54ef96f182e81a75$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(3, function(self, f, onNullable) {
        return M.flatMap(self, $54ef96f182e81a75$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $54ef96f182e81a75$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(3, function(self, f, onNone) {
        return M.flatMap(self, $54ef96f182e81a75$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $54ef96f182e81a75$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $54ef96f182e81a75$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $54ef96f182e81a75$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $54ef96f182e81a75$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};


function $4e77e1f8d7cf5551$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $4e77e1f8d7cf5551$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $4e77e1f8d7cf5551$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $4e77e1f8d7cf5551$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $4e77e1f8d7cf5551$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $4e77e1f8d7cf5551$var$curried(f, n - 1, combined);
    };
}
var $4e77e1f8d7cf5551$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $4e77e1f8d7cf5551$var$getTupleConstructor(len) {
    if (!$54ef96f182e81a75$export$a4f4bb6b1453fff5.call($4e77e1f8d7cf5551$var$tupleConstructors, len)) $4e77e1f8d7cf5551$var$tupleConstructors[len] = $4e77e1f8d7cf5551$var$curried((0, $ee6b3436e10e8e67$export$65e3907585753458), len - 1, []);
    return $4e77e1f8d7cf5551$var$tupleConstructors[len];
}
function $4e77e1f8d7cf5551$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $4e77e1f8d7cf5551$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $4e77e1f8d7cf5551$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $4e77e1f8d7cf5551$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $4e77e1f8d7cf5551$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $4e77e1f8d7cf5551$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}


function $b00b894e7b37435b$export$e3821ef4970c339c(M) {
    var tapM = $b00b894e7b37435b$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $b00b894e7b37435b$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $b00b894e7b37435b$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}


/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 


function $1f0befb2747eca52$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($54ef96f182e81a75$export$e56af863d5645d5f(ma) ? $54ef96f182e81a75$export$eabcd2c8791e7bf4(onNone()) : $54ef96f182e81a75$export$79ffe56a765070d2(ma.value));
        };
    };
}
function $1f0befb2747eca52$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $54ef96f182e81a75$export$79ffe56a765070d2(a) : $54ef96f182e81a75$export$eabcd2c8791e7bf4(onFalse(a)));
        };
    };
}
function $1f0befb2747eca52$export$a907462f448b49f8(F) {
    var fromOptionF = $1f0befb2747eca52$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(f, from);
        };
    };
}
function $1f0befb2747eca52$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $1f0befb2747eca52$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $1f0befb2747eca52$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(f, F.fromEither);
    };
}
function $1f0befb2747eca52$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $1f0befb2747eca52$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $1f0befb2747eca52$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $1f0befb2747eca52$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $1f0befb2747eca52$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $54ef96f182e81a75$export$79ffe56a765070d2(a) : $54ef96f182e81a75$export$eabcd2c8791e7bf4(onFalse(a)));
            });
        };
    };
}
function $1f0befb2747eca52$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $1f0befb2747eca52$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $b00b894e7b37435b$export$3f23594af5f37336)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}



/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
function $34b267f7755fe355$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $34b267f7755fe355$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $34b267f7755fe355$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $34b267f7755fe355$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $34b267f7755fe355$export$7b0f6fce42e2b480(F, G) {
    var _map = $34b267f7755fe355$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fga, _map(f));
        }
    };
}
function $34b267f7755fe355$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $34b267f7755fe355$export$9284b360ca18a0fd(F) {
    var asM = $34b267f7755fe355$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}









var $f591655db7bad68b$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $f591655db7bad68b$export$8cf3da7c1c9174ea = function(eqs) {
    return $f591655db7bad68b$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $f591655db7bad68b$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $f591655db7bad68b$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $f591655db7bad68b$var$contramap_ = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $f591655db7bad68b$export$53b696d27ecb7ba7(f));
};
var $f591655db7bad68b$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $f591655db7bad68b$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $f591655db7bad68b$export$9156e739aa33e19f = 'Eq';
var $f591655db7bad68b$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $f591655db7bad68b$var$empty = {
    equals: function() {
        return true;
    }
};
var $f591655db7bad68b$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $f591655db7bad68b$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $f591655db7bad68b$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $f591655db7bad68b$export$e759a9a7f8d04692().concat,
        empty: $f591655db7bad68b$var$empty
    };
};
var $f591655db7bad68b$export$def901a57d5539c3 = {
    URI: $f591655db7bad68b$export$9156e739aa33e19f,
    contramap: $f591655db7bad68b$var$contramap_
};
var $f591655db7bad68b$export$1a50cb133a346493 = $f591655db7bad68b$export$65e3907585753458;
var $f591655db7bad68b$export$b35b2bde1875587a = $f591655db7bad68b$export$8cf3da7c1c9174ea;
var $f591655db7bad68b$export$24d177074f8dc6ef = $f591655db7bad68b$export$37a88d8211c10fd3.equals;
var $f591655db7bad68b$export$9663ddc1cf085b32 = $f591655db7bad68b$export$def901a57d5539c3;
var $f591655db7bad68b$export$d7927e8ffc1afb48 = $f591655db7bad68b$export$37a88d8211c10fd3;
var $f591655db7bad68b$export$fa624555ca2acbc8 = $f591655db7bad68b$export$37a88d8211c10fd3;
var $f591655db7bad68b$export$e24978670be1e4f3 = $f591655db7bad68b$export$37a88d8211c10fd3;
var $f591655db7bad68b$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};



var $b73550eda84ebfbf$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $b73550eda84ebfbf$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $b73550eda84ebfbf$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $b73550eda84ebfbf$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $b73550eda84ebfbf$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $b73550eda84ebfbf$export$66c1ae025e96b4bc = function(O) {
    return $b73550eda84ebfbf$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $b73550eda84ebfbf$var$contramap_ = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $b73550eda84ebfbf$export$53b696d27ecb7ba7(f));
};
var $b73550eda84ebfbf$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $b73550eda84ebfbf$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $b73550eda84ebfbf$export$9156e739aa33e19f = 'Ord';
var $b73550eda84ebfbf$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $b73550eda84ebfbf$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $b73550eda84ebfbf$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $b73550eda84ebfbf$export$e759a9a7f8d04692().concat,
        empty: $b73550eda84ebfbf$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $b73550eda84ebfbf$export$def901a57d5539c3 = {
    URI: $b73550eda84ebfbf$export$9156e739aa33e19f,
    contramap: $b73550eda84ebfbf$var$contramap_
};
var $b73550eda84ebfbf$export$e5bb9f0f2dedbef6 = {
    equals: (0, $ee6b3436e10e8e67$export$a68382d9631f6c53),
    compare: /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$c983f826f44ff86)(0)
};
var $b73550eda84ebfbf$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $b73550eda84ebfbf$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $b73550eda84ebfbf$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $b73550eda84ebfbf$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $b73550eda84ebfbf$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $b73550eda84ebfbf$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $b73550eda84ebfbf$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $b73550eda84ebfbf$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $b73550eda84ebfbf$export$96ec731ed4dcb222(O);
    var maxO = $b73550eda84ebfbf$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $b73550eda84ebfbf$export$cf95c51b03f10bae = function(O) {
    var ltO = $b73550eda84ebfbf$export$b961576059b7aeb6(O);
    var gtO = $b73550eda84ebfbf$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $b73550eda84ebfbf$export$c41db498223b95e9 = $b73550eda84ebfbf$export$65e3907585753458;
var $b73550eda84ebfbf$export$35315ebcdff1b05c = $b73550eda84ebfbf$export$66c1ae025e96b4bc;
var $b73550eda84ebfbf$export$ad12338f1fefb50e = $b73550eda84ebfbf$export$def901a57d5539c3;
// default compare for primitive types
function $b73550eda84ebfbf$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $b73550eda84ebfbf$var$strictOrd = {
    equals: (0, $f591655db7bad68b$export$37a88d8211c10fd3).equals,
    compare: $b73550eda84ebfbf$var$compare
};
var $b73550eda84ebfbf$export$ef759d57a4e44836 = $b73550eda84ebfbf$var$strictOrd;
var $b73550eda84ebfbf$export$c5f2758e49b2b86a = $b73550eda84ebfbf$var$strictOrd;
var $b73550eda84ebfbf$export$5ed021ff2336715c = $b73550eda84ebfbf$var$strictOrd;
var $b73550eda84ebfbf$export$722593c82468f9f4 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$a4627e546088548d)($b73550eda84ebfbf$export$5ed021ff2336715c, /*#__PURE__*/ $b73550eda84ebfbf$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));









var $1e8be413a8f63f69$exports = {};
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 

/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $8b3cfd9ec0ec378a$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $8b3cfd9ec0ec378a$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $8b3cfd9ec0ec378a$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $8b3cfd9ec0ec378a$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $8b3cfd9ec0ec378a$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};



var $1e8be413a8f63f69$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $b73550eda84ebfbf$export$96ec731ed4dcb222(O)
    };
};
var $1e8be413a8f63f69$export$8960430cfd85939f = function(O) {
    return {
        concat: $b73550eda84ebfbf$export$8960430cfd85939f(O)
    };
};
var $1e8be413a8f63f69$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $1e8be413a8f63f69$export$66c1ae025e96b4bc = $8b3cfd9ec0ec378a$export$66c1ae025e96b4bc;
var $1e8be413a8f63f69$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $1e8be413a8f63f69$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $1e8be413a8f63f69$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $1e8be413a8f63f69$export$43128fadae87b74a = function() {
    return {
        concat: (0, $ee6b3436e10e8e67$export$f0954fd7d5368655)
    };
};
var $1e8be413a8f63f69$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $1e8be413a8f63f69$export$b314777ae20abca9 = $8b3cfd9ec0ec378a$export$b314777ae20abca9;
var $1e8be413a8f63f69$export$36aabcd6b6e45f3b = $1e8be413a8f63f69$export$c983f826f44ff86(undefined);
var $1e8be413a8f63f69$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $1e8be413a8f63f69$export$edb0acd3f464ffc5 = $1e8be413a8f63f69$export$4c7897fafd92b108;
var $1e8be413a8f63f69$export$84a57d7a8bf6c3ea = $1e8be413a8f63f69$export$43128fadae87b74a;
var $1e8be413a8f63f69$export$bd94daf2735ef9c = $1e8be413a8f63f69$export$65e3907585753458;
var $1e8be413a8f63f69$export$98d1814f8ed74e13 = $1e8be413a8f63f69$export$8cf3da7c1c9174ea;
var $1e8be413a8f63f69$export$e0cea6c43ec66a1 = $1e8be413a8f63f69$export$66c1ae025e96b4bc;
var $1e8be413a8f63f69$export$4278e54cd9769e6d = $1e8be413a8f63f69$export$8960430cfd85939f;
var $1e8be413a8f63f69$export$7baccd77d16d1a41 = $1e8be413a8f63f69$export$96ec731ed4dcb222;
var $1e8be413a8f63f69$export$fcc2cca196b2daf0 = $1e8be413a8f63f69$export$739ec22334c44788;
function $1e8be413a8f63f69$export$93e2b83da34ff82a(S) {
    var concatAllS = $1e8be413a8f63f69$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $1e8be413a8f63f69$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $1e8be413a8f63f69$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $1e8be413a8f63f69$export$b2ecf5de014857c2 = (0, $ee6b3436e10e8e67$export$e759a9a7f8d04692);
var $1e8be413a8f63f69$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $1e8be413a8f63f69$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $1e8be413a8f63f69$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};
$1e8be413a8f63f69$exports["min"] = $1e8be413a8f63f69$export$96ec731ed4dcb222;
$1e8be413a8f63f69$exports["max"] = $1e8be413a8f63f69$export$8960430cfd85939f;
$1e8be413a8f63f69$exports["constant"] = $1e8be413a8f63f69$export$c983f826f44ff86;
$1e8be413a8f63f69$exports["reverse"] = $1e8be413a8f63f69$export$66c1ae025e96b4bc;
$1e8be413a8f63f69$exports["struct"] = $1e8be413a8f63f69$export$8cf3da7c1c9174ea;
$1e8be413a8f63f69$exports["tuple"] = $1e8be413a8f63f69$export$65e3907585753458;
$1e8be413a8f63f69$exports["intercalate"] = $1e8be413a8f63f69$export$739ec22334c44788;
$1e8be413a8f63f69$exports["first"] = $1e8be413a8f63f69$export$43128fadae87b74a;
$1e8be413a8f63f69$exports["last"] = $1e8be413a8f63f69$export$4c7897fafd92b108;
$1e8be413a8f63f69$exports["concatAll"] = $1e8be413a8f63f69$export$b314777ae20abca9;
$1e8be413a8f63f69$exports["semigroupVoid"] = $1e8be413a8f63f69$export$36aabcd6b6e45f3b;
$1e8be413a8f63f69$exports["getObjectSemigroup"] = $1e8be413a8f63f69$export$2f965793fef2fb8a;
$1e8be413a8f63f69$exports["getLastSemigroup"] = $1e8be413a8f63f69$export$edb0acd3f464ffc5;
$1e8be413a8f63f69$exports["getFirstSemigroup"] = $1e8be413a8f63f69$export$84a57d7a8bf6c3ea;
$1e8be413a8f63f69$exports["getTupleSemigroup"] = $1e8be413a8f63f69$export$bd94daf2735ef9c;
$1e8be413a8f63f69$exports["getStructSemigroup"] = $1e8be413a8f63f69$export$98d1814f8ed74e13;
$1e8be413a8f63f69$exports["getDualSemigroup"] = $1e8be413a8f63f69$export$e0cea6c43ec66a1;
$1e8be413a8f63f69$exports["getJoinSemigroup"] = $1e8be413a8f63f69$export$4278e54cd9769e6d;
$1e8be413a8f63f69$exports["getMeetSemigroup"] = $1e8be413a8f63f69$export$7baccd77d16d1a41;
$1e8be413a8f63f69$exports["getIntercalateSemigroup"] = $1e8be413a8f63f69$export$fcc2cca196b2daf0;
$1e8be413a8f63f69$exports["fold"] = $1e8be413a8f63f69$export$93e2b83da34ff82a;
$1e8be413a8f63f69$exports["semigroupAll"] = $1e8be413a8f63f69$export$e8f9875ab703bdff;
$1e8be413a8f63f69$exports["semigroupAny"] = $1e8be413a8f63f69$export$9511aba5be5ac81b;
$1e8be413a8f63f69$exports["getFunctionSemigroup"] = $1e8be413a8f63f69$export$b2ecf5de014857c2;
$1e8be413a8f63f69$exports["semigroupString"] = $1e8be413a8f63f69$export$d9b7100b101f2c5b;
$1e8be413a8f63f69$exports["semigroupSum"] = $1e8be413a8f63f69$export$1481126044ad2de0;
$1e8be413a8f63f69$exports["semigroupProduct"] = $1e8be413a8f63f69$export$a22a2283cc3aa839;


var $69ae994846dd7463$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $69ae994846dd7463$export$6e22c362a0406a2c = $54ef96f182e81a75$export$6ca726a2417e0f3f;
var $69ae994846dd7463$export$a978c53b4062a525 = $54ef96f182e81a75$export$a978c53b4062a525;
var $69ae994846dd7463$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $69ae994846dd7463$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $69ae994846dd7463$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $69ae994846dd7463$export$68159836694e22c1 = $69ae994846dd7463$export$c4c4d41eab625797;
var $69ae994846dd7463$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $69ae994846dd7463$var$__spreadArray($69ae994846dd7463$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $69ae994846dd7463$export$10d8903dec122b9d = $69ae994846dd7463$export$19903a1bf1942f6;
var $69ae994846dd7463$export$f4863e1822a1860c = function(i, a, as) {
    if ($69ae994846dd7463$export$a978c53b4062a525(as)) {
        var xs = $54ef96f182e81a75$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $69ae994846dd7463$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $54ef96f182e81a75$export$7e77326b0f0e268c(as);
        xs[i] = a;
        return xs;
    }
};
var $69ae994846dd7463$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $69ae994846dd7463$export$5fd5031fecdacec3(as)
        ];
        var rest = $69ae994846dd7463$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $69ae994846dd7463$export$b035e44d7bb4278f = function(ords) {
    if ($69ae994846dd7463$export$a978c53b4062a525(ords)) {
        var M = (0, $b73550eda84ebfbf$export$c2a7ef2cc9b32b31)();
        return $69ae994846dd7463$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $ee6b3436e10e8e67$export$f0954fd7d5368655;
};
var $69ae994846dd7463$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $69ae994846dd7463$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $ee6b3436e10e8e67$export$a4627e546088548d)(first, $69ae994846dd7463$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $69ae994846dd7463$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($69ae994846dd7463$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $69ae994846dd7463$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(s, $69ae994846dd7463$export$ee1b3e54f0441b22(f));
        } else return $69ae994846dd7463$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $69ae994846dd7463$export$9288e031f1846591 = function(as) {
    return $69ae994846dd7463$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd(as) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $69ae994846dd7463$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $69ae994846dd7463$export$606959e7ccb797f0 = function(a) {
    return $69ae994846dd7463$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $69ae994846dd7463$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $69ae994846dd7463$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $69ae994846dd7463$export$c04edabe9c8d994f = function(as) {
    return [
        $69ae994846dd7463$export$5fd5031fecdacec3(as),
        $69ae994846dd7463$export$c01875f616615628(as)
    ];
};
var $69ae994846dd7463$export$89a97afc72a83708 = function(as) {
    return [
        $69ae994846dd7463$export$2cd8252107eb640b(as),
        $69ae994846dd7463$export$4c7897fafd92b108(as)
    ];
};
var $69ae994846dd7463$export$571d59b505e6bb4e = function(as) {
    return $69ae994846dd7463$export$9288e031f1846591(as.slice());
};
function $69ae994846dd7463$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $69ae994846dd7463$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $69ae994846dd7463$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $69ae994846dd7463$var$__spreadArray([
        $69ae994846dd7463$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $69ae994846dd7463$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $69ae994846dd7463$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $69ae994846dd7463$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $69ae994846dd7463$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $69ae994846dd7463$export$b6d8713d53419d4c = function(i, a) {
    return $69ae994846dd7463$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $69ae994846dd7463$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $69ae994846dd7463$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $69ae994846dd7463$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $69ae994846dd7463$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $69ae994846dd7463$export$8901015135f2fb22(bs, as);
    };
    return $69ae994846dd7463$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $69ae994846dd7463$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $69ae994846dd7463$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $69ae994846dd7463$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $69ae994846dd7463$export$c01875f616615628(as);
        return $69ae994846dd7463$export$a978c53b4062a525(rest) ? (0, $ee6b3436e10e8e67$export$a4627e546088548d)(rest, $69ae994846dd7463$export$849c7567cbd62acc(middle), $69ae994846dd7463$export$68159836694e22c1($69ae994846dd7463$export$5fd5031fecdacec3(as))) : as;
    };
};
var $69ae994846dd7463$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $54ef96f182e81a75$export$7e77326b0f0e268c(f(0, $69ae994846dd7463$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $69ae994846dd7463$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($69ae994846dd7463$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $69ae994846dd7463$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $69ae994846dd7463$export$6e22c362a0406a2c
        ] : [
            (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as.slice(1, m), $69ae994846dd7463$export$68159836694e22c1($69ae994846dd7463$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $69ae994846dd7463$export$2f0184d5df52135f = function(n) {
    return $69ae994846dd7463$export$433fe05b12ba833f($69ae994846dd7463$export$b0d75975ac0be0e1(n));
};
var $69ae994846dd7463$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_mapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$8f07ddce13659f50(f));
};
var $69ae994846dd7463$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $69ae994846dd7463$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_extend = function(wa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(wa, $69ae994846dd7463$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_foldMap = function(M) {
    var foldMapM = $69ae994846dd7463$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_traverse = function(F) {
    var traverseF = $69ae994846dd7463$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $69ae994846dd7463$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $69ae994846dd7463$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $69ae994846dd7463$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $69ae994846dd7463$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $69ae994846dd7463$export$ba255e9e49e00608 = $54ef96f182e81a75$export$439306a4dcaafbb9;
var $69ae994846dd7463$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $69ae994846dd7463$export$c8c959650bbe80e2(that()));
    };
};
var $69ae994846dd7463$export$228be17d80722ab = $69ae994846dd7463$export$1517cca7889d6aaa;
var $69ae994846dd7463$export$2f6ca3d3b1f80bf5 = function(as) {
    return $69ae994846dd7463$export$5b8affa63fc6df16(function(f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $69ae994846dd7463$export$871de8747c9eaa88(f));
    });
};
var $69ae994846dd7463$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ma, $69ae994846dd7463$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $69ae994846dd7463$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $69ae994846dd7463$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($69ae994846dd7463$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $69ae994846dd7463$export$c01875f616615628(next);
        }
        return out;
    };
};
var $69ae994846dd7463$export$ecd5e8ace626722c = /*#__PURE__*/ $69ae994846dd7463$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $69ae994846dd7463$export$bffa455ba8c619a6 = /*#__PURE__*/ $69ae994846dd7463$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $69ae994846dd7463$export$871de8747c9eaa88 = function(f) {
    return $69ae994846dd7463$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $69ae994846dd7463$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $69ae994846dd7463$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $69ae994846dd7463$export$533b26079ad0b4b = function(b, f) {
    return $69ae994846dd7463$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $69ae994846dd7463$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $69ae994846dd7463$export$7fef8bcdbb34f435 = function(b, f) {
    return $69ae994846dd7463$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $69ae994846dd7463$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $69ae994846dd7463$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $69ae994846dd7463$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $69ae994846dd7463$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $69ae994846dd7463$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $69ae994846dd7463$export$49bb65c2ea163039 = function(F) {
    return $69ae994846dd7463$export$955fdc0d24efa249(F)((0, $ee6b3436e10e8e67$export$5f584391ee0d99b4));
};
var $69ae994846dd7463$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $69ae994846dd7463$export$5fd5031fecdacec3(as)), $69ae994846dd7463$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(bs, $69ae994846dd7463$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $69ae994846dd7463$export$f9380c9a627682d3 = $54ef96f182e81a75$export$5fd5031fecdacec3;
var $69ae994846dd7463$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $69ae994846dd7463$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $69ae994846dd7463$export$e759a9a7f8d04692 = function() {
    return {
        concat: $69ae994846dd7463$export$ee1b3e54f0441b22
    };
};
var $69ae994846dd7463$export$804fed467fde44e4 = function(E) {
    return (0, $f591655db7bad68b$export$fec6acd8d60e8568)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $69ae994846dd7463$export$baca17b4aff42f82 = function(E) {
    var unionE = $69ae994846dd7463$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $69ae994846dd7463$export$bd5b6bfc5fa2ee61 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map
};
var $69ae994846dd7463$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($69ae994846dd7463$export$bd5b6bfc5fa2ee61);
var $69ae994846dd7463$export$59a71046037e6c20 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    of: $69ae994846dd7463$export$ba255e9e49e00608
};
var $69ae994846dd7463$export$9fdffe0fe1e91cad = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    mapWithIndex: $69ae994846dd7463$var$_mapWithIndex
};
var $69ae994846dd7463$export$efc21ddc6aeb363d = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    ap: $69ae994846dd7463$var$_ap
};
var $69ae994846dd7463$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($69ae994846dd7463$export$efc21ddc6aeb363d);
var $69ae994846dd7463$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($69ae994846dd7463$export$efc21ddc6aeb363d);
var $69ae994846dd7463$export$1279d2b7807629fd = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    ap: $69ae994846dd7463$var$_ap,
    of: $69ae994846dd7463$export$ba255e9e49e00608
};
var $69ae994846dd7463$export$f18d5acc27d70423 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    ap: $69ae994846dd7463$var$_ap,
    chain: $69ae994846dd7463$export$5b8affa63fc6df16
};
var $69ae994846dd7463$export$e3821ef4970c339c = /*#__PURE__*/ (0, $b00b894e7b37435b$export$e3821ef4970c339c)($69ae994846dd7463$export$f18d5acc27d70423);
var $69ae994846dd7463$export$fb641926d034ac7d = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    ap: $69ae994846dd7463$var$_ap,
    of: $69ae994846dd7463$export$ba255e9e49e00608,
    chain: $69ae994846dd7463$export$5b8affa63fc6df16
};
var $69ae994846dd7463$export$41404b31838667c9 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    reduce: $69ae994846dd7463$var$_reduce,
    foldMap: $69ae994846dd7463$var$_foldMap,
    reduceRight: $69ae994846dd7463$var$_reduceRight
};
var $69ae994846dd7463$export$e8f7d17aaff345cb = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    reduce: $69ae994846dd7463$var$_reduce,
    foldMap: $69ae994846dd7463$var$_foldMap,
    reduceRight: $69ae994846dd7463$var$_reduceRight,
    reduceWithIndex: $69ae994846dd7463$var$_reduceWithIndex,
    foldMapWithIndex: $69ae994846dd7463$var$_foldMapWithIndex,
    reduceRightWithIndex: $69ae994846dd7463$var$_reduceRightWithIndex
};
var $69ae994846dd7463$export$a0202666c3bda011 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    reduce: $69ae994846dd7463$var$_reduce,
    foldMap: $69ae994846dd7463$var$_foldMap,
    reduceRight: $69ae994846dd7463$var$_reduceRight,
    traverse: $69ae994846dd7463$var$_traverse,
    sequence: $69ae994846dd7463$export$49bb65c2ea163039
};
var $69ae994846dd7463$export$bd7b528d8c36ec41 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    mapWithIndex: $69ae994846dd7463$var$_mapWithIndex,
    reduce: $69ae994846dd7463$var$_reduce,
    foldMap: $69ae994846dd7463$var$_foldMap,
    reduceRight: $69ae994846dd7463$var$_reduceRight,
    traverse: $69ae994846dd7463$var$_traverse,
    sequence: $69ae994846dd7463$export$49bb65c2ea163039,
    reduceWithIndex: $69ae994846dd7463$var$_reduceWithIndex,
    foldMapWithIndex: $69ae994846dd7463$var$_foldMapWithIndex,
    reduceRightWithIndex: $69ae994846dd7463$var$_reduceRightWithIndex,
    traverseWithIndex: $69ae994846dd7463$var$_traverseWithIndex
};
var $69ae994846dd7463$export$25ba4469a069167 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    alt: $69ae994846dd7463$var$_alt
};
var $69ae994846dd7463$export$fdd73124b9f1de36 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    map: $69ae994846dd7463$var$_map,
    extend: $69ae994846dd7463$var$_extend,
    extract: $69ae994846dd7463$export$f9380c9a627682d3
};
var $69ae994846dd7463$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $69ae994846dd7463$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $69ae994846dd7463$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($69ae994846dd7463$export$bd5b6bfc5fa2ee61);
var $69ae994846dd7463$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($69ae994846dd7463$export$bd5b6bfc5fa2ee61);
var $69ae994846dd7463$export$2385a24977818dd0 = /*#__PURE__*/ (0, $b00b894e7b37435b$export$2385a24977818dd0)($69ae994846dd7463$export$f18d5acc27d70423);
var $69ae994846dd7463$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($69ae994846dd7463$export$efc21ddc6aeb363d);
var $69ae994846dd7463$export$5fd5031fecdacec3 = $69ae994846dd7463$export$f9380c9a627682d3;
var $69ae994846dd7463$export$c01875f616615628 = $54ef96f182e81a75$export$c01875f616615628;
var $69ae994846dd7463$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $69ae994846dd7463$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $69ae994846dd7463$export$96ec731ed4dcb222 = function(O) {
    var S = $1e8be413a8f63f69$export$96ec731ed4dcb222(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $69ae994846dd7463$export$8960430cfd85939f = function(O) {
    var S = $1e8be413a8f63f69$export$8960430cfd85939f(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $69ae994846dd7463$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $69ae994846dd7463$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($69ae994846dd7463$export$5fd5031fecdacec3(as), $69ae994846dd7463$export$c01875f616615628(as));
    };
};
var $69ae994846dd7463$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($69ae994846dd7463$export$2cd8252107eb640b(as), $69ae994846dd7463$export$4c7897fafd92b108(as));
    };
};
var $69ae994846dd7463$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $69ae994846dd7463$var$__spreadArray([
            f($69ae994846dd7463$export$5fd5031fecdacec3(as))
        ], $69ae994846dd7463$export$c01875f616615628(as), true);
    };
};
var $69ae994846dd7463$export$20ca6ad9f7762931 = function(a) {
    return $69ae994846dd7463$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $69ae994846dd7463$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)($69ae994846dd7463$export$2cd8252107eb640b(as), $69ae994846dd7463$export$10d8903dec122b9d(f($69ae994846dd7463$export$4c7897fafd92b108(as))));
    };
};
var $69ae994846dd7463$export$d3affa0a0a83d946 = function(a) {
    return $69ae994846dd7463$export$302ad361c463800a(function() {
        return a;
    });
};
var $69ae994846dd7463$export$739ec22334c44788 = function(S) {
    var concatAllS = $69ae994846dd7463$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($69ae994846dd7463$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $69ae994846dd7463$export$e08e3b67e392101e = $69ae994846dd7463$export$5b8affa63fc6df16;
function $69ae994846dd7463$export$103ce2c0a67e4e61(O) {
    var sortO = $69ae994846dd7463$export$97db5808d8f88186(O);
    var groupO = $69ae994846dd7463$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $69ae994846dd7463$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $69ae994846dd7463$export$6e22c362a0406a2c;
    };
}
function $69ae994846dd7463$export$3dea766d36a8935f(predicate) {
    return $69ae994846dd7463$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $69ae994846dd7463$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $69ae994846dd7463$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $69ae994846dd7463$export$b446f6baa3bb1430 = $69ae994846dd7463$export$c04edabe9c8d994f;
var $69ae994846dd7463$export$712962e076096ed4 = $69ae994846dd7463$export$89a97afc72a83708;
function $69ae994846dd7463$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $69ae994846dd7463$export$68159836694e22c1(head) : (0, $ee6b3436e10e8e67$export$a4627e546088548d)(tail, $69ae994846dd7463$export$68159836694e22c1(head));
}
var $69ae994846dd7463$export$c40cf5aab899f397 = function(init, end) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(init, $69ae994846dd7463$export$ee1b3e54f0441b22([
        end
    ]));
};
var $69ae994846dd7463$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$f4863e1822a1860c(i, a, as));
    };
};
var $69ae994846dd7463$export$baeb00bf1e27e233 = $69ae994846dd7463$export$849c7567cbd62acc;
var $69ae994846dd7463$export$93e2b83da34ff82a = $69ae994846dd7463$export$b314777ae20abca9;
var $69ae994846dd7463$export$3c6c57333e3dca24 = {
    URI: $69ae994846dd7463$export$9156e739aa33e19f,
    of: $69ae994846dd7463$export$ba255e9e49e00608,
    map: $69ae994846dd7463$var$_map,
    mapWithIndex: $69ae994846dd7463$var$_mapWithIndex,
    ap: $69ae994846dd7463$var$_ap,
    chain: $69ae994846dd7463$export$5b8affa63fc6df16,
    extend: $69ae994846dd7463$var$_extend,
    extract: $69ae994846dd7463$export$f9380c9a627682d3,
    reduce: $69ae994846dd7463$var$_reduce,
    foldMap: $69ae994846dd7463$var$_foldMap,
    reduceRight: $69ae994846dd7463$var$_reduceRight,
    traverse: $69ae994846dd7463$var$_traverse,
    sequence: $69ae994846dd7463$export$49bb65c2ea163039,
    reduceWithIndex: $69ae994846dd7463$var$_reduceWithIndex,
    foldMapWithIndex: $69ae994846dd7463$var$_foldMapWithIndex,
    reduceRightWithIndex: $69ae994846dd7463$var$_reduceRightWithIndex,
    traverseWithIndex: $69ae994846dd7463$var$_traverseWithIndex,
    alt: $69ae994846dd7463$var$_alt
};


var $0a41c5a0721a0550$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $0a41c5a0721a0550$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $0a41c5a0721a0550$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $0a41c5a0721a0550$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $0a41c5a0721a0550$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $0a41c5a0721a0550$export$68159836694e22c1 = $0a41c5a0721a0550$export$c4c4d41eab625797;
var $0a41c5a0721a0550$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $0a41c5a0721a0550$var$__spreadArray($0a41c5a0721a0550$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $0a41c5a0721a0550$export$10d8903dec122b9d = $0a41c5a0721a0550$export$19903a1bf1942f6;
var $0a41c5a0721a0550$export$f4863e1822a1860c = function(i, a, as) {
    if ($0a41c5a0721a0550$export$a978c53b4062a525(as)) {
        var xs = $0a41c5a0721a0550$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $0a41c5a0721a0550$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $0a41c5a0721a0550$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $0a41c5a0721a0550$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $0a41c5a0721a0550$export$784d13d8ee351f07(as);
        var out = [
            $0a41c5a0721a0550$export$5fd5031fecdacec3(as)
        ];
        var rest = $0a41c5a0721a0550$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $0a41c5a0721a0550$export$b035e44d7bb4278f = function(ords) {
    if ($0a41c5a0721a0550$export$a978c53b4062a525(ords)) {
        var M = (0, $b73550eda84ebfbf$export$c2a7ef2cc9b32b31)();
        return $0a41c5a0721a0550$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $0a41c5a0721a0550$export$784d13d8ee351f07;
};
var $0a41c5a0721a0550$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $0a41c5a0721a0550$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $ee6b3436e10e8e67$export$a4627e546088548d)(first, $0a41c5a0721a0550$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $0a41c5a0721a0550$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($0a41c5a0721a0550$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $0a41c5a0721a0550$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $0a41c5a0721a0550$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(s, $0a41c5a0721a0550$export$ee1b3e54f0441b22(f));
        } else return $0a41c5a0721a0550$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $0a41c5a0721a0550$export$7e77326b0f0e268c = $54ef96f182e81a75$export$7e77326b0f0e268c;
var $0a41c5a0721a0550$export$571d59b505e6bb4e = function(as) {
    return $0a41c5a0721a0550$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd(as) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $0a41c5a0721a0550$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $0a41c5a0721a0550$export$606959e7ccb797f0 = function(a) {
    return $0a41c5a0721a0550$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $0a41c5a0721a0550$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $0a41c5a0721a0550$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $0a41c5a0721a0550$export$c04edabe9c8d994f = function(as) {
    return [
        $0a41c5a0721a0550$export$5fd5031fecdacec3(as),
        $0a41c5a0721a0550$export$c01875f616615628(as)
    ];
};
var $0a41c5a0721a0550$export$89a97afc72a83708 = function(as) {
    return [
        $0a41c5a0721a0550$export$2cd8252107eb640b(as),
        $0a41c5a0721a0550$export$4c7897fafd92b108(as)
    ];
};
function $0a41c5a0721a0550$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $0a41c5a0721a0550$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $0a41c5a0721a0550$export$66c1ae025e96b4bc = function(as) {
    return $0a41c5a0721a0550$var$__spreadArray([
        $0a41c5a0721a0550$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $0a41c5a0721a0550$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $0a41c5a0721a0550$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $0a41c5a0721a0550$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $0a41c5a0721a0550$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($0a41c5a0721a0550$export$f4863e1822a1860c(i, a, as));
    };
};
var $0a41c5a0721a0550$export$b6d8713d53419d4c = function(i, a) {
    return $0a41c5a0721a0550$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $0a41c5a0721a0550$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $0a41c5a0721a0550$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($0a41c5a0721a0550$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $0a41c5a0721a0550$export$784d13d8ee351f07 = $0a41c5a0721a0550$export$7e77326b0f0e268c;
var $0a41c5a0721a0550$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $0a41c5a0721a0550$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $0a41c5a0721a0550$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $0a41c5a0721a0550$export$8901015135f2fb22(bs, as);
    };
    return $0a41c5a0721a0550$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $0a41c5a0721a0550$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $0a41c5a0721a0550$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $0a41c5a0721a0550$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $0a41c5a0721a0550$export$c01875f616615628(as);
        return $0a41c5a0721a0550$export$a978c53b4062a525(rest) ? (0, $ee6b3436e10e8e67$export$a4627e546088548d)(rest, $0a41c5a0721a0550$export$849c7567cbd62acc(middle), $0a41c5a0721a0550$export$68159836694e22c1($0a41c5a0721a0550$export$5fd5031fecdacec3(as))) : $0a41c5a0721a0550$export$784d13d8ee351f07(as);
    };
};
var $0a41c5a0721a0550$export$18153bb1181268e5 = $69ae994846dd7463$export$18153bb1181268e5;
var $0a41c5a0721a0550$export$b66cdc0497d8a99a = $69ae994846dd7463$export$b66cdc0497d8a99a;
var $0a41c5a0721a0550$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $0a41c5a0721a0550$export$7e77326b0f0e268c(f(0, $0a41c5a0721a0550$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $0a41c5a0721a0550$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($0a41c5a0721a0550$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $0a41c5a0721a0550$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $0a41c5a0721a0550$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as.slice(1, m), $0a41c5a0721a0550$export$68159836694e22c1($0a41c5a0721a0550$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $0a41c5a0721a0550$export$2f0184d5df52135f = function(n) {
    return $0a41c5a0721a0550$export$433fe05b12ba833f($0a41c5a0721a0550$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_mapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $0a41c5a0721a0550$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_extend = function(wa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(wa, $0a41c5a0721a0550$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_foldMap = function(M) {
    var foldMapM = $0a41c5a0721a0550$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_traverse = function(F) {
    var traverseF = $0a41c5a0721a0550$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $0a41c5a0721a0550$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $0a41c5a0721a0550$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $0a41c5a0721a0550$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $0a41c5a0721a0550$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $0a41c5a0721a0550$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $0a41c5a0721a0550$export$c8c959650bbe80e2(that()));
    };
};
var $0a41c5a0721a0550$export$228be17d80722ab = $0a41c5a0721a0550$export$1517cca7889d6aaa;
var $0a41c5a0721a0550$export$2f6ca3d3b1f80bf5 = function(as) {
    return $0a41c5a0721a0550$export$5b8affa63fc6df16(function(f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $0a41c5a0721a0550$export$871de8747c9eaa88(f));
    });
};
var $0a41c5a0721a0550$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ma, $0a41c5a0721a0550$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $0a41c5a0721a0550$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $0a41c5a0721a0550$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($0a41c5a0721a0550$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $0a41c5a0721a0550$export$c01875f616615628(next);
        }
        return out;
    };
};
var $0a41c5a0721a0550$export$ecd5e8ace626722c = /*#__PURE__*/ $0a41c5a0721a0550$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $0a41c5a0721a0550$export$bffa455ba8c619a6 = /*#__PURE__*/ $0a41c5a0721a0550$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $0a41c5a0721a0550$export$871de8747c9eaa88 = function(f) {
    return $0a41c5a0721a0550$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $0a41c5a0721a0550$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $0a41c5a0721a0550$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $0a41c5a0721a0550$export$533b26079ad0b4b = $69ae994846dd7463$export$533b26079ad0b4b;
var $0a41c5a0721a0550$export$bbd3ef8720e22369 = $69ae994846dd7463$export$bbd3ef8720e22369;
var $0a41c5a0721a0550$export$7fef8bcdbb34f435 = $69ae994846dd7463$export$7fef8bcdbb34f435;
var $0a41c5a0721a0550$export$ce2b2fe0b88ccd0a = $69ae994846dd7463$export$ce2b2fe0b88ccd0a;
var $0a41c5a0721a0550$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $0a41c5a0721a0550$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $0a41c5a0721a0550$export$49bb65c2ea163039 = function(F) {
    return $0a41c5a0721a0550$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $0a41c5a0721a0550$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $0a41c5a0721a0550$export$5fd5031fecdacec3(as)), $0a41c5a0721a0550$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(bs, $0a41c5a0721a0550$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $0a41c5a0721a0550$export$f9380c9a627682d3 = $69ae994846dd7463$export$5fd5031fecdacec3;
var $0a41c5a0721a0550$export$9156e739aa33e19f = 'NonEmptyArray';
var $0a41c5a0721a0550$export$3cb5cd7f7776c81 = $69ae994846dd7463$export$3cb5cd7f7776c81;
var $0a41c5a0721a0550$export$e759a9a7f8d04692 = function() {
    return {
        concat: $0a41c5a0721a0550$export$ee1b3e54f0441b22
    };
};
var $0a41c5a0721a0550$export$804fed467fde44e4 = $69ae994846dd7463$export$804fed467fde44e4;
var $0a41c5a0721a0550$export$baca17b4aff42f82 = function(E) {
    var unionE = $0a41c5a0721a0550$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $0a41c5a0721a0550$export$bd5b6bfc5fa2ee61 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map
};
var $0a41c5a0721a0550$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($0a41c5a0721a0550$export$bd5b6bfc5fa2ee61);
var $0a41c5a0721a0550$export$59a71046037e6c20 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    of: $0a41c5a0721a0550$export$ba255e9e49e00608
};
var $0a41c5a0721a0550$export$9fdffe0fe1e91cad = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    mapWithIndex: $0a41c5a0721a0550$var$_mapWithIndex
};
var $0a41c5a0721a0550$export$efc21ddc6aeb363d = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    ap: $0a41c5a0721a0550$var$_ap
};
var $0a41c5a0721a0550$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($0a41c5a0721a0550$export$efc21ddc6aeb363d);
var $0a41c5a0721a0550$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($0a41c5a0721a0550$export$efc21ddc6aeb363d);
var $0a41c5a0721a0550$export$1279d2b7807629fd = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    ap: $0a41c5a0721a0550$var$_ap,
    of: $0a41c5a0721a0550$export$ba255e9e49e00608
};
var $0a41c5a0721a0550$export$f18d5acc27d70423 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    ap: $0a41c5a0721a0550$var$_ap,
    chain: $0a41c5a0721a0550$export$5b8affa63fc6df16
};
var $0a41c5a0721a0550$export$e3821ef4970c339c = /*#__PURE__*/ (0, $b00b894e7b37435b$export$e3821ef4970c339c)($0a41c5a0721a0550$export$f18d5acc27d70423);
var $0a41c5a0721a0550$export$fb641926d034ac7d = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    ap: $0a41c5a0721a0550$var$_ap,
    of: $0a41c5a0721a0550$export$ba255e9e49e00608,
    chain: $0a41c5a0721a0550$export$5b8affa63fc6df16
};
var $0a41c5a0721a0550$export$41404b31838667c9 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    reduce: $0a41c5a0721a0550$var$_reduce,
    foldMap: $0a41c5a0721a0550$var$_foldMap,
    reduceRight: $0a41c5a0721a0550$var$_reduceRight
};
var $0a41c5a0721a0550$export$e8f7d17aaff345cb = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    reduce: $0a41c5a0721a0550$var$_reduce,
    foldMap: $0a41c5a0721a0550$var$_foldMap,
    reduceRight: $0a41c5a0721a0550$var$_reduceRight,
    reduceWithIndex: $0a41c5a0721a0550$var$_reduceWithIndex,
    foldMapWithIndex: $0a41c5a0721a0550$var$_foldMapWithIndex,
    reduceRightWithIndex: $0a41c5a0721a0550$var$_reduceRightWithIndex
};
var $0a41c5a0721a0550$export$a0202666c3bda011 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    reduce: $0a41c5a0721a0550$var$_reduce,
    foldMap: $0a41c5a0721a0550$var$_foldMap,
    reduceRight: $0a41c5a0721a0550$var$_reduceRight,
    traverse: $0a41c5a0721a0550$var$_traverse,
    sequence: $0a41c5a0721a0550$export$49bb65c2ea163039
};
var $0a41c5a0721a0550$export$bd7b528d8c36ec41 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    mapWithIndex: $0a41c5a0721a0550$var$_mapWithIndex,
    reduce: $0a41c5a0721a0550$var$_reduce,
    foldMap: $0a41c5a0721a0550$var$_foldMap,
    reduceRight: $0a41c5a0721a0550$var$_reduceRight,
    traverse: $0a41c5a0721a0550$var$_traverse,
    sequence: $0a41c5a0721a0550$export$49bb65c2ea163039,
    reduceWithIndex: $0a41c5a0721a0550$var$_reduceWithIndex,
    foldMapWithIndex: $0a41c5a0721a0550$var$_foldMapWithIndex,
    reduceRightWithIndex: $0a41c5a0721a0550$var$_reduceRightWithIndex,
    traverseWithIndex: $0a41c5a0721a0550$var$_traverseWithIndex
};
var $0a41c5a0721a0550$export$25ba4469a069167 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    alt: $0a41c5a0721a0550$var$_alt
};
var $0a41c5a0721a0550$export$fdd73124b9f1de36 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    map: $0a41c5a0721a0550$var$_map,
    extend: $0a41c5a0721a0550$var$_extend,
    extract: $0a41c5a0721a0550$export$f9380c9a627682d3
};
var $0a41c5a0721a0550$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $0a41c5a0721a0550$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $0a41c5a0721a0550$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($0a41c5a0721a0550$export$bd5b6bfc5fa2ee61);
var $0a41c5a0721a0550$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($0a41c5a0721a0550$export$bd5b6bfc5fa2ee61);
var $0a41c5a0721a0550$export$2385a24977818dd0 = /*#__PURE__*/ (0, $b00b894e7b37435b$export$2385a24977818dd0)($0a41c5a0721a0550$export$f18d5acc27d70423);
var $0a41c5a0721a0550$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($0a41c5a0721a0550$export$efc21ddc6aeb363d);
var $0a41c5a0721a0550$export$5fd5031fecdacec3 = $69ae994846dd7463$export$5fd5031fecdacec3;
var $0a41c5a0721a0550$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $0a41c5a0721a0550$export$4c7897fafd92b108 = $69ae994846dd7463$export$4c7897fafd92b108;
var $0a41c5a0721a0550$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $0a41c5a0721a0550$export$96ec731ed4dcb222 = $69ae994846dd7463$export$96ec731ed4dcb222;
var $0a41c5a0721a0550$export$8960430cfd85939f = $69ae994846dd7463$export$8960430cfd85939f;
var $0a41c5a0721a0550$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $0a41c5a0721a0550$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($0a41c5a0721a0550$export$5fd5031fecdacec3(as), $0a41c5a0721a0550$export$c01875f616615628(as));
    };
};
var $0a41c5a0721a0550$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($0a41c5a0721a0550$export$2cd8252107eb640b(as), $0a41c5a0721a0550$export$4c7897fafd92b108(as));
    };
};
var $0a41c5a0721a0550$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $0a41c5a0721a0550$var$__spreadArray([
            f($0a41c5a0721a0550$export$5fd5031fecdacec3(as))
        ], $0a41c5a0721a0550$export$c01875f616615628(as), true);
    };
};
var $0a41c5a0721a0550$export$20ca6ad9f7762931 = function(a) {
    return $0a41c5a0721a0550$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $0a41c5a0721a0550$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)($0a41c5a0721a0550$export$2cd8252107eb640b(as), $0a41c5a0721a0550$export$10d8903dec122b9d(f($0a41c5a0721a0550$export$4c7897fafd92b108(as))));
    };
};
var $0a41c5a0721a0550$export$d3affa0a0a83d946 = function(a) {
    return $0a41c5a0721a0550$export$302ad361c463800a(function() {
        return a;
    });
};
var $0a41c5a0721a0550$export$739ec22334c44788 = $69ae994846dd7463$export$739ec22334c44788;
var $0a41c5a0721a0550$export$e08e3b67e392101e = $0a41c5a0721a0550$export$5b8affa63fc6df16;
function $0a41c5a0721a0550$export$103ce2c0a67e4e61(O) {
    var sortO = $0a41c5a0721a0550$export$97db5808d8f88186(O);
    var groupO = $0a41c5a0721a0550$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $0a41c5a0721a0550$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $0a41c5a0721a0550$export$3dea766d36a8935f(predicate) {
    return $0a41c5a0721a0550$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $0a41c5a0721a0550$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $0a41c5a0721a0550$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $0a41c5a0721a0550$export$b446f6baa3bb1430 = $0a41c5a0721a0550$export$c04edabe9c8d994f;
var $0a41c5a0721a0550$export$712962e076096ed4 = $0a41c5a0721a0550$export$89a97afc72a83708;
function $0a41c5a0721a0550$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $0a41c5a0721a0550$export$68159836694e22c1(head) : (0, $ee6b3436e10e8e67$export$a4627e546088548d)(tail, $0a41c5a0721a0550$export$68159836694e22c1(head));
}
var $0a41c5a0721a0550$export$c40cf5aab899f397 = function(init, end) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(init, $0a41c5a0721a0550$export$10d8903dec122b9d(end));
};
var $0a41c5a0721a0550$export$baeb00bf1e27e233 = $0a41c5a0721a0550$export$849c7567cbd62acc;
var $0a41c5a0721a0550$export$93e2b83da34ff82a = $69ae994846dd7463$export$b314777ae20abca9;
var $0a41c5a0721a0550$export$a5383a53b408af94 = {
    URI: $0a41c5a0721a0550$export$9156e739aa33e19f,
    of: $0a41c5a0721a0550$export$ba255e9e49e00608,
    map: $0a41c5a0721a0550$var$_map,
    mapWithIndex: $0a41c5a0721a0550$var$_mapWithIndex,
    ap: $0a41c5a0721a0550$var$_ap,
    chain: $0a41c5a0721a0550$export$5b8affa63fc6df16,
    extend: $0a41c5a0721a0550$var$_extend,
    extract: $0a41c5a0721a0550$export$f9380c9a627682d3,
    reduce: $0a41c5a0721a0550$var$_reduce,
    foldMap: $0a41c5a0721a0550$var$_foldMap,
    reduceRight: $0a41c5a0721a0550$var$_reduceRight,
    traverse: $0a41c5a0721a0550$var$_traverse,
    sequence: $0a41c5a0721a0550$export$49bb65c2ea163039,
    reduceWithIndex: $0a41c5a0721a0550$var$_reduceWithIndex,
    foldMapWithIndex: $0a41c5a0721a0550$var$_foldMapWithIndex,
    reduceRightWithIndex: $0a41c5a0721a0550$var$_reduceRightWithIndex,
    traverseWithIndex: $0a41c5a0721a0550$var$_traverseWithIndex,
    alt: $0a41c5a0721a0550$var$_alt
};









// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $9f1b5e003fd5ed07$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $9f1b5e003fd5ed07$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $9f1b5e003fd5ed07$export$ee8aa95bfab51c5 = {
    equals: $9f1b5e003fd5ed07$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $9f1b5e003fd5ed07$export$88f31472ebc405c8 = {
    equals: $9f1b5e003fd5ed07$export$a2050e5b0c4dcf10.equals,
    compare: $9f1b5e003fd5ed07$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $9f1b5e003fd5ed07$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $9f1b5e003fd5ed07$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $9f1b5e003fd5ed07$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $9f1b5e003fd5ed07$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $9f1b5e003fd5ed07$export$2517c0450e71e789 = {
    concat: $9f1b5e003fd5ed07$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $9f1b5e003fd5ed07$export$ee1a63590489b690 = {
    concat: $9f1b5e003fd5ed07$export$5b0bccec79556292.concat,
    empty: 1
};
var $9f1b5e003fd5ed07$export$a455218a85c89869 = {
    add: $9f1b5e003fd5ed07$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $9f1b5e003fd5ed07$export$5b0bccec79556292.concat,
    one: 1,
    sub: $9f1b5e003fd5ed07$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};




/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 

var $4ddd06d7371e8509$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $4ddd06d7371e8509$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $4ddd06d7371e8509$export$871de8747c9eaa88(f));
};
var $4ddd06d7371e8509$var$_mapLeft = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $4ddd06d7371e8509$export$472de43a55e4aa49(f));
};
var $4ddd06d7371e8509$var$_bimap = function(fa, g, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $4ddd06d7371e8509$export$eb54baf0b342cb1d(g, f));
};
var $4ddd06d7371e8509$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $4ddd06d7371e8509$export$beaabdf62f4a639d($4ddd06d7371e8509$export$eabcd2c8791e7bf4(fa), f($4ddd06d7371e8509$export$79ffe56a765070d2(fa)));
    };
};
var $4ddd06d7371e8509$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $4ddd06d7371e8509$export$beaabdf62f4a639d(f($4ddd06d7371e8509$export$eabcd2c8791e7bf4(fa)), $4ddd06d7371e8509$export$79ffe56a765070d2(fa));
    };
};
var $4ddd06d7371e8509$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $4ddd06d7371e8509$export$beaabdf62f4a639d(f($4ddd06d7371e8509$export$eabcd2c8791e7bf4(fa)), g($4ddd06d7371e8509$export$79ffe56a765070d2(fa)));
    };
};
var $4ddd06d7371e8509$export$9156e739aa33e19f = 'Separated';
var $4ddd06d7371e8509$export$fd0fe42029639505 = {
    URI: $4ddd06d7371e8509$export$9156e739aa33e19f,
    mapLeft: $4ddd06d7371e8509$var$_mapLeft,
    bimap: $4ddd06d7371e8509$var$_bimap
};
var $4ddd06d7371e8509$export$bd5b6bfc5fa2ee61 = {
    URI: $4ddd06d7371e8509$export$9156e739aa33e19f,
    map: $4ddd06d7371e8509$var$_map
};
var $4ddd06d7371e8509$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($4ddd06d7371e8509$export$bd5b6bfc5fa2ee61);
var $4ddd06d7371e8509$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $4ddd06d7371e8509$export$79ffe56a765070d2 = function(s) {
    return s.right;
};



function $b333f781e2a19138$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $b333f781e2a19138$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $b333f781e2a19138$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $54ef96f182e81a75$export$ad14ef4001db2bcd(a) : $54ef96f182e81a75$export$f883a24d5edde77c;
                    });
                });
            };
        };
    };
}


function $5dbed21a6458819e$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}


var $6ec673d1158159b2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6ec673d1158159b2$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $6ec673d1158159b2$export$a978c53b4062a525 = $69ae994846dd7463$export$a978c53b4062a525;
var $6ec673d1158159b2$export$68159836694e22c1 = $69ae994846dd7463$export$68159836694e22c1;
var $6ec673d1158159b2$export$c4c4d41eab625797 = $69ae994846dd7463$export$c4c4d41eab625797;
var $6ec673d1158159b2$export$10d8903dec122b9d = $69ae994846dd7463$export$10d8903dec122b9d;
var $6ec673d1158159b2$export$19903a1bf1942f6 = $69ae994846dd7463$export$19903a1bf1942f6;
var $6ec673d1158159b2$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $6ec673d1158159b2$export$6e22c362a0406a2c : $69ae994846dd7463$export$849fbdcc2211fcde(f)(n);
};
var $6ec673d1158159b2$export$606959e7ccb797f0 = function(n, a) {
    return $6ec673d1158159b2$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $6ec673d1158159b2$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $6ec673d1158159b2$export$6e22c362a0406a2c;
    };
}
var $6ec673d1158159b2$export$172ec0a6ebfeb6fa = function(ma) {
    return $54ef96f182e81a75$export$e56af863d5645d5f(ma) ? $6ec673d1158159b2$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $6ec673d1158159b2$export$80c878c9b1d77917 = function(e) {
    return $54ef96f182e81a75$export$d649b6842e09f2b(e) ? $6ec673d1158159b2$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $6ec673d1158159b2$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $6ec673d1158159b2$export$4659b591c19bdf3d = $6ec673d1158159b2$export$2d55ea551c238330;
var $6ec673d1158159b2$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? onNonEmpty($69ae994846dd7463$export$5fd5031fecdacec3(as), $69ae994846dd7463$export$c01875f616615628(as)) : onEmpty();
    };
};
var $6ec673d1158159b2$export$6280271dfaec4919 = $6ec673d1158159b2$export$ebbe93aa91e3abdc;
var $6ec673d1158159b2$export$f3163a37d0ef5927 = $6ec673d1158159b2$export$6280271dfaec4919;
var $6ec673d1158159b2$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? onNonEmpty($69ae994846dd7463$export$2cd8252107eb640b(as), $69ae994846dd7463$export$4c7897fafd92b108(as)) : onEmpty();
    };
};
var $6ec673d1158159b2$export$b1cacb83a5c6bd02 = $6ec673d1158159b2$export$364f7f2cc8473008;
var $6ec673d1158159b2$export$77fa89c00b331c4c = $6ec673d1158159b2$export$b1cacb83a5c6bd02;
var $6ec673d1158159b2$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($6ec673d1158159b2$export$dd1bc94b04021eeb(as)) return $6ec673d1158159b2$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $6ec673d1158159b2$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $6ec673d1158159b2$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $6ec673d1158159b2$export$346677f925de839c = function(as) {
    return as.length;
};
var $6ec673d1158159b2$export$2fde0b1c54fc39b9 = $69ae994846dd7463$export$2fde0b1c54fc39b9;
function $6ec673d1158159b2$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $6ec673d1158159b2$export$dfc7155ac0343b8(i, as);
    } : $6ec673d1158159b2$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd(as[i]);
}
var $6ec673d1158159b2$export$5fd5031fecdacec3 = function(as) {
    return $6ec673d1158159b2$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$5fd5031fecdacec3(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $6ec673d1158159b2$export$4c7897fafd92b108 = function(as) {
    return $6ec673d1158159b2$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$4c7897fafd92b108(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $6ec673d1158159b2$export$c01875f616615628 = function(as) {
    return $6ec673d1158159b2$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$c01875f616615628(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $6ec673d1158159b2$export$2cd8252107eb640b = function(as) {
    return $6ec673d1158159b2$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$2cd8252107eb640b(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $6ec673d1158159b2$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $6ec673d1158159b2$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $6ec673d1158159b2$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $6ec673d1158159b2$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $6ec673d1158159b2$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $6ec673d1158159b2$export$6e22c362a0406a2c : out;
    };
}
var $6ec673d1158159b2$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $6ec673d1158159b2$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $6ec673d1158159b2$export$b0d75975ac0be0e1($6ec673d1158159b2$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $6ec673d1158159b2$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $6ec673d1158159b2$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $6ec673d1158159b2$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $6ec673d1158159b2$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $6ec673d1158159b2$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $6ec673d1158159b2$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $6ec673d1158159b2$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $54ef96f182e81a75$export$ad14ef4001db2bcd(i);
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
};
function $6ec673d1158159b2$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $54ef96f182e81a75$export$ad14ef4001db2bcd(as[i]);
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
}
var $6ec673d1158159b2$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($54ef96f182e81a75$export$5d7e502287836e58(out)) return out;
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
};
function $6ec673d1158159b2$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $54ef96f182e81a75$export$ad14ef4001db2bcd(as[i]);
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
}
var $6ec673d1158159b2$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($54ef96f182e81a75$export$5d7e502287836e58(out)) return out;
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
};
var $6ec673d1158159b2$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $54ef96f182e81a75$export$ad14ef4001db2bcd(i);
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
};
var $6ec673d1158159b2$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($69ae994846dd7463$export$f4863e1822a1860c(i, a, as));
    };
};
var $6ec673d1158159b2$export$b6d8713d53419d4c = function(i, a) {
    return $6ec673d1158159b2$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $6ec673d1158159b2$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $6ec673d1158159b2$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($6ec673d1158159b2$export$4937fde8dfc38dbd(i, as));
    };
};
var $6ec673d1158159b2$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $6ec673d1158159b2$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($6ec673d1158159b2$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $6ec673d1158159b2$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $6ec673d1158159b2$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $6ec673d1158159b2$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $6ec673d1158159b2$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $6ec673d1158159b2$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $6ec673d1158159b2$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $6ec673d1158159b2$export$8901015135f2fb22(bs, as);
    };
    return $6ec673d1158159b2$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $6ec673d1158159b2$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $6ec673d1158159b2$export$849c7567cbd62acc = function(middle) {
    var f = $69ae994846dd7463$export$849c7567cbd62acc(middle);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $6ec673d1158159b2$export$af200dcf8b7cb5de = function(middle) {
    var f = $69ae994846dd7463$export$af200dcf8b7cb5de(middle);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $6ec673d1158159b2$export$bb628a54ab399bc9 = function(n) {
    var f = $69ae994846dd7463$export$bb628a54ab399bc9(n);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $6ec673d1158159b2$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $6ec673d1158159b2$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $6ec673d1158159b2$export$f70730c3d1fc524e = function(E) {
    var f = $69ae994846dd7463$export$f70730c3d1fc524e(E);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $6ec673d1158159b2$export$b035e44d7bb4278f = function(ords) {
    var f = $69ae994846dd7463$export$b035e44d7bb4278f(ords);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $6ec673d1158159b2$export$433fe05b12ba833f = function(f) {
    var g = $69ae994846dd7463$export$433fe05b12ba833f(f);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? g(as) : $6ec673d1158159b2$export$6e22c362a0406a2c;
    };
};
var $6ec673d1158159b2$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $6ec673d1158159b2$export$a978c53b4062a525(as) ? $69ae994846dd7463$export$b0d75975ac0be0e1(n)(as) : $6ec673d1158159b2$export$dd1bc94b04021eeb(as) ? [
            as,
            $6ec673d1158159b2$export$6e22c362a0406a2c
        ] : [
            $6ec673d1158159b2$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $6ec673d1158159b2$export$2f0184d5df52135f = function(n) {
    var f = $69ae994846dd7463$export$2f0184d5df52135f(n);
    return function(as) {
        return $6ec673d1158159b2$export$a978c53b4062a525(as) ? f(as) : $6ec673d1158159b2$export$6e22c362a0406a2c;
    };
};
var $6ec673d1158159b2$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $6ec673d1158159b2$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $6ec673d1158159b2$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $6ec673d1158159b2$export$a978c53b4062a525(input) ? $6ec673d1158159b2$export$5b8affa63fc6df16($69ae994846dd7463$export$5fd5031fecdacec3(input), function(a) {
            return go((0, $ee6b3436e10e8e67$export$a4627e546088548d)(scope, $6ec673d1158159b2$export$10d8903dec122b9d(a)), $69ae994846dd7463$export$c01875f616615628(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $6ec673d1158159b2$export$6e22c362a0406a2c;
    };
    return go($6ec673d1158159b2$export$6e22c362a0406a2c, input);
}
var $6ec673d1158159b2$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $6ec673d1158159b2$export$dd1bc94b04021eeb(first) ? second : $6ec673d1158159b2$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $6ec673d1158159b2$export$ee1b3e54f0441b22 = $6ec673d1158159b2$export$c8c959650bbe80e2;
function $6ec673d1158159b2$export$971dd5b0dfd021b6(E) {
    var unionE = $69ae994846dd7463$export$971dd5b0dfd021b6(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $6ec673d1158159b2$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $6ec673d1158159b2$export$a978c53b4062a525(first) && $6ec673d1158159b2$export$a978c53b4062a525(second) ? unionE(second)(first) : $6ec673d1158159b2$export$a978c53b4062a525(first) ? first : second;
    };
}
function $6ec673d1158159b2$export$bc86dfbf7795668c(E) {
    var elemE = $6ec673d1158159b2$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $6ec673d1158159b2$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $6ec673d1158159b2$export$acaf96a27438246b(E) {
    var elemE = $6ec673d1158159b2$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $6ec673d1158159b2$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $6ec673d1158159b2$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$871de8747c9eaa88(f));
};
var $6ec673d1158159b2$var$_mapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$8f07ddce13659f50(f));
};
var $6ec673d1158159b2$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $6ec673d1158159b2$export$2f6ca3d3b1f80bf5(fa));
};
var $6ec673d1158159b2$var$_filter = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$3dea766d36a8935f(predicate));
};
var $6ec673d1158159b2$var$_filterMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$a04c6c6965dd4709(f));
};
var $6ec673d1158159b2$var$_partition = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$b29f828819edca8d(predicate));
};
var $6ec673d1158159b2$var$_partitionMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$3117e3f9ececb6bc(f));
};
var $6ec673d1158159b2$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $6ec673d1158159b2$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$bc7c0794b9c6f3ba(f));
};
var $6ec673d1158159b2$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$228be17d80722ab(that));
};
var $6ec673d1158159b2$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$533b26079ad0b4b(b, f));
};
var $6ec673d1158159b2$var$_foldMap = function(M) {
    var foldMapM = $6ec673d1158159b2$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
var $6ec673d1158159b2$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$7fef8bcdbb34f435(b, f));
};
var $6ec673d1158159b2$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$bbd3ef8720e22369(b, f));
};
var $6ec673d1158159b2$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $6ec673d1158159b2$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
var $6ec673d1158159b2$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$ce2b2fe0b88ccd0a(b, f));
};
var $6ec673d1158159b2$var$_filterMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$30c5cbe848021e97(f));
};
var $6ec673d1158159b2$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$36e42aef19fc7171(predicateWithIndex));
};
var $6ec673d1158159b2$var$_extend = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$8b58be045bf06082(f));
};
var $6ec673d1158159b2$var$_traverse = function(F) {
    var traverseF = $6ec673d1158159b2$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $6ec673d1158159b2$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $6ec673d1158159b2$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $6ec673d1158159b2$export$c5c44f872d8af73 = function(a, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(a, $6ec673d1158159b2$export$f855115a79f70c1a(f));
};
var $6ec673d1158159b2$export$b9909b62ceeab991 = function(a, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(a, $6ec673d1158159b2$export$bffee57bb00a6859(f));
};
var $6ec673d1158159b2$export$ba255e9e49e00608 = $69ae994846dd7463$export$ba255e9e49e00608;
var $6ec673d1158159b2$export$7f9972325ebfd559 = function() {
    return $6ec673d1158159b2$export$6e22c362a0406a2c;
};
var $6ec673d1158159b2$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $6ec673d1158159b2$export$228be17d80722ab = $6ec673d1158159b2$export$1517cca7889d6aaa;
var $6ec673d1158159b2$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $6ec673d1158159b2$export$5b8affa63fc6df16(function(f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $6ec673d1158159b2$export$871de8747c9eaa88(f));
    });
};
var $6ec673d1158159b2$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ma, $6ec673d1158159b2$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $6ec673d1158159b2$export$bffa455ba8c619a6 = /*#__PURE__*/ $6ec673d1158159b2$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $6ec673d1158159b2$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $6ec673d1158159b2$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $6ec673d1158159b2$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
};
var $6ec673d1158159b2$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $6ec673d1158159b2$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($54ef96f182e81a75$export$5d7e502287836e58(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $6ec673d1158159b2$export$a04c6c6965dd4709 = function(f) {
    return $6ec673d1158159b2$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $6ec673d1158159b2$export$8e16b83750b44988 = /*#__PURE__*/ $6ec673d1158159b2$export$a04c6c6965dd4709((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $6ec673d1158159b2$export$b29f828819edca8d = function(predicate) {
    return $6ec673d1158159b2$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $6ec673d1158159b2$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
};
var $6ec673d1158159b2$export$3117e3f9ececb6bc = function(f) {
    return $6ec673d1158159b2$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $6ec673d1158159b2$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
};
var $6ec673d1158159b2$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $6ec673d1158159b2$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $6ec673d1158159b2$export$ecd5e8ace626722c = /*#__PURE__*/ $6ec673d1158159b2$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $6ec673d1158159b2$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $6ec673d1158159b2$export$533b26079ad0b4b = function(b, f) {
    return $6ec673d1158159b2$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $6ec673d1158159b2$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $6ec673d1158159b2$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $6ec673d1158159b2$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $6ec673d1158159b2$export$7fef8bcdbb34f435 = function(b, f) {
    return $6ec673d1158159b2$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $6ec673d1158159b2$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $6ec673d1158159b2$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $6ec673d1158159b2$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $6ec673d1158159b2$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $6ec673d1158159b2$var$_reduce(ta, F.of($6ec673d1158159b2$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $6ec673d1158159b2$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $6ec673d1158159b2$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $6ec673d1158159b2$export$bbd3ef8720e22369(F.of($6ec673d1158159b2$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(bs, $6ec673d1158159b2$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $6ec673d1158159b2$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $6ec673d1158159b2$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $6ec673d1158159b2$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $6ec673d1158159b2$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $6ec673d1158159b2$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($54ef96f182e81a75$export$5d7e502287836e58(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $6ec673d1158159b2$export$9156e739aa33e19f = 'ReadonlyArray';
var $6ec673d1158159b2$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $6ec673d1158159b2$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $6ec673d1158159b2$export$dd1bc94b04021eeb(first) ? second : $6ec673d1158159b2$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $6ec673d1158159b2$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $6ec673d1158159b2$export$e759a9a7f8d04692().concat,
        empty: $6ec673d1158159b2$export$6e22c362a0406a2c
    };
};
var $6ec673d1158159b2$export$804fed467fde44e4 = function(E) {
    return (0, $f591655db7bad68b$export$fec6acd8d60e8568)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $6ec673d1158159b2$export$1af51209b1b91d07 = function(O) {
    return (0, $b73550eda84ebfbf$export$aa9e0de96ff2f1fd)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $9f1b5e003fd5ed07$export$ee8aa95bfab51c5.compare(aLen, bLen);
    });
};
var $6ec673d1158159b2$export$baca17b4aff42f82 = function(E) {
    var unionE = $6ec673d1158159b2$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $6ec673d1158159b2$export$c487aac9f4157837 = function(E) {
    return {
        concat: $6ec673d1158159b2$export$baca17b4aff42f82(E).concat,
        empty: $6ec673d1158159b2$export$6e22c362a0406a2c
    };
};
var $6ec673d1158159b2$export$d379a869a72e4055 = function(E) {
    var intersectionE = $6ec673d1158159b2$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $6ec673d1158159b2$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $6ec673d1158159b2$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $6ec673d1158159b2$export$bd5b6bfc5fa2ee61 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map
};
var $6ec673d1158159b2$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($6ec673d1158159b2$export$bd5b6bfc5fa2ee61);
var $6ec673d1158159b2$export$59a71046037e6c20 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    of: $6ec673d1158159b2$export$ba255e9e49e00608
};
var $6ec673d1158159b2$export$9fdffe0fe1e91cad = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    mapWithIndex: $6ec673d1158159b2$var$_mapWithIndex
};
var $6ec673d1158159b2$export$efc21ddc6aeb363d = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap
};
var $6ec673d1158159b2$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($6ec673d1158159b2$export$efc21ddc6aeb363d);
var $6ec673d1158159b2$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($6ec673d1158159b2$export$efc21ddc6aeb363d);
var $6ec673d1158159b2$export$1279d2b7807629fd = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    of: $6ec673d1158159b2$export$ba255e9e49e00608
};
var $6ec673d1158159b2$export$f18d5acc27d70423 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    chain: $6ec673d1158159b2$export$5b8affa63fc6df16
};
var $6ec673d1158159b2$export$fb641926d034ac7d = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    of: $6ec673d1158159b2$export$ba255e9e49e00608,
    chain: $6ec673d1158159b2$export$5b8affa63fc6df16
};
var $6ec673d1158159b2$export$e3821ef4970c339c = /*#__PURE__*/ (0, $b00b894e7b37435b$export$e3821ef4970c339c)($6ec673d1158159b2$export$f18d5acc27d70423);
var $6ec673d1158159b2$export$8fa953f00d3b093 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    unfold: $6ec673d1158159b2$export$c48e357c1a89b78d
};
var $6ec673d1158159b2$export$25ba4469a069167 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    alt: $6ec673d1158159b2$var$_alt
};
var $6ec673d1158159b2$export$aaef8a3eae948f03 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    zero: $6ec673d1158159b2$export$7f9972325ebfd559
};
var $6ec673d1158159b2$export$864d727b48066337 = /*#__PURE__*/ (0, $5dbed21a6458819e$export$864d727b48066337)($6ec673d1158159b2$export$aaef8a3eae948f03, $6ec673d1158159b2$export$59a71046037e6c20);
var $6ec673d1158159b2$export$4acb47accde578d2 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    of: $6ec673d1158159b2$export$ba255e9e49e00608,
    alt: $6ec673d1158159b2$var$_alt,
    zero: $6ec673d1158159b2$export$7f9972325ebfd559
};
var $6ec673d1158159b2$export$5b5dd0e212d2a5bc = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    extend: $6ec673d1158159b2$var$_extend
};
var $6ec673d1158159b2$export$4a21ac48141ac3c9 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    compact: $6ec673d1158159b2$export$8e16b83750b44988,
    separate: $6ec673d1158159b2$export$709f6946f4e97408
};
var $6ec673d1158159b2$export$d00e1c48fb621173 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    compact: $6ec673d1158159b2$export$8e16b83750b44988,
    separate: $6ec673d1158159b2$export$709f6946f4e97408,
    filter: $6ec673d1158159b2$var$_filter,
    filterMap: $6ec673d1158159b2$var$_filterMap,
    partition: $6ec673d1158159b2$var$_partition,
    partitionMap: $6ec673d1158159b2$var$_partitionMap
};
var $6ec673d1158159b2$export$c29a647071e542ec = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    mapWithIndex: $6ec673d1158159b2$var$_mapWithIndex,
    compact: $6ec673d1158159b2$export$8e16b83750b44988,
    separate: $6ec673d1158159b2$export$709f6946f4e97408,
    filter: $6ec673d1158159b2$var$_filter,
    filterMap: $6ec673d1158159b2$var$_filterMap,
    partition: $6ec673d1158159b2$var$_partition,
    partitionMap: $6ec673d1158159b2$var$_partitionMap,
    partitionMapWithIndex: $6ec673d1158159b2$var$_partitionMapWithIndex,
    partitionWithIndex: $6ec673d1158159b2$var$_partitionWithIndex,
    filterMapWithIndex: $6ec673d1158159b2$var$_filterMapWithIndex,
    filterWithIndex: $6ec673d1158159b2$var$_filterWithIndex
};
var $6ec673d1158159b2$export$41404b31838667c9 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight
};
var $6ec673d1158159b2$export$e8f7d17aaff345cb = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight,
    reduceWithIndex: $6ec673d1158159b2$var$_reduceWithIndex,
    foldMapWithIndex: $6ec673d1158159b2$var$_foldMapWithIndex,
    reduceRightWithIndex: $6ec673d1158159b2$var$_reduceRightWithIndex
};
var $6ec673d1158159b2$export$a0202666c3bda011 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight,
    traverse: $6ec673d1158159b2$var$_traverse,
    sequence: $6ec673d1158159b2$export$49bb65c2ea163039
};
var $6ec673d1158159b2$export$bd7b528d8c36ec41 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    mapWithIndex: $6ec673d1158159b2$var$_mapWithIndex,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight,
    reduceWithIndex: $6ec673d1158159b2$var$_reduceWithIndex,
    foldMapWithIndex: $6ec673d1158159b2$var$_foldMapWithIndex,
    reduceRightWithIndex: $6ec673d1158159b2$var$_reduceRightWithIndex,
    traverse: $6ec673d1158159b2$var$_traverse,
    sequence: $6ec673d1158159b2$export$49bb65c2ea163039,
    traverseWithIndex: $6ec673d1158159b2$var$_traverseWithIndex
};
var $6ec673d1158159b2$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $6ec673d1158159b2$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($54ef96f182e81a75$export$d649b6842e09f2b(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $6ec673d1158159b2$export$7d808dfaa6d54634 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    chain: $6ec673d1158159b2$export$5b8affa63fc6df16,
    chainRec: $6ec673d1158159b2$export$c5c44f872d8af73
};
var $6ec673d1158159b2$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($54ef96f182e81a75$export$d649b6842e09f2b(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $6ec673d1158159b2$export$57f3a385c7e59628 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    chain: $6ec673d1158159b2$export$5b8affa63fc6df16,
    chainRec: $6ec673d1158159b2$export$b9909b62ceeab991
};
var $6ec673d1158159b2$var$_wither = /*#__PURE__*/ (0, $b333f781e2a19138$export$1f5c6f948d11a182)($6ec673d1158159b2$export$a0202666c3bda011, $6ec673d1158159b2$export$4a21ac48141ac3c9);
var $6ec673d1158159b2$var$_wilt = /*#__PURE__*/ (0, $b333f781e2a19138$export$f4cb42390e44d1d2)($6ec673d1158159b2$export$a0202666c3bda011, $6ec673d1158159b2$export$4a21ac48141ac3c9);
var $6ec673d1158159b2$export$748d317b4c426f96 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    map: $6ec673d1158159b2$var$_map,
    compact: $6ec673d1158159b2$export$8e16b83750b44988,
    separate: $6ec673d1158159b2$export$709f6946f4e97408,
    filter: $6ec673d1158159b2$var$_filter,
    filterMap: $6ec673d1158159b2$var$_filterMap,
    partition: $6ec673d1158159b2$var$_partition,
    partitionMap: $6ec673d1158159b2$var$_partitionMap,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight,
    traverse: $6ec673d1158159b2$var$_traverse,
    sequence: $6ec673d1158159b2$export$49bb65c2ea163039,
    wither: $6ec673d1158159b2$var$_wither,
    wilt: $6ec673d1158159b2$var$_wilt
};
var $6ec673d1158159b2$export$c40604f35db61519 = /*#__PURE__*/ (0, $b333f781e2a19138$export$c40604f35db61519)($6ec673d1158159b2$export$748d317b4c426f96);
var $6ec673d1158159b2$export$825ea6cb6fc48d49 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    fromEither: $6ec673d1158159b2$export$80c878c9b1d77917
};
var $6ec673d1158159b2$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $1f0befb2747eca52$export$8138b0ae92c9b5d8)($6ec673d1158159b2$export$825ea6cb6fc48d49);
var $6ec673d1158159b2$export$f4863e1822a1860c = $69ae994846dd7463$export$f4863e1822a1860c;
var $6ec673d1158159b2$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $6ec673d1158159b2$export$a978c53b4062a525(as) ? $69ae994846dd7463$export$9c0c6889b1fa9bfc(i, a, as) : as;
};
var $6ec673d1158159b2$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $6ec673d1158159b2$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $6ec673d1158159b2$export$571d59b505e6bb4e = function(as) {
    return $6ec673d1158159b2$export$dd1bc94b04021eeb(as) ? $6ec673d1158159b2$export$6e22c362a0406a2c : as.slice();
};
var $6ec673d1158159b2$export$6e22c362a0406a2c = $69ae994846dd7463$export$6e22c362a0406a2c;
function $6ec673d1158159b2$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $6ec673d1158159b2$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $6ec673d1158159b2$export$f7e9f41ea797a17 = $6ec673d1158159b2$export$ad14ef4001db2bcd;
var $6ec673d1158159b2$export$739ec22334c44788 = function(M) {
    var intercalateM = $69ae994846dd7463$export$739ec22334c44788(M);
    return function(middle) {
        return $6ec673d1158159b2$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $6ec673d1158159b2$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $6ec673d1158159b2$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $6ec673d1158159b2$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($6ec673d1158159b2$export$bd5b6bfc5fa2ee61);
var $6ec673d1158159b2$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($6ec673d1158159b2$export$bd5b6bfc5fa2ee61);
var $6ec673d1158159b2$export$2385a24977818dd0 = /*#__PURE__*/ (0, $b00b894e7b37435b$export$2385a24977818dd0)($6ec673d1158159b2$export$f18d5acc27d70423);
var $6ec673d1158159b2$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($6ec673d1158159b2$export$efc21ddc6aeb363d);
var $6ec673d1158159b2$export$e08e3b67e392101e = $6ec673d1158159b2$export$5b8affa63fc6df16;
var $6ec673d1158159b2$export$d02631cccf789723 = $69ae994846dd7463$export$d02631cccf789723;
var $6ec673d1158159b2$export$8327ebbef2a0ba76 = $69ae994846dd7463$export$8327ebbef2a0ba76;
var $6ec673d1158159b2$export$c40cf5aab899f397 = $69ae994846dd7463$export$c40cf5aab899f397;
var $6ec673d1158159b2$export$baeb00bf1e27e233 = $6ec673d1158159b2$export$849c7567cbd62acc;
var $6ec673d1158159b2$export$95ca155af9fd5713 = {
    URI: $6ec673d1158159b2$export$9156e739aa33e19f,
    compact: $6ec673d1158159b2$export$8e16b83750b44988,
    separate: $6ec673d1158159b2$export$709f6946f4e97408,
    map: $6ec673d1158159b2$var$_map,
    ap: $6ec673d1158159b2$var$_ap,
    of: $6ec673d1158159b2$export$ba255e9e49e00608,
    chain: $6ec673d1158159b2$export$5b8affa63fc6df16,
    filter: $6ec673d1158159b2$var$_filter,
    filterMap: $6ec673d1158159b2$var$_filterMap,
    partition: $6ec673d1158159b2$var$_partition,
    partitionMap: $6ec673d1158159b2$var$_partitionMap,
    mapWithIndex: $6ec673d1158159b2$var$_mapWithIndex,
    partitionMapWithIndex: $6ec673d1158159b2$var$_partitionMapWithIndex,
    partitionWithIndex: $6ec673d1158159b2$var$_partitionWithIndex,
    filterMapWithIndex: $6ec673d1158159b2$var$_filterMapWithIndex,
    filterWithIndex: $6ec673d1158159b2$var$_filterWithIndex,
    alt: $6ec673d1158159b2$var$_alt,
    zero: $6ec673d1158159b2$export$7f9972325ebfd559,
    unfold: $6ec673d1158159b2$export$c48e357c1a89b78d,
    reduce: $6ec673d1158159b2$var$_reduce,
    foldMap: $6ec673d1158159b2$var$_foldMap,
    reduceRight: $6ec673d1158159b2$var$_reduceRight,
    traverse: $6ec673d1158159b2$var$_traverse,
    sequence: $6ec673d1158159b2$export$49bb65c2ea163039,
    reduceWithIndex: $6ec673d1158159b2$var$_reduceWithIndex,
    foldMapWithIndex: $6ec673d1158159b2$var$_foldMapWithIndex,
    reduceRightWithIndex: $6ec673d1158159b2$var$_reduceRightWithIndex,
    traverseWithIndex: $6ec673d1158159b2$var$_traverseWithIndex,
    extend: $6ec673d1158159b2$var$_extend,
    wither: $6ec673d1158159b2$var$_wither,
    wilt: $6ec673d1158159b2$var$_wilt
};





var $c4094a3bee7a2fc6$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $c4094a3bee7a2fc6$export$a978c53b4062a525 = $0a41c5a0721a0550$export$a978c53b4062a525;
var $c4094a3bee7a2fc6$export$68159836694e22c1 = $0a41c5a0721a0550$export$68159836694e22c1;
var $c4094a3bee7a2fc6$export$c4c4d41eab625797 = $0a41c5a0721a0550$export$c4c4d41eab625797;
var $c4094a3bee7a2fc6$export$10d8903dec122b9d = $0a41c5a0721a0550$export$10d8903dec122b9d;
var $c4094a3bee7a2fc6$export$19903a1bf1942f6 = $0a41c5a0721a0550$export$19903a1bf1942f6;
var $c4094a3bee7a2fc6$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $0a41c5a0721a0550$export$849fbdcc2211fcde(f)(n);
};
var $c4094a3bee7a2fc6$export$606959e7ccb797f0 = function(n, a) {
    return $c4094a3bee7a2fc6$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $c4094a3bee7a2fc6$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $c4094a3bee7a2fc6$export$172ec0a6ebfeb6fa = function(ma) {
    return $54ef96f182e81a75$export$e56af863d5645d5f(ma) ? [] : [
        ma.value
    ];
};
var $c4094a3bee7a2fc6$export$80c878c9b1d77917 = function(e) {
    return $54ef96f182e81a75$export$d649b6842e09f2b(e) ? [] : [
        e.right
    ];
};
var $c4094a3bee7a2fc6$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $c4094a3bee7a2fc6$export$4659b591c19bdf3d = $c4094a3bee7a2fc6$export$2d55ea551c238330;
var $c4094a3bee7a2fc6$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? onNonEmpty($0a41c5a0721a0550$export$5fd5031fecdacec3(as), $0a41c5a0721a0550$export$c01875f616615628(as)) : onEmpty();
    };
};
var $c4094a3bee7a2fc6$export$6280271dfaec4919 = $c4094a3bee7a2fc6$export$ebbe93aa91e3abdc;
var $c4094a3bee7a2fc6$export$f3163a37d0ef5927 = $c4094a3bee7a2fc6$export$6280271dfaec4919;
var $c4094a3bee7a2fc6$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? onNonEmpty($0a41c5a0721a0550$export$2cd8252107eb640b(as), $0a41c5a0721a0550$export$4c7897fafd92b108(as)) : onEmpty();
    };
};
var $c4094a3bee7a2fc6$export$b1cacb83a5c6bd02 = $c4094a3bee7a2fc6$export$364f7f2cc8473008;
var $c4094a3bee7a2fc6$export$77fa89c00b331c4c = $c4094a3bee7a2fc6$export$b1cacb83a5c6bd02;
var $c4094a3bee7a2fc6$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $c4094a3bee7a2fc6$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $c4094a3bee7a2fc6$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $c4094a3bee7a2fc6$export$346677f925de839c = function(as) {
    return as.length;
};
var $c4094a3bee7a2fc6$export$2fde0b1c54fc39b9 = $0a41c5a0721a0550$export$2fde0b1c54fc39b9;
var $c4094a3bee7a2fc6$export$dfc7155ac0343b8 = $6ec673d1158159b2$export$dfc7155ac0343b8;
var $c4094a3bee7a2fc6$export$5fd5031fecdacec3 = $6ec673d1158159b2$export$5fd5031fecdacec3;
var $c4094a3bee7a2fc6$export$4c7897fafd92b108 = $6ec673d1158159b2$export$4c7897fafd92b108;
var $c4094a3bee7a2fc6$export$c01875f616615628 = function(as) {
    return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($0a41c5a0721a0550$export$c01875f616615628(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $c4094a3bee7a2fc6$export$2cd8252107eb640b = function(as) {
    return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? $54ef96f182e81a75$export$ad14ef4001db2bcd($0a41c5a0721a0550$export$2cd8252107eb640b(as)) : $54ef96f182e81a75$export$f883a24d5edde77c;
};
var $c4094a3bee7a2fc6$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$2fde0b1c54fc39b9(n, as) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $c4094a3bee7a2fc6$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$2fde0b1c54fc39b9(n, as) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $c4094a3bee7a2fc6$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $c4094a3bee7a2fc6$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $c4094a3bee7a2fc6$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $c4094a3bee7a2fc6$export$b0d75975ac0be0e1($c4094a3bee7a2fc6$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $c4094a3bee7a2fc6$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(as) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $c4094a3bee7a2fc6$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(as) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $c4094a3bee7a2fc6$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($c4094a3bee7a2fc6$var$spanLeftIndex(as, predicate));
    };
}
var $c4094a3bee7a2fc6$export$de3a4d4a0d731119 = $6ec673d1158159b2$export$de3a4d4a0d731119;
function $c4094a3bee7a2fc6$export$9a2f228bed5035c2(predicate) {
    return $6ec673d1158159b2$export$9a2f228bed5035c2(predicate);
}
var $c4094a3bee7a2fc6$export$a86c11c94d794a95 = $6ec673d1158159b2$export$a86c11c94d794a95;
function $c4094a3bee7a2fc6$export$296de88ccac4bedb(predicate) {
    return $6ec673d1158159b2$export$296de88ccac4bedb(predicate);
}
var $c4094a3bee7a2fc6$export$8b5e6d6ad82284fa = $6ec673d1158159b2$export$8b5e6d6ad82284fa;
var $c4094a3bee7a2fc6$export$8855a8be7bd3e9f8 = $6ec673d1158159b2$export$8855a8be7bd3e9f8;
var $c4094a3bee7a2fc6$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $c4094a3bee7a2fc6$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($c4094a3bee7a2fc6$export$f4863e1822a1860c(i, a, as));
    };
};
var $c4094a3bee7a2fc6$export$b6d8713d53419d4c = function(i, a) {
    return $c4094a3bee7a2fc6$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $c4094a3bee7a2fc6$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($c4094a3bee7a2fc6$export$4937fde8dfc38dbd(i, as));
    };
};
var $c4094a3bee7a2fc6$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $c4094a3bee7a2fc6$export$2fde0b1c54fc39b9(i, as) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd($c4094a3bee7a2fc6$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $c4094a3bee7a2fc6$export$66c1ae025e96b4bc = function(as) {
    return $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $c4094a3bee7a2fc6$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $c4094a3bee7a2fc6$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $c4094a3bee7a2fc6$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $c4094a3bee7a2fc6$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $c4094a3bee7a2fc6$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $c4094a3bee7a2fc6$export$8901015135f2fb22(bs, as);
    };
    return $c4094a3bee7a2fc6$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $c4094a3bee7a2fc6$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $c4094a3bee7a2fc6$export$849c7567cbd62acc = function(middle) {
    var f = $0a41c5a0721a0550$export$849c7567cbd62acc(middle);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $c4094a3bee7a2fc6$export$af200dcf8b7cb5de = function(middle) {
    var f = $0a41c5a0721a0550$export$af200dcf8b7cb5de(middle);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : $c4094a3bee7a2fc6$export$784d13d8ee351f07(as);
    };
};
var $c4094a3bee7a2fc6$export$bb628a54ab399bc9 = function(n) {
    var f = $0a41c5a0721a0550$export$bb628a54ab399bc9(n);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : $c4094a3bee7a2fc6$export$784d13d8ee351f07(as);
    };
};
var $c4094a3bee7a2fc6$export$5bf96401662340b7 = $6ec673d1158159b2$export$5bf96401662340b7;
var $c4094a3bee7a2fc6$export$f70730c3d1fc524e = function(E) {
    var f = $0a41c5a0721a0550$export$f70730c3d1fc524e(E);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : $c4094a3bee7a2fc6$export$784d13d8ee351f07(as);
    };
};
var $c4094a3bee7a2fc6$export$b035e44d7bb4278f = function(ords) {
    var f = $0a41c5a0721a0550$export$b035e44d7bb4278f(ords);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : $c4094a3bee7a2fc6$export$784d13d8ee351f07(as);
    };
};
var $c4094a3bee7a2fc6$export$433fe05b12ba833f = function(f) {
    var g = $0a41c5a0721a0550$export$433fe05b12ba833f(f);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $c4094a3bee7a2fc6$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? $0a41c5a0721a0550$export$b0d75975ac0be0e1(n)(as) : $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(as) ? [
            $c4094a3bee7a2fc6$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $c4094a3bee7a2fc6$export$784d13d8ee351f07(as)
        ];
    };
};
var $c4094a3bee7a2fc6$export$2f0184d5df52135f = function(n) {
    var f = $0a41c5a0721a0550$export$2f0184d5df52135f(n);
    return function(as) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $c4094a3bee7a2fc6$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $c4094a3bee7a2fc6$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $c4094a3bee7a2fc6$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(input) ? $c4094a3bee7a2fc6$export$5b8affa63fc6df16($0a41c5a0721a0550$export$5fd5031fecdacec3(input), function(a) {
            return go((0, $ee6b3436e10e8e67$export$a4627e546088548d)(scope, $c4094a3bee7a2fc6$export$10d8903dec122b9d(a)), $0a41c5a0721a0550$export$c01875f616615628(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $c4094a3bee7a2fc6$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(first) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(second) : $c4094a3bee7a2fc6$export$dd1bc94b04021eeb(second) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $c4094a3bee7a2fc6$export$ee1b3e54f0441b22 = $c4094a3bee7a2fc6$export$c8c959650bbe80e2;
function $c4094a3bee7a2fc6$export$971dd5b0dfd021b6(E) {
    var unionE = $0a41c5a0721a0550$export$971dd5b0dfd021b6(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $c4094a3bee7a2fc6$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $c4094a3bee7a2fc6$export$a978c53b4062a525(first) && $c4094a3bee7a2fc6$export$a978c53b4062a525(second) ? unionE(second)(first) : $c4094a3bee7a2fc6$export$a978c53b4062a525(first) ? $c4094a3bee7a2fc6$export$784d13d8ee351f07(first) : $c4094a3bee7a2fc6$export$784d13d8ee351f07(second);
    };
}
function $c4094a3bee7a2fc6$export$bc86dfbf7795668c(E) {
    var elemE = $c4094a3bee7a2fc6$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $c4094a3bee7a2fc6$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $c4094a3bee7a2fc6$export$acaf96a27438246b(E) {
    var elemE = $c4094a3bee7a2fc6$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $c4094a3bee7a2fc6$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $c4094a3bee7a2fc6$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_mapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$8f07ddce13659f50(f));
};
var $c4094a3bee7a2fc6$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $c4094a3bee7a2fc6$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_filter = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_filterMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_partition = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_partitionMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$228be17d80722ab(that));
};
var $c4094a3bee7a2fc6$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_foldMap = function(M) {
    var foldMapM = $c4094a3bee7a2fc6$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $c4094a3bee7a2fc6$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_filterMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_extend = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_traverse = function(F) {
    var traverseF = $c4094a3bee7a2fc6$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $c4094a3bee7a2fc6$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $c4094a3bee7a2fc6$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $c4094a3bee7a2fc6$var$_chainRecDepthFirst = $6ec673d1158159b2$export$c5c44f872d8af73;
var $c4094a3bee7a2fc6$var$_chainRecBreadthFirst = $6ec673d1158159b2$export$b9909b62ceeab991;
var $c4094a3bee7a2fc6$export$ba255e9e49e00608 = $0a41c5a0721a0550$export$ba255e9e49e00608;
var $c4094a3bee7a2fc6$export$7f9972325ebfd559 = function() {
    return [];
};
var $c4094a3bee7a2fc6$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $c4094a3bee7a2fc6$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $c4094a3bee7a2fc6$export$5b8affa63fc6df16(function(f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $c4094a3bee7a2fc6$export$871de8747c9eaa88(f));
    });
};
var $c4094a3bee7a2fc6$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ma, $c4094a3bee7a2fc6$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $c4094a3bee7a2fc6$export$bffa455ba8c619a6 = /*#__PURE__*/ $c4094a3bee7a2fc6$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $c4094a3bee7a2fc6$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $c4094a3bee7a2fc6$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($54ef96f182e81a75$export$5d7e502287836e58(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $c4094a3bee7a2fc6$export$a04c6c6965dd4709 = function(f) {
    return $c4094a3bee7a2fc6$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $c4094a3bee7a2fc6$export$8e16b83750b44988 = /*#__PURE__*/ $c4094a3bee7a2fc6$export$a04c6c6965dd4709((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $c4094a3bee7a2fc6$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
};
var $c4094a3bee7a2fc6$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $c4094a3bee7a2fc6$export$b29f828819edca8d = function(predicate) {
    return $c4094a3bee7a2fc6$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $c4094a3bee7a2fc6$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
};
var $c4094a3bee7a2fc6$export$3117e3f9ececb6bc = function(f) {
    return $c4094a3bee7a2fc6$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $c4094a3bee7a2fc6$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
};
var $c4094a3bee7a2fc6$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $c4094a3bee7a2fc6$export$228be17d80722ab = $c4094a3bee7a2fc6$export$1517cca7889d6aaa;
var $c4094a3bee7a2fc6$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $c4094a3bee7a2fc6$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $c4094a3bee7a2fc6$export$ecd5e8ace626722c = /*#__PURE__*/ $c4094a3bee7a2fc6$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $c4094a3bee7a2fc6$export$b66cdc0497d8a99a = $6ec673d1158159b2$export$b66cdc0497d8a99a;
var $c4094a3bee7a2fc6$export$18153bb1181268e5 = $6ec673d1158159b2$export$18153bb1181268e5;
var $c4094a3bee7a2fc6$export$533b26079ad0b4b = $6ec673d1158159b2$export$533b26079ad0b4b;
var $c4094a3bee7a2fc6$export$bbd3ef8720e22369 = $6ec673d1158159b2$export$bbd3ef8720e22369;
var $c4094a3bee7a2fc6$export$7fef8bcdbb34f435 = $6ec673d1158159b2$export$7fef8bcdbb34f435;
var $c4094a3bee7a2fc6$export$ce2b2fe0b88ccd0a = $6ec673d1158159b2$export$ce2b2fe0b88ccd0a;
var $c4094a3bee7a2fc6$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $c4094a3bee7a2fc6$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $c4094a3bee7a2fc6$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $c4094a3bee7a2fc6$var$_reduce(ta, F.of($c4094a3bee7a2fc6$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(as, $c4094a3bee7a2fc6$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $c4094a3bee7a2fc6$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $c4094a3bee7a2fc6$export$bbd3ef8720e22369(F.of($c4094a3bee7a2fc6$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(bs, $c4094a3bee7a2fc6$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $c4094a3bee7a2fc6$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $c4094a3bee7a2fc6$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $c4094a3bee7a2fc6$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $c4094a3bee7a2fc6$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $c4094a3bee7a2fc6$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($54ef96f182e81a75$export$5d7e502287836e58(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $c4094a3bee7a2fc6$export$9156e739aa33e19f = 'Array';
var $c4094a3bee7a2fc6$export$3cb5cd7f7776c81 = $6ec673d1158159b2$export$3cb5cd7f7776c81;
var $c4094a3bee7a2fc6$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $c4094a3bee7a2fc6$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $c4094a3bee7a2fc6$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $c4094a3bee7a2fc6$export$804fed467fde44e4 = $6ec673d1158159b2$export$804fed467fde44e4;
var $c4094a3bee7a2fc6$export$1af51209b1b91d07 = $6ec673d1158159b2$export$1af51209b1b91d07;
var $c4094a3bee7a2fc6$export$baca17b4aff42f82 = function(E) {
    var unionE = $c4094a3bee7a2fc6$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $c4094a3bee7a2fc6$export$c487aac9f4157837 = function(E) {
    return {
        concat: $c4094a3bee7a2fc6$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $c4094a3bee7a2fc6$export$d379a869a72e4055 = function(E) {
    var intersectionE = $c4094a3bee7a2fc6$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $c4094a3bee7a2fc6$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $c4094a3bee7a2fc6$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $c4094a3bee7a2fc6$export$bd5b6bfc5fa2ee61 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map
};
var $c4094a3bee7a2fc6$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($c4094a3bee7a2fc6$export$bd5b6bfc5fa2ee61);
var $c4094a3bee7a2fc6$export$59a71046037e6c20 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    of: $c4094a3bee7a2fc6$export$ba255e9e49e00608
};
var $c4094a3bee7a2fc6$export$9fdffe0fe1e91cad = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    mapWithIndex: $c4094a3bee7a2fc6$var$_mapWithIndex
};
var $c4094a3bee7a2fc6$export$efc21ddc6aeb363d = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap
};
var $c4094a3bee7a2fc6$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($c4094a3bee7a2fc6$export$efc21ddc6aeb363d);
var $c4094a3bee7a2fc6$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($c4094a3bee7a2fc6$export$efc21ddc6aeb363d);
var $c4094a3bee7a2fc6$export$1279d2b7807629fd = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    of: $c4094a3bee7a2fc6$export$ba255e9e49e00608
};
var $c4094a3bee7a2fc6$export$f18d5acc27d70423 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    chain: $c4094a3bee7a2fc6$export$5b8affa63fc6df16
};
var $c4094a3bee7a2fc6$export$e3821ef4970c339c = /*#__PURE__*/ (0, $b00b894e7b37435b$export$e3821ef4970c339c)($c4094a3bee7a2fc6$export$f18d5acc27d70423);
var $c4094a3bee7a2fc6$export$fb641926d034ac7d = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    of: $c4094a3bee7a2fc6$export$ba255e9e49e00608,
    chain: $c4094a3bee7a2fc6$export$5b8affa63fc6df16
};
var $c4094a3bee7a2fc6$export$8fa953f00d3b093 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    unfold: $c4094a3bee7a2fc6$export$c48e357c1a89b78d
};
var $c4094a3bee7a2fc6$export$25ba4469a069167 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    alt: $c4094a3bee7a2fc6$var$_alt
};
var $c4094a3bee7a2fc6$export$aaef8a3eae948f03 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    zero: $c4094a3bee7a2fc6$export$7f9972325ebfd559
};
var $c4094a3bee7a2fc6$export$864d727b48066337 = /*#__PURE__*/ (0, $5dbed21a6458819e$export$864d727b48066337)($c4094a3bee7a2fc6$export$aaef8a3eae948f03, $c4094a3bee7a2fc6$export$59a71046037e6c20);
var $c4094a3bee7a2fc6$export$4acb47accde578d2 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    of: $c4094a3bee7a2fc6$export$ba255e9e49e00608,
    alt: $c4094a3bee7a2fc6$var$_alt,
    zero: $c4094a3bee7a2fc6$export$7f9972325ebfd559
};
var $c4094a3bee7a2fc6$export$5b5dd0e212d2a5bc = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    extend: $c4094a3bee7a2fc6$var$_extend
};
var $c4094a3bee7a2fc6$export$4a21ac48141ac3c9 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    compact: $c4094a3bee7a2fc6$export$8e16b83750b44988,
    separate: $c4094a3bee7a2fc6$export$709f6946f4e97408
};
var $c4094a3bee7a2fc6$export$d00e1c48fb621173 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    compact: $c4094a3bee7a2fc6$export$8e16b83750b44988,
    separate: $c4094a3bee7a2fc6$export$709f6946f4e97408,
    filter: $c4094a3bee7a2fc6$var$_filter,
    filterMap: $c4094a3bee7a2fc6$var$_filterMap,
    partition: $c4094a3bee7a2fc6$var$_partition,
    partitionMap: $c4094a3bee7a2fc6$var$_partitionMap
};
var $c4094a3bee7a2fc6$export$c29a647071e542ec = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    mapWithIndex: $c4094a3bee7a2fc6$var$_mapWithIndex,
    compact: $c4094a3bee7a2fc6$export$8e16b83750b44988,
    separate: $c4094a3bee7a2fc6$export$709f6946f4e97408,
    filter: $c4094a3bee7a2fc6$var$_filter,
    filterMap: $c4094a3bee7a2fc6$var$_filterMap,
    partition: $c4094a3bee7a2fc6$var$_partition,
    partitionMap: $c4094a3bee7a2fc6$var$_partitionMap,
    partitionMapWithIndex: $c4094a3bee7a2fc6$var$_partitionMapWithIndex,
    partitionWithIndex: $c4094a3bee7a2fc6$var$_partitionWithIndex,
    filterMapWithIndex: $c4094a3bee7a2fc6$var$_filterMapWithIndex,
    filterWithIndex: $c4094a3bee7a2fc6$var$_filterWithIndex
};
var $c4094a3bee7a2fc6$export$41404b31838667c9 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight
};
var $c4094a3bee7a2fc6$export$e8f7d17aaff345cb = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight,
    reduceWithIndex: $c4094a3bee7a2fc6$var$_reduceWithIndex,
    foldMapWithIndex: $c4094a3bee7a2fc6$var$_foldMapWithIndex,
    reduceRightWithIndex: $c4094a3bee7a2fc6$var$_reduceRightWithIndex
};
var $c4094a3bee7a2fc6$export$a0202666c3bda011 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight,
    traverse: $c4094a3bee7a2fc6$var$_traverse,
    sequence: $c4094a3bee7a2fc6$export$49bb65c2ea163039
};
var $c4094a3bee7a2fc6$export$bd7b528d8c36ec41 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    mapWithIndex: $c4094a3bee7a2fc6$var$_mapWithIndex,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight,
    reduceWithIndex: $c4094a3bee7a2fc6$var$_reduceWithIndex,
    foldMapWithIndex: $c4094a3bee7a2fc6$var$_foldMapWithIndex,
    reduceRightWithIndex: $c4094a3bee7a2fc6$var$_reduceRightWithIndex,
    traverse: $c4094a3bee7a2fc6$var$_traverse,
    sequence: $c4094a3bee7a2fc6$export$49bb65c2ea163039,
    traverseWithIndex: $c4094a3bee7a2fc6$var$_traverseWithIndex
};
var $c4094a3bee7a2fc6$var$_wither = /*#__PURE__*/ (0, $b333f781e2a19138$export$1f5c6f948d11a182)($c4094a3bee7a2fc6$export$a0202666c3bda011, $c4094a3bee7a2fc6$export$4a21ac48141ac3c9);
var $c4094a3bee7a2fc6$var$_wilt = /*#__PURE__*/ (0, $b333f781e2a19138$export$f4cb42390e44d1d2)($c4094a3bee7a2fc6$export$a0202666c3bda011, $c4094a3bee7a2fc6$export$4a21ac48141ac3c9);
var $c4094a3bee7a2fc6$export$748d317b4c426f96 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    compact: $c4094a3bee7a2fc6$export$8e16b83750b44988,
    separate: $c4094a3bee7a2fc6$export$709f6946f4e97408,
    filter: $c4094a3bee7a2fc6$var$_filter,
    filterMap: $c4094a3bee7a2fc6$var$_filterMap,
    partition: $c4094a3bee7a2fc6$var$_partition,
    partitionMap: $c4094a3bee7a2fc6$var$_partitionMap,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight,
    traverse: $c4094a3bee7a2fc6$var$_traverse,
    sequence: $c4094a3bee7a2fc6$export$49bb65c2ea163039,
    wither: $c4094a3bee7a2fc6$var$_wither,
    wilt: $c4094a3bee7a2fc6$var$_wilt
};
var $c4094a3bee7a2fc6$export$f855115a79f70c1a = $6ec673d1158159b2$export$f855115a79f70c1a;
var $c4094a3bee7a2fc6$export$7d808dfaa6d54634 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    chain: $c4094a3bee7a2fc6$export$5b8affa63fc6df16,
    chainRec: $c4094a3bee7a2fc6$var$_chainRecDepthFirst
};
var $c4094a3bee7a2fc6$export$bffee57bb00a6859 = $6ec673d1158159b2$export$bffee57bb00a6859;
var $c4094a3bee7a2fc6$export$57f3a385c7e59628 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    chain: $c4094a3bee7a2fc6$export$5b8affa63fc6df16,
    chainRec: $c4094a3bee7a2fc6$var$_chainRecBreadthFirst
};
var $c4094a3bee7a2fc6$export$c40604f35db61519 = /*#__PURE__*/ (0, $b333f781e2a19138$export$c40604f35db61519)($c4094a3bee7a2fc6$export$748d317b4c426f96);
var $c4094a3bee7a2fc6$export$825ea6cb6fc48d49 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    fromEither: $c4094a3bee7a2fc6$export$80c878c9b1d77917
};
var $c4094a3bee7a2fc6$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $1f0befb2747eca52$export$8138b0ae92c9b5d8)($c4094a3bee7a2fc6$export$825ea6cb6fc48d49);
var $c4094a3bee7a2fc6$export$f4863e1822a1860c = $0a41c5a0721a0550$export$f4863e1822a1860c;
var $c4094a3bee7a2fc6$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $c4094a3bee7a2fc6$export$a978c53b4062a525(as) ? $0a41c5a0721a0550$export$9c0c6889b1fa9bfc(i, a, as) : [];
};
var $c4094a3bee7a2fc6$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $c4094a3bee7a2fc6$export$7ecc1a3b11b57dab = $6ec673d1158159b2$export$7ecc1a3b11b57dab;
var $c4094a3bee7a2fc6$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $c4094a3bee7a2fc6$export$f7e9f41ea797a17 = $c4094a3bee7a2fc6$export$ad14ef4001db2bcd;
var $c4094a3bee7a2fc6$export$739ec22334c44788 = $6ec673d1158159b2$export$739ec22334c44788;
var $c4094a3bee7a2fc6$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $c4094a3bee7a2fc6$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $c4094a3bee7a2fc6$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($c4094a3bee7a2fc6$export$bd5b6bfc5fa2ee61);
var $c4094a3bee7a2fc6$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($c4094a3bee7a2fc6$export$bd5b6bfc5fa2ee61);
var $c4094a3bee7a2fc6$export$2385a24977818dd0 = /*#__PURE__*/ (0, $b00b894e7b37435b$export$2385a24977818dd0)($c4094a3bee7a2fc6$export$f18d5acc27d70423);
var $c4094a3bee7a2fc6$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($c4094a3bee7a2fc6$export$efc21ddc6aeb363d);
var $c4094a3bee7a2fc6$export$e08e3b67e392101e = $c4094a3bee7a2fc6$export$5b8affa63fc6df16;
var $c4094a3bee7a2fc6$export$d02631cccf789723 = $0a41c5a0721a0550$export$d02631cccf789723;
var $c4094a3bee7a2fc6$export$6e22c362a0406a2c = [];
var $c4094a3bee7a2fc6$export$8327ebbef2a0ba76 = $0a41c5a0721a0550$export$8327ebbef2a0ba76;
var $c4094a3bee7a2fc6$export$c40cf5aab899f397 = $0a41c5a0721a0550$export$c40cf5aab899f397;
var $c4094a3bee7a2fc6$export$baeb00bf1e27e233 = $c4094a3bee7a2fc6$export$849c7567cbd62acc;
var $c4094a3bee7a2fc6$export$2f23118c22fb2630 = {
    URI: $c4094a3bee7a2fc6$export$9156e739aa33e19f,
    compact: $c4094a3bee7a2fc6$export$8e16b83750b44988,
    separate: $c4094a3bee7a2fc6$export$709f6946f4e97408,
    map: $c4094a3bee7a2fc6$var$_map,
    ap: $c4094a3bee7a2fc6$var$_ap,
    of: $c4094a3bee7a2fc6$export$ba255e9e49e00608,
    chain: $c4094a3bee7a2fc6$export$5b8affa63fc6df16,
    filter: $c4094a3bee7a2fc6$var$_filter,
    filterMap: $c4094a3bee7a2fc6$var$_filterMap,
    partition: $c4094a3bee7a2fc6$var$_partition,
    partitionMap: $c4094a3bee7a2fc6$var$_partitionMap,
    mapWithIndex: $c4094a3bee7a2fc6$var$_mapWithIndex,
    partitionMapWithIndex: $c4094a3bee7a2fc6$var$_partitionMapWithIndex,
    partitionWithIndex: $c4094a3bee7a2fc6$var$_partitionWithIndex,
    filterMapWithIndex: $c4094a3bee7a2fc6$var$_filterMapWithIndex,
    filterWithIndex: $c4094a3bee7a2fc6$var$_filterWithIndex,
    alt: $c4094a3bee7a2fc6$var$_alt,
    zero: $c4094a3bee7a2fc6$export$7f9972325ebfd559,
    unfold: $c4094a3bee7a2fc6$export$c48e357c1a89b78d,
    reduce: $c4094a3bee7a2fc6$var$_reduce,
    foldMap: $c4094a3bee7a2fc6$var$_foldMap,
    reduceRight: $c4094a3bee7a2fc6$var$_reduceRight,
    traverse: $c4094a3bee7a2fc6$var$_traverse,
    sequence: $c4094a3bee7a2fc6$export$49bb65c2ea163039,
    reduceWithIndex: $c4094a3bee7a2fc6$var$_reduceWithIndex,
    foldMapWithIndex: $c4094a3bee7a2fc6$var$_foldMapWithIndex,
    reduceRightWithIndex: $c4094a3bee7a2fc6$var$_reduceRightWithIndex,
    traverseWithIndex: $c4094a3bee7a2fc6$var$_traverseWithIndex,
    extend: $c4094a3bee7a2fc6$var$_extend,
    wither: $c4094a3bee7a2fc6$var$_wither,
    wilt: $c4094a3bee7a2fc6$var$_wilt
};




var $44c3c1cb7d4112e4$export$dd44f18ab656f3bb = (0, $ee6b3436e10e8e67$export$401372c57776dc);
function $44c3c1cb7d4112e4$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $44c3c1cb7d4112e4$export$804fed467fde44e4 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$1af51209b1b91d07 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$c55397fc301c5a = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$e759a9a7f8d04692 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$c2a7ef2cc9b32b31 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$3d48c7fefc7b8ec2 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$575097c1c561f76f = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$2e73cb3f0f25ed55 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
var $44c3c1cb7d4112e4$export$f37f1abb2c955577 = (0, $ee6b3436e10e8e67$export$f0954fd7d5368655);
function $44c3c1cb7d4112e4$export$81090df2aa47ff12(S) {
    return {
        URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
        _E: undefined,
        map: $44c3c1cb7d4112e4$var$_map,
        ap: function(fab, fa) {
            return $44c3c1cb7d4112e4$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $44c3c1cb7d4112e4$export$1402880adb2295a7(M) {
    var A = $44c3c1cb7d4112e4$export$81090df2aa47ff12(M);
    return {
        URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $44c3c1cb7d4112e4$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $44c3c1cb7d4112e4$var$_contramap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $44c3c1cb7d4112e4$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $44c3c1cb7d4112e4$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $44c3c1cb7d4112e4$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $44c3c1cb7d4112e4$var$_bimap = function(fa, f, g) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $44c3c1cb7d4112e4$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $44c3c1cb7d4112e4$var$_mapLeft = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $44c3c1cb7d4112e4$export$472de43a55e4aa49(f));
};
var $44c3c1cb7d4112e4$export$53b696d27ecb7ba7 = function() {
    return 0, $ee6b3436e10e8e67$export$401372c57776dc;
};
var $44c3c1cb7d4112e4$export$871de8747c9eaa88 = function() {
    return 0, $ee6b3436e10e8e67$export$401372c57776dc;
};
var $44c3c1cb7d4112e4$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $44c3c1cb7d4112e4$export$dd44f18ab656f3bb(f(fa));
    };
};
var $44c3c1cb7d4112e4$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $44c3c1cb7d4112e4$export$dd44f18ab656f3bb(f(fa));
    };
};
var $44c3c1cb7d4112e4$export$9156e739aa33e19f = 'Const';
var $44c3c1cb7d4112e4$export$bd5b6bfc5fa2ee61 = {
    URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
    map: $44c3c1cb7d4112e4$var$_map
};
var $44c3c1cb7d4112e4$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($44c3c1cb7d4112e4$export$bd5b6bfc5fa2ee61);
var $44c3c1cb7d4112e4$export$def901a57d5539c3 = {
    URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
    contramap: $44c3c1cb7d4112e4$var$_contramap
};
var $44c3c1cb7d4112e4$export$fd0fe42029639505 = {
    URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
    bimap: $44c3c1cb7d4112e4$var$_bimap,
    mapLeft: $44c3c1cb7d4112e4$var$_mapLeft
};
var $44c3c1cb7d4112e4$export$dfdd8a9a12668b21 = {
    URI: $44c3c1cb7d4112e4$export$9156e739aa33e19f,
    map: $44c3c1cb7d4112e4$var$_map,
    contramap: $44c3c1cb7d4112e4$var$_contramap,
    bimap: $44c3c1cb7d4112e4$var$_bimap,
    mapLeft: $44c3c1cb7d4112e4$var$_mapLeft
};



/**
 * @since 2.11.0
 */ 
var $0e788fecd26972c9$export$9156e739aa33e19f = 'Endomorphism';
var $0e788fecd26972c9$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(first, second);
        }
    };
};
var $0e788fecd26972c9$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $0e788fecd26972c9$export$e759a9a7f8d04692().concat,
        empty: (0, $ee6b3436e10e8e67$export$f0954fd7d5368655)
    };
};





var $ba0eb5f7cb7456fd$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $1e8be413a8f63f69$exports.min(B).concat,
        empty: B.top
    };
};
var $ba0eb5f7cb7456fd$export$8960430cfd85939f = function(B) {
    return {
        concat: $1e8be413a8f63f69$exports.max(B).concat,
        empty: B.bottom
    };
};
var $ba0eb5f7cb7456fd$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $1e8be413a8f63f69$exports.reverse(M).concat,
        empty: M.empty
    };
};
var $ba0eb5f7cb7456fd$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $1e8be413a8f63f69$exports.struct(monoids).concat,
        empty: empty
    };
};
var $ba0eb5f7cb7456fd$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $1e8be413a8f63f69$exports.tuple.apply($1e8be413a8f63f69$exports, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $ba0eb5f7cb7456fd$export$b314777ae20abca9 = function(M) {
    return $1e8be413a8f63f69$exports.concatAll(M)(M.empty);
};
var $ba0eb5f7cb7456fd$export$50d82750fd26461d = {
    concat: $1e8be413a8f63f69$exports.semigroupVoid.concat,
    empty: undefined
};
var $ba0eb5f7cb7456fd$export$4ab04e39033ac22a = $ba0eb5f7cb7456fd$export$65e3907585753458;
var $ba0eb5f7cb7456fd$export$dfc91d1e5b77420b = $ba0eb5f7cb7456fd$export$8cf3da7c1c9174ea;
var $ba0eb5f7cb7456fd$export$5ca84f9b29f1c1a2 = $ba0eb5f7cb7456fd$export$66c1ae025e96b4bc;
var $ba0eb5f7cb7456fd$export$9cc0388793460b00 = $ba0eb5f7cb7456fd$export$8960430cfd85939f;
var $ba0eb5f7cb7456fd$export$6d1c667712a51996 = $ba0eb5f7cb7456fd$export$96ec731ed4dcb222;
var $ba0eb5f7cb7456fd$export$93e2b83da34ff82a = $ba0eb5f7cb7456fd$export$b314777ae20abca9;
var $ba0eb5f7cb7456fd$export$ea84ccdc68daa647 = {
    concat: $1e8be413a8f63f69$exports.semigroupAll.concat,
    empty: true
};
var $ba0eb5f7cb7456fd$export$c147905ca5134122 = {
    concat: $1e8be413a8f63f69$exports.semigroupAny.concat,
    empty: false
};
var $ba0eb5f7cb7456fd$export$616ba591d6210ed8 = (0, $ee6b3436e10e8e67$export$c2a7ef2cc9b32b31);
var $ba0eb5f7cb7456fd$export$5c6d2e402d334f37 = function() {
    return $ba0eb5f7cb7456fd$export$66c1ae025e96b4bc((0, $0e788fecd26972c9$export$c2a7ef2cc9b32b31)());
};
var $ba0eb5f7cb7456fd$export$fc39f3d77fa2e58a = {
    concat: $1e8be413a8f63f69$exports.semigroupString.concat,
    empty: ''
};
var $ba0eb5f7cb7456fd$export$8f9c64d4a92a9eb6 = {
    concat: $1e8be413a8f63f69$exports.semigroupSum.concat,
    empty: 0
};
var $ba0eb5f7cb7456fd$export$cb362f92c995f3b8 = {
    concat: $1e8be413a8f63f69$exports.semigroupProduct.concat,
    empty: 1
};


/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 


function $375caf5928a03f48$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $4e77e1f8d7cf5551$export$18979a515d2a828e)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $375caf5928a03f48$export$9833a940afed18f3(F, G) {
    var map = (0, $34b267f7755fe355$export$7b0f6fce42e2b480)(F, G).map;
    var _ap = (0, $4e77e1f8d7cf5551$export$2f6ca3d3b1f80bf5)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fgab, _ap(fga));
        }
    };
}









var $64d8a745506bf17b$var$contramap_ = function(predicate, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(predicate, $64d8a745506bf17b$export$53b696d27ecb7ba7(f));
};
var $64d8a745506bf17b$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(f, predicate);
    };
};
var $64d8a745506bf17b$export$9156e739aa33e19f = 'Predicate';
var $64d8a745506bf17b$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(first, $64d8a745506bf17b$export$252bb8b3bbdf6749(second));
        }
    };
};
var $64d8a745506bf17b$export$d795ff673668f564 = function() {
    return {
        concat: $64d8a745506bf17b$export$45c71cec3a7e90aa().concat,
        empty: (0, $ee6b3436e10e8e67$export$7349232f2648ca80)
    };
};
var $64d8a745506bf17b$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(first, $64d8a745506bf17b$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $64d8a745506bf17b$export$4c43b04d78b174fa = function() {
    return {
        concat: $64d8a745506bf17b$export$d900a29579818780().concat,
        empty: (0, $ee6b3436e10e8e67$export$a68382d9631f6c53)
    };
};
var $64d8a745506bf17b$export$def901a57d5539c3 = {
    URI: $64d8a745506bf17b$export$9156e739aa33e19f,
    contramap: $64d8a745506bf17b$var$contramap_
};
var $64d8a745506bf17b$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $64d8a745506bf17b$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $64d8a745506bf17b$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};






var $1ed8bdeb457e19d0$export$f883a24d5edde77c = $54ef96f182e81a75$export$f883a24d5edde77c;
var $1ed8bdeb457e19d0$export$ad14ef4001db2bcd = $54ef96f182e81a75$export$ad14ef4001db2bcd;
function $1ed8bdeb457e19d0$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(a) : $1ed8bdeb457e19d0$export$f883a24d5edde77c;
    };
}
var $1ed8bdeb457e19d0$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(ma.left);
};
var $1ed8bdeb457e19d0$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(ma.right);
};
var $1ed8bdeb457e19d0$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$871de8747c9eaa88(f));
};
var $1ed8bdeb457e19d0$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $1ed8bdeb457e19d0$export$2f6ca3d3b1f80bf5(fa));
};
var $1ed8bdeb457e19d0$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$533b26079ad0b4b(b, f));
};
var $1ed8bdeb457e19d0$var$_foldMap = function(M) {
    var foldMapM = $1ed8bdeb457e19d0$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
var $1ed8bdeb457e19d0$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$7fef8bcdbb34f435(b, f));
};
var $1ed8bdeb457e19d0$var$_traverse = function(F) {
    var traverseF = $1ed8bdeb457e19d0$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $1ed8bdeb457e19d0$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$228be17d80722ab(that));
};
var $1ed8bdeb457e19d0$var$_filter = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $1ed8bdeb457e19d0$var$_filterMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $1ed8bdeb457e19d0$var$_extend = function(wa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(wa, $1ed8bdeb457e19d0$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $1ed8bdeb457e19d0$var$_partition = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $1ed8bdeb457e19d0$var$_partitionMap = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $1ed8bdeb457e19d0$export$3117e3f9ececb6bc(f));
};
var $1ed8bdeb457e19d0$export$9156e739aa33e19f = 'Option';
var $1ed8bdeb457e19d0$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $1ed8bdeb457e19d0$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($1ed8bdeb457e19d0$export$e56af863d5645d5f(x) ? $1ed8bdeb457e19d0$export$e56af863d5645d5f(y) : $1ed8bdeb457e19d0$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $1ed8bdeb457e19d0$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $1ed8bdeb457e19d0$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $1ed8bdeb457e19d0$export$5d7e502287836e58(x) ? $1ed8bdeb457e19d0$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : -1;
        }
    };
};
var $1ed8bdeb457e19d0$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $1ed8bdeb457e19d0$export$e56af863d5645d5f(x) ? y : $1ed8bdeb457e19d0$export$e56af863d5645d5f(y) ? x : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $1ed8bdeb457e19d0$export$f883a24d5edde77c
    };
};
var $1ed8bdeb457e19d0$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map
};
var $1ed8bdeb457e19d0$export$6554612db691658e = (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, (0, $34b267f7755fe355$export$6554612db691658e)($1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61));
var $1ed8bdeb457e19d0$export$9284b360ca18a0fd = (0, $34b267f7755fe355$export$9284b360ca18a0fd)($1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61);
var $1ed8bdeb457e19d0$export$ba255e9e49e00608 = $1ed8bdeb457e19d0$export$ad14ef4001db2bcd;
var $1ed8bdeb457e19d0$export$59a71046037e6c20 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608
};
var $1ed8bdeb457e19d0$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fab) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $1ed8bdeb457e19d0$export$efc21ddc6aeb363d = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap
};
var $1ed8bdeb457e19d0$export$1279d2b7807629fd = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608
};
var $1ed8bdeb457e19d0$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : f(ma.value);
});
var $1ed8bdeb457e19d0$export$f18d5acc27d70423 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap,
    chain: $1ed8bdeb457e19d0$export$5b8affa63fc6df16
};
var $1ed8bdeb457e19d0$export$fb641926d034ac7d = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608,
    chain: $1ed8bdeb457e19d0$export$5b8affa63fc6df16
};
var $1ed8bdeb457e19d0$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $1ed8bdeb457e19d0$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $1ed8bdeb457e19d0$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $1ed8bdeb457e19d0$export$41404b31838667c9 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    reduce: $1ed8bdeb457e19d0$var$_reduce,
    foldMap: $1ed8bdeb457e19d0$var$_foldMap,
    reduceRight: $1ed8bdeb457e19d0$var$_reduceRight
};
var $1ed8bdeb457e19d0$export$41d1a04d78e7b141 = (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(self, that) {
    return $1ed8bdeb457e19d0$export$e56af863d5645d5f(self) ? that() : self;
});
var $1ed8bdeb457e19d0$export$1517cca7889d6aaa = $1ed8bdeb457e19d0$export$41d1a04d78e7b141;
var $1ed8bdeb457e19d0$export$228be17d80722ab = $1ed8bdeb457e19d0$export$41d1a04d78e7b141;
var $1ed8bdeb457e19d0$export$25ba4469a069167 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    alt: $1ed8bdeb457e19d0$var$_alt
};
var $1ed8bdeb457e19d0$export$7f9972325ebfd559 = function() {
    return $1ed8bdeb457e19d0$export$f883a24d5edde77c;
};
var $1ed8bdeb457e19d0$export$aaef8a3eae948f03 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    zero: $1ed8bdeb457e19d0$export$7f9972325ebfd559
};
var $1ed8bdeb457e19d0$export$864d727b48066337 = /*#__PURE__*/ (0, $5dbed21a6458819e$export$864d727b48066337)($1ed8bdeb457e19d0$export$aaef8a3eae948f03, $1ed8bdeb457e19d0$export$59a71046037e6c20);
var $1ed8bdeb457e19d0$export$4acb47accde578d2 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608,
    alt: $1ed8bdeb457e19d0$var$_alt,
    zero: $1ed8bdeb457e19d0$export$7f9972325ebfd559
};
var $1ed8bdeb457e19d0$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(wa) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(f(wa));
    };
};
var $1ed8bdeb457e19d0$export$5b5dd0e212d2a5bc = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    extend: $1ed8bdeb457e19d0$var$_extend
};
var $1ed8bdeb457e19d0$export$8e16b83750b44988 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $1ed8bdeb457e19d0$var$defaultSeparated = /*#__PURE__*/ (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($1ed8bdeb457e19d0$export$f883a24d5edde77c, $1ed8bdeb457e19d0$export$f883a24d5edde77c);
var $1ed8bdeb457e19d0$export$709f6946f4e97408 = function(ma) {
    return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? $1ed8bdeb457e19d0$var$defaultSeparated : (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($1ed8bdeb457e19d0$export$da405662c16fca8e(ma.value), $1ed8bdeb457e19d0$export$482f3615ecf01dc6(ma.value));
};
var $1ed8bdeb457e19d0$export$4a21ac48141ac3c9 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    compact: $1ed8bdeb457e19d0$export$8e16b83750b44988,
    separate: $1ed8bdeb457e19d0$export$709f6946f4e97408
};
var $1ed8bdeb457e19d0$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : predicate(fa.value) ? fa : $1ed8bdeb457e19d0$export$f883a24d5edde77c;
    };
};
var $1ed8bdeb457e19d0$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(fa) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : f(fa.value);
    };
};
var $1ed8bdeb457e19d0$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($1ed8bdeb457e19d0$var$_filter(fa, (0, $64d8a745506bf17b$export$6003a5f097c73977)(predicate)), $1ed8bdeb457e19d0$var$_filter(fa, predicate));
    };
};
var $1ed8bdeb457e19d0$export$3117e3f9ececb6bc = function(f) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($1ed8bdeb457e19d0$export$871de8747c9eaa88(f), $1ed8bdeb457e19d0$export$709f6946f4e97408);
};
var $1ed8bdeb457e19d0$export$d00e1c48fb621173 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    compact: $1ed8bdeb457e19d0$export$8e16b83750b44988,
    separate: $1ed8bdeb457e19d0$export$709f6946f4e97408,
    filter: $1ed8bdeb457e19d0$var$_filter,
    filterMap: $1ed8bdeb457e19d0$var$_filterMap,
    partition: $1ed8bdeb457e19d0$var$_partition,
    partitionMap: $1ed8bdeb457e19d0$var$_partitionMap
};
var $1ed8bdeb457e19d0$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ta) ? F.of($1ed8bdeb457e19d0$export$f883a24d5edde77c) : F.map(f(ta.value), $1ed8bdeb457e19d0$export$ad14ef4001db2bcd);
        };
    };
};
var $1ed8bdeb457e19d0$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ta) ? F.of($1ed8bdeb457e19d0$export$f883a24d5edde77c) : F.map(ta.value, $1ed8bdeb457e19d0$export$ad14ef4001db2bcd);
    };
};
var $1ed8bdeb457e19d0$export$a0202666c3bda011 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    reduce: $1ed8bdeb457e19d0$var$_reduce,
    foldMap: $1ed8bdeb457e19d0$var$_foldMap,
    reduceRight: $1ed8bdeb457e19d0$var$_reduceRight,
    traverse: $1ed8bdeb457e19d0$var$_traverse,
    sequence: $1ed8bdeb457e19d0$export$49bb65c2ea163039
};
var $1ed8bdeb457e19d0$var$_wither = /*#__PURE__*/ (0, $b333f781e2a19138$export$1f5c6f948d11a182)($1ed8bdeb457e19d0$export$a0202666c3bda011, $1ed8bdeb457e19d0$export$4a21ac48141ac3c9);
var $1ed8bdeb457e19d0$var$_wilt = /*#__PURE__*/ (0, $b333f781e2a19138$export$f4cb42390e44d1d2)($1ed8bdeb457e19d0$export$a0202666c3bda011, $1ed8bdeb457e19d0$export$4a21ac48141ac3c9);
var $1ed8bdeb457e19d0$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $1ed8bdeb457e19d0$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $1ed8bdeb457e19d0$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $1ed8bdeb457e19d0$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $1ed8bdeb457e19d0$export$748d317b4c426f96 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    reduce: $1ed8bdeb457e19d0$var$_reduce,
    foldMap: $1ed8bdeb457e19d0$var$_foldMap,
    reduceRight: $1ed8bdeb457e19d0$var$_reduceRight,
    traverse: $1ed8bdeb457e19d0$var$_traverse,
    sequence: $1ed8bdeb457e19d0$export$49bb65c2ea163039,
    compact: $1ed8bdeb457e19d0$export$8e16b83750b44988,
    separate: $1ed8bdeb457e19d0$export$709f6946f4e97408,
    filter: $1ed8bdeb457e19d0$var$_filter,
    filterMap: $1ed8bdeb457e19d0$var$_filterMap,
    partition: $1ed8bdeb457e19d0$var$_partition,
    partitionMap: $1ed8bdeb457e19d0$var$_partitionMap,
    wither: $1ed8bdeb457e19d0$var$_wither,
    wilt: $1ed8bdeb457e19d0$var$_wilt
};
var $1ed8bdeb457e19d0$export$8bf7aba4a9e09055 = function() {
    return $1ed8bdeb457e19d0$export$f883a24d5edde77c;
};
var $1ed8bdeb457e19d0$export$5f956d47d0619c3a = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    ap: $1ed8bdeb457e19d0$var$_ap,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608,
    chain: $1ed8bdeb457e19d0$export$5b8affa63fc6df16,
    throwError: $1ed8bdeb457e19d0$export$8bf7aba4a9e09055
};
var $1ed8bdeb457e19d0$export$80c878c9b1d77917 = $1ed8bdeb457e19d0$export$482f3615ecf01dc6;
var $1ed8bdeb457e19d0$export$825ea6cb6fc48d49 = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    fromEither: $1ed8bdeb457e19d0$export$80c878c9b1d77917
};
var $1ed8bdeb457e19d0$export$5d7e502287836e58 = $54ef96f182e81a75$export$5d7e502287836e58;
var $1ed8bdeb457e19d0$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $1ed8bdeb457e19d0$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $1ed8bdeb457e19d0$export$ccb09033cefa61e8 = $1ed8bdeb457e19d0$export$2d55ea551c238330;
var $1ed8bdeb457e19d0$export$4659b591c19bdf3d = $1ed8bdeb457e19d0$export$2d55ea551c238330;
var $1ed8bdeb457e19d0$export$93e2b83da34ff82a = $1ed8bdeb457e19d0$export$4659b591c19bdf3d;
var $1ed8bdeb457e19d0$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $1ed8bdeb457e19d0$export$8832081647a02ee7 = $1ed8bdeb457e19d0$export$d8a997ff0e6436f3;
var $1ed8bdeb457e19d0$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61);
var $1ed8bdeb457e19d0$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($1ed8bdeb457e19d0$export$efc21ddc6aeb363d);
var $1ed8bdeb457e19d0$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($1ed8bdeb457e19d0$export$efc21ddc6aeb363d);
var $1ed8bdeb457e19d0$export$bffa455ba8c619a6 = $1ed8bdeb457e19d0$export$8e16b83750b44988;
var $1ed8bdeb457e19d0$export$3f23594af5f37336 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, $b00b894e7b37435b$export$3f23594af5f37336($1ed8bdeb457e19d0$export$f18d5acc27d70423));
var $1ed8bdeb457e19d0$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, (0, $1f0befb2747eca52$export$be3ff275bb5a8ac9)($1ed8bdeb457e19d0$export$825ea6cb6fc48d49, $1ed8bdeb457e19d0$export$f18d5acc27d70423));
var $1ed8bdeb457e19d0$export$ecd5e8ace626722c = /*#__PURE__*/ $1ed8bdeb457e19d0$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $1ed8bdeb457e19d0$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $1f0befb2747eca52$export$8138b0ae92c9b5d8)($1ed8bdeb457e19d0$export$825ea6cb6fc48d49);
var $1ed8bdeb457e19d0$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $1f0befb2747eca52$export$a3eef2eba9908c3e)($1ed8bdeb457e19d0$export$825ea6cb6fc48d49, $1ed8bdeb457e19d0$export$f18d5acc27d70423);
var $1ed8bdeb457e19d0$export$c5f2bdbf9b43f0c0 = $1ed8bdeb457e19d0$export$be3ff275bb5a8ac9;
var $1ed8bdeb457e19d0$export$b601f49376b4621a = function(a) {
    return a == null ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(a);
};
var $1ed8bdeb457e19d0$export$d234c058d1d4e435 = function(f) {
    try {
        return $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $1ed8bdeb457e19d0$export$f883a24d5edde77c;
    }
};
var $1ed8bdeb457e19d0$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $1ed8bdeb457e19d0$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $1ed8bdeb457e19d0$export$c69ca7b73fad45e1 = function(f) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(f, $1ed8bdeb457e19d0$export$b601f49376b4621a);
};
var $1ed8bdeb457e19d0$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? $1ed8bdeb457e19d0$export$f883a24d5edde77c : $1ed8bdeb457e19d0$export$b601f49376b4621a(f(ma.value));
    };
};
var $1ed8bdeb457e19d0$export$b187f57ee1822bc5 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$4659b591c19bdf3d((0, $ee6b3436e10e8e67$export$243c2ee5e7d8b05c), (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $1ed8bdeb457e19d0$export$cb585b8513fa8577 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$4659b591c19bdf3d((0, $ee6b3436e10e8e67$export$3d16a43570087548), (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
function $1ed8bdeb457e19d0$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $1ed8bdeb457e19d0$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $1ed8bdeb457e19d0$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $1ed8bdeb457e19d0$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $1ed8bdeb457e19d0$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $1ed8bdeb457e19d0$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61);
var $1ed8bdeb457e19d0$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($1ed8bdeb457e19d0$export$bd5b6bfc5fa2ee61);
var $1ed8bdeb457e19d0$export$2385a24977818dd0 = /*#__PURE__*/ $b00b894e7b37435b$export$2385a24977818dd0($1ed8bdeb457e19d0$export$f18d5acc27d70423);
var $1ed8bdeb457e19d0$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($1ed8bdeb457e19d0$export$efc21ddc6aeb363d);
var $1ed8bdeb457e19d0$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$ba255e9e49e00608($54ef96f182e81a75$export$6ca726a2417e0f3f);
var $1ed8bdeb457e19d0$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $54ef96f182e81a75$export$5fd5031fecdacec3(as));
        if ($1ed8bdeb457e19d0$export$e56af863d5645d5f(o)) return $1ed8bdeb457e19d0$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($1ed8bdeb457e19d0$export$e56af863d5645d5f(o_1)) return $1ed8bdeb457e19d0$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(out);
    };
};
var $1ed8bdeb457e19d0$export$d4e79db5dc14cc1 = function(f) {
    var g = $1ed8bdeb457e19d0$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $54ef96f182e81a75$export$a978c53b4062a525(as) ? g(as) : $1ed8bdeb457e19d0$export$c74b6e34b2b6efb0;
    };
};
var $1ed8bdeb457e19d0$export$104a2841e9cbad06 = $1ed8bdeb457e19d0$export$d4e79db5dc14cc1;
var $1ed8bdeb457e19d0$export$64f39b2a2b79e1b1 = function(f) {
    return $1ed8bdeb457e19d0$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $1ed8bdeb457e19d0$export$d330b60315c14cd1 = /*#__PURE__*/ $1ed8bdeb457e19d0$export$64f39b2a2b79e1b1((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $1ed8bdeb457e19d0$export$e08e3b67e392101e = $1ed8bdeb457e19d0$export$5b8affa63fc6df16;
var $1ed8bdeb457e19d0$export$e3821ef4970c339c = $1ed8bdeb457e19d0$export$3f23594af5f37336;
function $1ed8bdeb457e19d0$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $1ed8bdeb457e19d0$export$5d7e502287836e58(getOption(a));
    };
}
var $1ed8bdeb457e19d0$export$c2a8dfc107523e74 = $1ed8bdeb457e19d0$export$c81f992c08fd0bf3;
var $1ed8bdeb457e19d0$export$a75d1723e6bda2ec = {
    URI: $1ed8bdeb457e19d0$export$9156e739aa33e19f,
    map: $1ed8bdeb457e19d0$var$_map,
    of: $1ed8bdeb457e19d0$export$ba255e9e49e00608,
    ap: $1ed8bdeb457e19d0$var$_ap,
    chain: $1ed8bdeb457e19d0$export$5b8affa63fc6df16,
    reduce: $1ed8bdeb457e19d0$var$_reduce,
    foldMap: $1ed8bdeb457e19d0$var$_foldMap,
    reduceRight: $1ed8bdeb457e19d0$var$_reduceRight,
    traverse: $1ed8bdeb457e19d0$var$_traverse,
    sequence: $1ed8bdeb457e19d0$export$49bb65c2ea163039,
    zero: $1ed8bdeb457e19d0$export$7f9972325ebfd559,
    alt: $1ed8bdeb457e19d0$var$_alt,
    extend: $1ed8bdeb457e19d0$var$_extend,
    compact: $1ed8bdeb457e19d0$export$8e16b83750b44988,
    separate: $1ed8bdeb457e19d0$export$709f6946f4e97408,
    filter: $1ed8bdeb457e19d0$var$_filter,
    filterMap: $1ed8bdeb457e19d0$var$_filterMap,
    partition: $1ed8bdeb457e19d0$var$_partition,
    partitionMap: $1ed8bdeb457e19d0$var$_partitionMap,
    wither: $1ed8bdeb457e19d0$var$_wither,
    wilt: $1ed8bdeb457e19d0$var$_wilt,
    throwError: $1ed8bdeb457e19d0$export$8bf7aba4a9e09055
};
var $1ed8bdeb457e19d0$export$18979a515d2a828e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$18979a515d2a828e)($1ed8bdeb457e19d0$export$efc21ddc6aeb363d);
var $1ed8bdeb457e19d0$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $375caf5928a03f48$export$c8e1a8ea383fd0ff)($1ed8bdeb457e19d0$export$1279d2b7807629fd);
var $1ed8bdeb457e19d0$export$56cd0d85e73e688f = function() {
    return $1ed8bdeb457e19d0$export$c2a7ef2cc9b32b31((0, $1e8be413a8f63f69$export$43128fadae87b74a)());
};
var $1ed8bdeb457e19d0$export$ca391a563a1f3001 = function() {
    return $1ed8bdeb457e19d0$export$c2a7ef2cc9b32b31((0, $1e8be413a8f63f69$export$4c7897fafd92b108)());
};





function $37dbc87cd4b95810$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $37dbc87cd4b95810$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $37dbc87cd4b95810$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $37dbc87cd4b95810$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $37dbc87cd4b95810$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $37dbc87cd4b95810$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $37dbc87cd4b95810$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $37dbc87cd4b95810$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $37dbc87cd4b95810$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $37dbc87cd4b95810$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $37dbc87cd4b95810$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $37dbc87cd4b95810$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $37dbc87cd4b95810$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $37dbc87cd4b95810$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $37dbc87cd4b95810$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $37dbc87cd4b95810$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $37dbc87cd4b95810$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $37dbc87cd4b95810$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $37dbc87cd4b95810$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $37dbc87cd4b95810$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $37dbc87cd4b95810$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $37dbc87cd4b95810$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $37dbc87cd4b95810$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $37dbc87cd4b95810$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $37dbc87cd4b95810$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $37dbc87cd4b95810$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $37dbc87cd4b95810$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $37dbc87cd4b95810$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $37dbc87cd4b95810$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $37dbc87cd4b95810$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $37dbc87cd4b95810$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $37dbc87cd4b95810$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $37dbc87cd4b95810$export$1124ffa357d27237(I) {
    var r = {};
    if ($37dbc87cd4b95810$var$isFunctor(I)) r.map = $37dbc87cd4b95810$export$871de8747c9eaa88(I);
    if ($37dbc87cd4b95810$var$isContravariant(I)) r.contramap = $37dbc87cd4b95810$export$53b696d27ecb7ba7(I);
    if ($37dbc87cd4b95810$var$isFunctorWithIndex(I)) r.mapWithIndex = $37dbc87cd4b95810$export$8f07ddce13659f50(I);
    if ($37dbc87cd4b95810$var$isApply(I)) {
        r.ap = $37dbc87cd4b95810$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)(I);
        r.apSecond = (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)(I);
    }
    if ($37dbc87cd4b95810$var$isChain(I)) {
        r.chain = $37dbc87cd4b95810$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $b00b894e7b37435b$export$e3821ef4970c339c)(I);
        r.flatten = r.chain((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
    }
    if ($37dbc87cd4b95810$var$isBifunctor(I)) {
        r.bimap = $37dbc87cd4b95810$export$eb54baf0b342cb1d(I);
        r.mapLeft = $37dbc87cd4b95810$export$472de43a55e4aa49(I);
    }
    if ($37dbc87cd4b95810$var$isExtend(I)) {
        r.extend = $37dbc87cd4b95810$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
    }
    if ($37dbc87cd4b95810$var$isFoldable(I)) {
        r.reduce = $37dbc87cd4b95810$export$533b26079ad0b4b(I);
        r.foldMap = $37dbc87cd4b95810$export$b66cdc0497d8a99a(I);
        r.reduceRight = $37dbc87cd4b95810$export$7fef8bcdbb34f435(I);
    }
    if ($37dbc87cd4b95810$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $37dbc87cd4b95810$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $37dbc87cd4b95810$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $37dbc87cd4b95810$export$ce2b2fe0b88ccd0a(I);
    }
    if ($37dbc87cd4b95810$var$isAlt(I)) r.alt = $37dbc87cd4b95810$export$228be17d80722ab(I);
    if ($37dbc87cd4b95810$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($37dbc87cd4b95810$var$isFilterable(I)) {
        r.filter = $37dbc87cd4b95810$export$3dea766d36a8935f(I);
        r.filterMap = $37dbc87cd4b95810$export$a04c6c6965dd4709(I);
        r.partition = $37dbc87cd4b95810$export$b29f828819edca8d(I);
        r.partitionMap = $37dbc87cd4b95810$export$3117e3f9ececb6bc(I);
    }
    if ($37dbc87cd4b95810$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $37dbc87cd4b95810$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $37dbc87cd4b95810$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $37dbc87cd4b95810$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $37dbc87cd4b95810$export$bc7c0794b9c6f3ba(I);
    }
    if ($37dbc87cd4b95810$var$isProfunctor(I)) r.promap = $37dbc87cd4b95810$export$6684e88861ab74ec(I);
    if ($37dbc87cd4b95810$var$isSemigroupoid(I)) r.compose = $37dbc87cd4b95810$export$f672e0b6f7222cd7(I);
    if ($37dbc87cd4b95810$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $37dbc87cd4b95810$export$a4627e546088548d = (0, $ee6b3436e10e8e67$export$a4627e546088548d);











var $75d6b9af8d6f69d5$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $75d6b9af8d6f69d5$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $75d6b9af8d6f69d5$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $75d6b9af8d6f69d5$export$346677f925de839c = function(m) {
    return m.size;
};
var $75d6b9af8d6f69d5$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $75d6b9af8d6f69d5$export$6a0d13241802fe80(E) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $75d6b9af8d6f69d5$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $54ef96f182e81a75$export$5d7e502287836e58(lookupE(k, m));
    };
}
function $75d6b9af8d6f69d5$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $75d6b9af8d6f69d5$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $75d6b9af8d6f69d5$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $75d6b9af8d6f69d5$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $75d6b9af8d6f69d5$export$bb44f104e3c54dae(O) {
    var keysO = $75d6b9af8d6f69d5$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $75d6b9af8d6f69d5$export$4aaa3912a3956cb7 = function(O) {
    return $75d6b9af8d6f69d5$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $75d6b9af8d6f69d5$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $75d6b9af8d6f69d5$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $54ef96f182e81a75$export$ad14ef4001db2bcd([
                kas[b],
                b + 1
            ]) : $54ef96f182e81a75$export$f883a24d5edde77c;
        });
    };
}
var $75d6b9af8d6f69d5$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($54ef96f182e81a75$export$e56af863d5645d5f(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $75d6b9af8d6f69d5$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($54ef96f182e81a75$export$5d7e502287836e58(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $75d6b9af8d6f69d5$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $75d6b9af8d6f69d5$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $75d6b9af8d6f69d5$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($54ef96f182e81a75$export$e56af863d5645d5f(found)) return $54ef96f182e81a75$export$f883a24d5edde77c;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $54ef96f182e81a75$export$ad14ef4001db2bcd(m);
            var r = new Map(m);
            r.set(fk, next);
            return $54ef96f182e81a75$export$ad14ef4001db2bcd(r);
        };
    };
};
function $75d6b9af8d6f69d5$export$3e41007ebfff0e64(E) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    var deleteAtE = $75d6b9af8d6f69d5$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(lookupE(k, m), $1ed8bdeb457e19d0$export$871de8747c9eaa88(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $54ef96f182e81a75$export$ad14ef4001db2bcd([
                ka,
                a
            ]);
        }
        return $54ef96f182e81a75$export$f883a24d5edde77c;
    };
}
function $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(lookupWithKeyE(k, m), $1ed8bdeb457e19d0$export$871de8747c9eaa88(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $75d6b9af8d6f69d5$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $75d6b9af8d6f69d5$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($54ef96f182e81a75$export$e56af863d5645d5f(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $75d6b9af8d6f69d5$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $75d6b9af8d6f69d5$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $75d6b9af8d6f69d5$export$35d0420a84c5d3ae(SK, SA);
    return (0, $f591655db7bad68b$export$fec6acd8d60e8568)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $75d6b9af8d6f69d5$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(mx)) return my;
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($54ef96f182e81a75$export$5d7e502287836e58(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $75d6b9af8d6f69d5$export$6e22c362a0406a2c
    };
}
var $75d6b9af8d6f69d5$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $75d6b9af8d6f69d5$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $75d6b9af8d6f69d5$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($54ef96f182e81a75$export$5d7e502287836e58(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $75d6b9af8d6f69d5$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $75d6b9af8d6f69d5$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($54ef96f182e81a75$export$d649b6842e09f2b(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
};
function $75d6b9af8d6f69d5$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
}
var $75d6b9af8d6f69d5$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($54ef96f182e81a75$export$5d7e502287836e58(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $75d6b9af8d6f69d5$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $75d6b9af8d6f69d5$var$_map = function(fa, f) {
    return $75d6b9af8d6f69d5$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $75d6b9af8d6f69d5$var$_filter = function(fa, p) {
    return $75d6b9af8d6f69d5$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $75d6b9af8d6f69d5$var$_filterMap = function(fa, f) {
    return $75d6b9af8d6f69d5$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $75d6b9af8d6f69d5$var$_partition = function(fa, predicate) {
    return $75d6b9af8d6f69d5$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $75d6b9af8d6f69d5$var$_partitionMap = function(fa, f) {
    return $75d6b9af8d6f69d5$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $75d6b9af8d6f69d5$var$_filterWithIndex = function(fa, p) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $75d6b9af8d6f69d5$export$36e42aef19fc7171(p));
};
var $75d6b9af8d6f69d5$var$_filterMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $75d6b9af8d6f69d5$export$30c5cbe848021e97(f));
};
var $75d6b9af8d6f69d5$var$_partitionWithIndex = function(fa, p) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $75d6b9af8d6f69d5$export$dad5e500f2bab9bc(p));
};
var $75d6b9af8d6f69d5$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $75d6b9af8d6f69d5$export$bc7c0794b9c6f3ba(f));
};
var $75d6b9af8d6f69d5$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($54ef96f182e81a75$export$5d7e502287836e58(oa)) m.set(k, oa.value);
    }
    return m;
};
var $75d6b9af8d6f69d5$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_filter(fa, predicate);
    };
};
var $75d6b9af8d6f69d5$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_filterMap(fa, f);
    };
};
var $75d6b9af8d6f69d5$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_map(fa, f);
    };
};
var $75d6b9af8d6f69d5$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_mapWithIndex(fa, f);
    };
};
var $75d6b9af8d6f69d5$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_partition(fa, predicate);
    };
};
var $75d6b9af8d6f69d5$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $75d6b9af8d6f69d5$var$_partitionMap(fa, f);
    };
};
var $75d6b9af8d6f69d5$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($54ef96f182e81a75$export$d649b6842e09f2b(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
};
var $75d6b9af8d6f69d5$export$9156e739aa33e19f = 'ReadonlyMap';
var $75d6b9af8d6f69d5$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $75d6b9af8d6f69d5$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $75d6b9af8d6f69d5$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $75d6b9af8d6f69d5$export$baca17b4aff42f82(E, S).concat,
        empty: $75d6b9af8d6f69d5$export$6e22c362a0406a2c
    };
};
var $75d6b9af8d6f69d5$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $75d6b9af8d6f69d5$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $75d6b9af8d6f69d5$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $75d6b9af8d6f69d5$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $75d6b9af8d6f69d5$export$d600270efcad85ac() {
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        map: $75d6b9af8d6f69d5$var$_map,
        mapWithIndex: $75d6b9af8d6f69d5$var$_mapWithIndex,
        compact: $75d6b9af8d6f69d5$export$8e16b83750b44988,
        separate: $75d6b9af8d6f69d5$export$709f6946f4e97408,
        filter: $75d6b9af8d6f69d5$var$_filter,
        filterMap: $75d6b9af8d6f69d5$var$_filterMap,
        partition: $75d6b9af8d6f69d5$var$_partition,
        partitionMap: $75d6b9af8d6f69d5$var$_partitionMap,
        partitionMapWithIndex: $75d6b9af8d6f69d5$var$_partitionMapWithIndex,
        partitionWithIndex: $75d6b9af8d6f69d5$var$_partitionWithIndex,
        filterMapWithIndex: $75d6b9af8d6f69d5$var$_filterMapWithIndex,
        filterWithIndex: $75d6b9af8d6f69d5$var$_filterWithIndex
    };
}
var $75d6b9af8d6f69d5$export$bd5b6bfc5fa2ee61 = {
    URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
    map: $75d6b9af8d6f69d5$var$_map
};
var $75d6b9af8d6f69d5$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($75d6b9af8d6f69d5$export$bd5b6bfc5fa2ee61);
var $75d6b9af8d6f69d5$export$7c7748da5f3db60f = function() {
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        map: $75d6b9af8d6f69d5$var$_map,
        mapWithIndex: $75d6b9af8d6f69d5$var$_mapWithIndex
    };
};
var $75d6b9af8d6f69d5$export$4a21ac48141ac3c9 = {
    URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
    compact: $75d6b9af8d6f69d5$export$8e16b83750b44988,
    separate: $75d6b9af8d6f69d5$export$709f6946f4e97408
};
var $75d6b9af8d6f69d5$export$d00e1c48fb621173 = {
    URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
    map: $75d6b9af8d6f69d5$var$_map,
    compact: $75d6b9af8d6f69d5$export$8e16b83750b44988,
    separate: $75d6b9af8d6f69d5$export$709f6946f4e97408,
    filter: $75d6b9af8d6f69d5$var$_filter,
    filterMap: $75d6b9af8d6f69d5$var$_filterMap,
    partition: $75d6b9af8d6f69d5$var$_partition,
    partitionMap: $75d6b9af8d6f69d5$var$_partitionMap
};
var $75d6b9af8d6f69d5$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $75d6b9af8d6f69d5$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $75d6b9af8d6f69d5$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $75d6b9af8d6f69d5$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $75d6b9af8d6f69d5$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $75d6b9af8d6f69d5$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $75d6b9af8d6f69d5$export$d544f02c7cebdaed = function(O) {
    var reduceO = $75d6b9af8d6f69d5$export$533b26079ad0b4b(O);
    var foldMapO = $75d6b9af8d6f69d5$export$b66cdc0497d8a99a(O);
    var reduceRightO = $75d6b9af8d6f69d5$export$7fef8bcdbb34f435(O);
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceRightO(b, f));
        }
    };
};
var $75d6b9af8d6f69d5$export$bbd3ef8720e22369 = function(O) {
    var keysO = $75d6b9af8d6f69d5$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $75d6b9af8d6f69d5$export$18153bb1181268e5 = function(O) {
    var keysO = $75d6b9af8d6f69d5$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $75d6b9af8d6f69d5$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $75d6b9af8d6f69d5$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $75d6b9af8d6f69d5$export$6c59d75f118e7bc9 = function(O) {
    var F = $75d6b9af8d6f69d5$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $75d6b9af8d6f69d5$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $75d6b9af8d6f69d5$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $75d6b9af8d6f69d5$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $75d6b9af8d6f69d5$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $75d6b9af8d6f69d5$export$46b81797a3375b8c(O);
    var F = $75d6b9af8d6f69d5$export$d544f02c7cebdaed(O);
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        map: $75d6b9af8d6f69d5$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $75d6b9af8d6f69d5$export$46b81797a3375b8c = function(O) {
    var FWI = $75d6b9af8d6f69d5$export$6c59d75f118e7bc9(O);
    var keysO = $75d6b9af8d6f69d5$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $ee6b3436e10e8e67$export$5f584391ee0d99b4));
        };
    };
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        map: $75d6b9af8d6f69d5$var$_map,
        mapWithIndex: $75d6b9af8d6f69d5$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $75d6b9af8d6f69d5$export$bb8ef26a634cac7b(O) {
    var TWI = $75d6b9af8d6f69d5$export$46b81797a3375b8c(O);
    return {
        URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
        _E: undefined,
        map: $75d6b9af8d6f69d5$var$_map,
        compact: $75d6b9af8d6f69d5$export$8e16b83750b44988,
        separate: $75d6b9af8d6f69d5$export$709f6946f4e97408,
        filter: $75d6b9af8d6f69d5$var$_filter,
        filterMap: $75d6b9af8d6f69d5$var$_filterMap,
        partition: $75d6b9af8d6f69d5$var$_partition,
        partitionMap: $75d6b9af8d6f69d5$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $75d6b9af8d6f69d5$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $b333f781e2a19138$export$f4cb42390e44d1d2)(TWI, $75d6b9af8d6f69d5$export$4a21ac48141ac3c9),
        wither: (0, $b333f781e2a19138$export$1f5c6f948d11a182)(TWI, $75d6b9af8d6f69d5$export$4a21ac48141ac3c9)
    };
}
var $75d6b9af8d6f69d5$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(first)) return second;
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($54ef96f182e81a75$export$5d7e502287836e58(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($54ef96f182e81a75$export$e56af863d5645d5f(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $75d6b9af8d6f69d5$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(first) || $75d6b9af8d6f69d5$export$dd1bc94b04021eeb(second)) return $75d6b9af8d6f69d5$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($54ef96f182e81a75$export$5d7e502287836e58(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $75d6b9af8d6f69d5$export$acaf96a27438246b = function(E) {
    var memberE = $75d6b9af8d6f69d5$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(first)) return second;
            if ($75d6b9af8d6f69d5$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $75d6b9af8d6f69d5$export$9f200c4466975173 = $75d6b9af8d6f69d5$export$ff82449ce381c54a;
var $75d6b9af8d6f69d5$export$28562fb56044e6b5 = {
    URI: $75d6b9af8d6f69d5$export$9156e739aa33e19f,
    map: $75d6b9af8d6f69d5$var$_map,
    compact: $75d6b9af8d6f69d5$export$8e16b83750b44988,
    separate: $75d6b9af8d6f69d5$export$709f6946f4e97408,
    filter: $75d6b9af8d6f69d5$var$_filter,
    filterMap: $75d6b9af8d6f69d5$var$_filterMap,
    partition: $75d6b9af8d6f69d5$var$_partition,
    partitionMap: $75d6b9af8d6f69d5$var$_partitionMap
};






var $8ef2d0b67d58fe22$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $8ef2d0b67d58fe22$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $8ef2d0b67d58fe22$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $8ef2d0b67d58fe22$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $8ef2d0b67d58fe22$export$871de8747c9eaa88(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $8ef2d0b67d58fe22$export$e08e3b67e392101e(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $8ef2d0b67d58fe22$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $8ef2d0b67d58fe22$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
}
function $8ef2d0b67d58fe22$export$971dd5b0dfd021b6(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $8ef2d0b67d58fe22$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($8ef2d0b67d58fe22$export$dd1bc94b04021eeb(me)) return that;
        if ($8ef2d0b67d58fe22$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $8ef2d0b67d58fe22$export$bc86dfbf7795668c(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $8ef2d0b67d58fe22$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($8ef2d0b67d58fe22$export$dd1bc94b04021eeb(me) || $8ef2d0b67d58fe22$export$dd1bc94b04021eeb(that)) return $8ef2d0b67d58fe22$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $8ef2d0b67d58fe22$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $8ef2d0b67d58fe22$export$5bf96401662340b7(EB);
            var hasC = $8ef2d0b67d58fe22$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
        };
    };
}
function $8ef2d0b67d58fe22$export$acaf96a27438246b(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $8ef2d0b67d58fe22$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $8ef2d0b67d58fe22$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $8ef2d0b67d58fe22$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $8ef2d0b67d58fe22$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $8ef2d0b67d58fe22$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $8ef2d0b67d58fe22$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $8ef2d0b67d58fe22$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $8ef2d0b67d58fe22$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $8ef2d0b67d58fe22$export$21a5ca8aa77d35ff(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $8ef2d0b67d58fe22$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $8ef2d0b67d58fe22$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $8ef2d0b67d58fe22$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    var removeE = $8ef2d0b67d58fe22$export$cd7f480d6b8286c3(E);
    var insertE = $8ef2d0b67d58fe22$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $8ef2d0b67d58fe22$export$8e16b83750b44988 = function(E) {
    return $8ef2d0b67d58fe22$export$a04c6c6965dd4709(E)((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
function $8ef2d0b67d58fe22$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $8ef2d0b67d58fe22$export$5bf96401662340b7(EE);
        var elemEA = $8ef2d0b67d58fe22$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
}
function $8ef2d0b67d58fe22$export$a04c6c6965dd4709(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $8ef2d0b67d58fe22$export$6e22c362a0406a2c = new Set();
var $8ef2d0b67d58fe22$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $8ef2d0b67d58fe22$export$346677f925de839c = function(set) {
    return set.size;
};
var $8ef2d0b67d58fe22$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $8ef2d0b67d58fe22$export$7ecc1a3b11b57dab(predicate) {
    return (0, $64d8a745506bf17b$export$6003a5f097c73977)($8ef2d0b67d58fe22$export$ad14ef4001db2bcd((0, $64d8a745506bf17b$export$6003a5f097c73977)(predicate)));
}
function $8ef2d0b67d58fe22$export$af04532ec9ff13d2(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $8ef2d0b67d58fe22$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $8ef2d0b67d58fe22$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $8ef2d0b67d58fe22$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $8ef2d0b67d58fe22$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $8ef2d0b67d58fe22$export$9156e739aa33e19f = 'ReadonlySet';
function $8ef2d0b67d58fe22$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $8ef2d0b67d58fe22$export$804fed467fde44e4(E) {
    var subsetE = $8ef2d0b67d58fe22$export$af04532ec9ff13d2(E);
    return (0, $f591655db7bad68b$export$fec6acd8d60e8568)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $8ef2d0b67d58fe22$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $8ef2d0b67d58fe22$export$971dd5b0dfd021b6(E)
    };
};
var $8ef2d0b67d58fe22$export$c487aac9f4157837 = function(E) {
    return {
        concat: $8ef2d0b67d58fe22$export$baca17b4aff42f82(E).concat,
        empty: $8ef2d0b67d58fe22$export$6e22c362a0406a2c
    };
};
var $8ef2d0b67d58fe22$export$d379a869a72e4055 = function(E) {
    return {
        concat: $8ef2d0b67d58fe22$export$bc86dfbf7795668c(E)
    };
};
var $8ef2d0b67d58fe22$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $8ef2d0b67d58fe22$export$acaf96a27438246b(E)
    };
};
var $8ef2d0b67d58fe22$export$571d59b505e6bb4e = $8ef2d0b67d58fe22$export$9288e031f1846591;


var $71e2e12449623c93$exports = {};







var $be3ababca8b33dca$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $be3ababca8b33dca$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $be3ababca8b33dca$export$6e22c362a0406a2c = '';
var $be3ababca8b33dca$export$8f55868b713abdc3 = {
    concat: $be3ababca8b33dca$export$c16b1dbe8a4166b6.concat,
    empty: $be3ababca8b33dca$export$6e22c362a0406a2c
};
var $be3ababca8b33dca$export$ee8aa95bfab51c5 = {
    equals: $be3ababca8b33dca$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $be3ababca8b33dca$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $be3ababca8b33dca$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $be3ababca8b33dca$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $be3ababca8b33dca$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $be3ababca8b33dca$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $be3ababca8b33dca$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $be3ababca8b33dca$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $be3ababca8b33dca$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $be3ababca8b33dca$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $be3ababca8b33dca$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $be3ababca8b33dca$export$346677f925de839c = function(s) {
    return s.length;
};
var $be3ababca8b33dca$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $69ae994846dd7463$export$a978c53b4062a525)(out) ? out : [
            s
        ];
    };
};
var $be3ababca8b33dca$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $be3ababca8b33dca$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $be3ababca8b33dca$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};



var $83226b83a5307e7b$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $83226b83a5307e7b$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $83226b83a5307e7b$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $83226b83a5307e7b$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) return false;
    }
    return true;
};
var $83226b83a5307e7b$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $83226b83a5307e7b$export$ed97f33186d4b816 = /*#__PURE__*/ $83226b83a5307e7b$var$keys_($be3ababca8b33dca$export$ee8aa95bfab51c5);
function $83226b83a5307e7b$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $83226b83a5307e7b$export$bb44f104e3c54dae($be3ababca8b33dca$export$ee8aa95bfab51c5)(O);
    var keysO = $83226b83a5307e7b$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $83226b83a5307e7b$export$4aaa3912a3956cb7 = /*#__PURE__*/ $83226b83a5307e7b$export$bb44f104e3c54dae($be3ababca8b33dca$export$ee8aa95bfab51c5)(function(k, a) {
    return [
        k,
        a
    ];
});
function $83226b83a5307e7b$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $83226b83a5307e7b$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $54ef96f182e81a75$export$ad14ef4001db2bcd([
                sas[b],
                b + 1
            ]) : $54ef96f182e81a75$export$f883a24d5edde77c;
        });
    };
}
var $83226b83a5307e7b$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $83226b83a5307e7b$export$a4f4bb6b1453fff5 = function(k, r) {
    return $54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k);
};
function $83226b83a5307e7b$export$90f9093465da3136(k) {
    return function(r) {
        if (!$54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $83226b83a5307e7b$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$83226b83a5307e7b$export$a4f4bb6b1453fff5(k, r)) return $54ef96f182e81a75$export$f883a24d5edde77c;
        if (r[k] === a) return $54ef96f182e81a75$export$ad14ef4001db2bcd(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $54ef96f182e81a75$export$ad14ef4001db2bcd(out);
    };
};
var $83226b83a5307e7b$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$83226b83a5307e7b$export$a4f4bb6b1453fff5(k, r)) return $54ef96f182e81a75$export$f883a24d5edde77c;
        var next = f(r[k]);
        if (next === r[k]) return $54ef96f182e81a75$export$ad14ef4001db2bcd(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $54ef96f182e81a75$export$ad14ef4001db2bcd(out);
    };
};
function $83226b83a5307e7b$export$3e41007ebfff0e64(k) {
    var deleteAtk = $83226b83a5307e7b$export$90f9093465da3136(k);
    return function(r) {
        var oa = $83226b83a5307e7b$export$dfc7155ac0343b8(k, r);
        return $54ef96f182e81a75$export$e56af863d5645d5f(oa) ? $54ef96f182e81a75$export$f883a24d5edde77c : $54ef96f182e81a75$export$ad14ef4001db2bcd([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $83226b83a5307e7b$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $83226b83a5307e7b$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$54ef96f182e81a75$export$a4f4bb6b1453fff5.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $83226b83a5307e7b$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $83226b83a5307e7b$export$dfc7155ac0343b8(k, r);
    };
    return $54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k) ? $54ef96f182e81a75$export$ad14ef4001db2bcd(r[k]) : $54ef96f182e81a75$export$f883a24d5edde77c;
}
var $83226b83a5307e7b$export$6e22c362a0406a2c = {};
function $83226b83a5307e7b$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $83226b83a5307e7b$export$871de8747c9eaa88(f) {
    return $83226b83a5307e7b$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $83226b83a5307e7b$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $83226b83a5307e7b$export$bbd3ef8720e22369($be3ababca8b33dca$export$ee8aa95bfab51c5).apply(void 0, args);
    var keysO = $83226b83a5307e7b$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $83226b83a5307e7b$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $83226b83a5307e7b$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $83226b83a5307e7b$export$18153bb1181268e5($be3ababca8b33dca$export$ee8aa95bfab51c5)(O);
}
function $83226b83a5307e7b$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $83226b83a5307e7b$export$ce2b2fe0b88ccd0a($be3ababca8b33dca$export$ee8aa95bfab51c5).apply(void 0, args);
    var keysO = $83226b83a5307e7b$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $83226b83a5307e7b$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $83226b83a5307e7b$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $83226b83a5307e7b$var$_traverseWithIndex($be3ababca8b33dca$export$ee8aa95bfab51c5)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $83226b83a5307e7b$export$df3f009e3d155b20(F) {
    var traverseOF = $83226b83a5307e7b$export$b3c6f3d9661cffba($be3ababca8b33dca$export$ee8aa95bfab51c5)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $83226b83a5307e7b$export$49bb65c2ea163039(F) {
    return $83226b83a5307e7b$export$5d141086b2c0bc6($be3ababca8b33dca$export$ee8aa95bfab51c5)(F);
}
var $83226b83a5307e7b$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $83226b83a5307e7b$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, traverseF(f)), $83226b83a5307e7b$export$8e16b83750b44988);
        };
    };
};
var $83226b83a5307e7b$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $83226b83a5307e7b$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, traverseF(f)), $83226b83a5307e7b$export$709f6946f4e97408);
        };
    };
};
function $83226b83a5307e7b$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
}
function $83226b83a5307e7b$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
    };
}
function $83226b83a5307e7b$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) {
            var ob = f(k, r[k]);
            if ($54ef96f182e81a75$export$5d7e502287836e58(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $83226b83a5307e7b$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $83226b83a5307e7b$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $83226b83a5307e7b$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
    };
}
function $83226b83a5307e7b$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $83226b83a5307e7b$export$9f69d28786a8399c = $83226b83a5307e7b$export$4aaa3912a3956cb7;
var $83226b83a5307e7b$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $83226b83a5307e7b$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $83226b83a5307e7b$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $83226b83a5307e7b$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $83226b83a5307e7b$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $83226b83a5307e7b$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($83226b83a5307e7b$export$dd1bc94b04021eeb(first)) return second;
            if ($83226b83a5307e7b$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($83226b83a5307e7b$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$83226b83a5307e7b$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $83226b83a5307e7b$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($83226b83a5307e7b$export$dd1bc94b04021eeb(first) || $83226b83a5307e7b$export$dd1bc94b04021eeb(second)) return $83226b83a5307e7b$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($83226b83a5307e7b$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $83226b83a5307e7b$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($83226b83a5307e7b$export$dd1bc94b04021eeb(first)) return second;
        if ($83226b83a5307e7b$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$83226b83a5307e7b$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$83226b83a5307e7b$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $83226b83a5307e7b$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$871de8747c9eaa88(f));
};
var $83226b83a5307e7b$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$8f07ddce13659f50(f));
};
var $83226b83a5307e7b$export$8eef5fdba9512999 = function(O) {
    var reduceO = $83226b83a5307e7b$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceO(b, f));
    };
};
var $83226b83a5307e7b$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $83226b83a5307e7b$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
        };
    };
};
var $83226b83a5307e7b$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $83226b83a5307e7b$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceRightO(b, f));
    };
};
var $83226b83a5307e7b$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$3dea766d36a8935f(predicate));
};
var $83226b83a5307e7b$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$a04c6c6965dd4709(f));
};
var $83226b83a5307e7b$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$b29f828819edca8d(predicate));
};
var $83226b83a5307e7b$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$3117e3f9ececb6bc(f));
};
var $83226b83a5307e7b$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $83226b83a5307e7b$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceWithIndexO(b, f));
    };
};
var $83226b83a5307e7b$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $83226b83a5307e7b$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
        };
    };
};
var $83226b83a5307e7b$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $83226b83a5307e7b$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, reduceRightWithIndexO(b, f));
    };
};
var $83226b83a5307e7b$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$bc7c0794b9c6f3ba(f));
};
var $83226b83a5307e7b$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $83226b83a5307e7b$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$30c5cbe848021e97(f));
};
var $83226b83a5307e7b$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $83226b83a5307e7b$export$36e42aef19fc7171(predicateWithIndex));
};
var $83226b83a5307e7b$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $83226b83a5307e7b$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)((0, $ee6b3436e10e8e67$export$5f584391ee0d99b4), f));
        };
    };
};
var $83226b83a5307e7b$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $83226b83a5307e7b$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
        };
    };
};
var $83226b83a5307e7b$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $83226b83a5307e7b$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($83226b83a5307e7b$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $83226b83a5307e7b$export$3dea766d36a8935f = function(predicate) {
    return $83226b83a5307e7b$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $83226b83a5307e7b$export$a04c6c6965dd4709 = function(f) {
    return $83226b83a5307e7b$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $83226b83a5307e7b$export$b29f828819edca8d = function(predicate) {
    return $83226b83a5307e7b$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $83226b83a5307e7b$export$3117e3f9ececb6bc = function(f) {
    return $83226b83a5307e7b$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $83226b83a5307e7b$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $83226b83a5307e7b$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $83226b83a5307e7b$export$533b26079ad0b4b($be3ababca8b33dca$export$ee8aa95bfab51c5).apply(void 0, args);
}
function $83226b83a5307e7b$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $83226b83a5307e7b$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $83226b83a5307e7b$export$b66cdc0497d8a99a($be3ababca8b33dca$export$ee8aa95bfab51c5)(O);
}
function $83226b83a5307e7b$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $83226b83a5307e7b$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $83226b83a5307e7b$export$7fef8bcdbb34f435($be3ababca8b33dca$export$ee8aa95bfab51c5).apply(void 0, args);
}
var $83226b83a5307e7b$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) {
        var oa = r[k];
        if ($54ef96f182e81a75$export$5d7e502287836e58(oa)) out[k] = oa.value;
    }
    return out;
};
var $83226b83a5307e7b$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r, k)) {
        var e = r[k];
        if ($54ef96f182e81a75$export$d649b6842e09f2b(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(left, right);
};
var $83226b83a5307e7b$export$9156e739aa33e19f = 'ReadonlyRecord';
function $83226b83a5307e7b$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $83226b83a5307e7b$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $83226b83a5307e7b$export$3cb5cd7f7776c81($be3ababca8b33dca$export$ee8aa95bfab51c5)(O);
}
function $83226b83a5307e7b$export$804fed467fde44e4(E) {
    var isSubrecordE = $83226b83a5307e7b$export$36e6f76a1d117b8a(E);
    return (0, $f591655db7bad68b$export$fec6acd8d60e8568)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $83226b83a5307e7b$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($83226b83a5307e7b$export$dd1bc94b04021eeb(first)) return second;
            if ($83226b83a5307e7b$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($54ef96f182e81a75$export$a4f4bb6b1453fff5.call(second, k)) r[k] = $54ef96f182e81a75$export$a4f4bb6b1453fff5.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $83226b83a5307e7b$export$6e22c362a0406a2c
    };
}
var $83226b83a5307e7b$export$bd5b6bfc5fa2ee61 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab
};
var $83226b83a5307e7b$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($83226b83a5307e7b$export$bd5b6bfc5fa2ee61);
var $83226b83a5307e7b$export$9fdffe0fe1e91cad = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    mapWithIndex: $83226b83a5307e7b$export$45e3e46323e6d66c
};
var $83226b83a5307e7b$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $83226b83a5307e7b$export$9156e739aa33e19f,
        reduce: $83226b83a5307e7b$export$8eef5fdba9512999(O),
        foldMap: $83226b83a5307e7b$export$11b0d0e0b70641d9(O),
        reduceRight: $83226b83a5307e7b$export$ec882fc9def9e5db(O)
    };
};
var $83226b83a5307e7b$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $83226b83a5307e7b$export$9156e739aa33e19f,
        reduce: $83226b83a5307e7b$export$8eef5fdba9512999(O),
        foldMap: $83226b83a5307e7b$export$11b0d0e0b70641d9(O),
        reduceRight: $83226b83a5307e7b$export$ec882fc9def9e5db(O),
        reduceWithIndex: $83226b83a5307e7b$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $83226b83a5307e7b$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $83226b83a5307e7b$export$3b7618311030b1af(O)
    };
};
var $83226b83a5307e7b$export$4a21ac48141ac3c9 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    compact: $83226b83a5307e7b$export$8e16b83750b44988,
    separate: $83226b83a5307e7b$export$709f6946f4e97408
};
var $83226b83a5307e7b$export$d00e1c48fb621173 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    compact: $83226b83a5307e7b$export$8e16b83750b44988,
    separate: $83226b83a5307e7b$export$709f6946f4e97408,
    filter: $83226b83a5307e7b$export$ec7439dc64f73058,
    filterMap: $83226b83a5307e7b$export$e8609d6e184911e6,
    partition: $83226b83a5307e7b$export$8d112ad5a197e16a,
    partitionMap: $83226b83a5307e7b$export$f721fb25a1c72a8d
};
var $83226b83a5307e7b$export$c29a647071e542ec = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    mapWithIndex: $83226b83a5307e7b$export$45e3e46323e6d66c,
    compact: $83226b83a5307e7b$export$8e16b83750b44988,
    separate: $83226b83a5307e7b$export$709f6946f4e97408,
    filter: $83226b83a5307e7b$export$ec7439dc64f73058,
    filterMap: $83226b83a5307e7b$export$e8609d6e184911e6,
    partition: $83226b83a5307e7b$export$8d112ad5a197e16a,
    partitionMap: $83226b83a5307e7b$export$f721fb25a1c72a8d,
    filterMapWithIndex: $83226b83a5307e7b$export$ac207938ecd8ddc4,
    filterWithIndex: $83226b83a5307e7b$export$560430393fed15de,
    partitionMapWithIndex: $83226b83a5307e7b$export$18034ec93490e9d2,
    partitionWithIndex: $83226b83a5307e7b$export$31601036bfbf1c76
};
var $83226b83a5307e7b$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $83226b83a5307e7b$export$9156e739aa33e19f,
        map: $83226b83a5307e7b$export$a0135aecf4a782ab,
        reduce: $83226b83a5307e7b$export$8eef5fdba9512999(O),
        foldMap: $83226b83a5307e7b$export$11b0d0e0b70641d9(O),
        reduceRight: $83226b83a5307e7b$export$ec882fc9def9e5db(O),
        traverse: $83226b83a5307e7b$export$b3c6f3d9661cffba(O),
        sequence: $83226b83a5307e7b$export$5d141086b2c0bc6(O)
    };
};
var $83226b83a5307e7b$export$46b81797a3375b8c = function(O) {
    return {
        URI: $83226b83a5307e7b$export$9156e739aa33e19f,
        map: $83226b83a5307e7b$export$a0135aecf4a782ab,
        mapWithIndex: $83226b83a5307e7b$export$45e3e46323e6d66c,
        reduce: $83226b83a5307e7b$export$8eef5fdba9512999(O),
        foldMap: $83226b83a5307e7b$export$11b0d0e0b70641d9(O),
        reduceRight: $83226b83a5307e7b$export$ec882fc9def9e5db(O),
        reduceWithIndex: $83226b83a5307e7b$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $83226b83a5307e7b$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $83226b83a5307e7b$export$3b7618311030b1af(O),
        traverse: $83226b83a5307e7b$export$b3c6f3d9661cffba(O),
        sequence: $83226b83a5307e7b$export$5d141086b2c0bc6(O),
        traverseWithIndex: $83226b83a5307e7b$var$_traverseWithIndex(O)
    };
};
var $83226b83a5307e7b$export$bb8ef26a634cac7b = function(O) {
    var T = $83226b83a5307e7b$export$4e0ffba11065d2c1(O);
    return {
        URI: $83226b83a5307e7b$export$9156e739aa33e19f,
        map: $83226b83a5307e7b$export$a0135aecf4a782ab,
        reduce: $83226b83a5307e7b$export$8eef5fdba9512999(O),
        foldMap: $83226b83a5307e7b$export$11b0d0e0b70641d9(O),
        reduceRight: $83226b83a5307e7b$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $83226b83a5307e7b$export$8e16b83750b44988,
        separate: $83226b83a5307e7b$export$709f6946f4e97408,
        filter: $83226b83a5307e7b$export$ec7439dc64f73058,
        filterMap: $83226b83a5307e7b$export$e8609d6e184911e6,
        partition: $83226b83a5307e7b$export$8d112ad5a197e16a,
        partitionMap: $83226b83a5307e7b$export$f721fb25a1c72a8d,
        wither: (0, $b333f781e2a19138$export$1f5c6f948d11a182)(T, $83226b83a5307e7b$export$4a21ac48141ac3c9),
        wilt: (0, $b333f781e2a19138$export$f4cb42390e44d1d2)(T, $83226b83a5307e7b$export$4a21ac48141ac3c9)
    };
};
var $83226b83a5307e7b$export$baca17b4aff42f82 = function(S) {
    var unionS = $83226b83a5307e7b$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $83226b83a5307e7b$export$c487aac9f4157837 = function(S) {
    return {
        concat: $83226b83a5307e7b$export$baca17b4aff42f82(S).concat,
        empty: $83226b83a5307e7b$export$6e22c362a0406a2c
    };
};
var $83226b83a5307e7b$export$d379a869a72e4055 = function(S) {
    var intersectionS = $83226b83a5307e7b$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $83226b83a5307e7b$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $83226b83a5307e7b$export$acaf96a27438246b(second)(first);
        }
    };
};
var $83226b83a5307e7b$export$41404b31838667c9 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5)
};
var $83226b83a5307e7b$export$e8f7d17aaff345cb = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$dd5ca3bcbad0b6af($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$e08bbf939bdc3250($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$3b7618311030b1af($be3ababca8b33dca$export$ee8aa95bfab51c5)
};
var $83226b83a5307e7b$export$a0202666c3bda011 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $83226b83a5307e7b$export$b3c6f3d9661cffba($be3ababca8b33dca$export$ee8aa95bfab51c5),
    sequence: $83226b83a5307e7b$export$49bb65c2ea163039
};
var $83226b83a5307e7b$export$bd7b528d8c36ec41 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    mapWithIndex: $83226b83a5307e7b$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$dd5ca3bcbad0b6af($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$e08bbf939bdc3250($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$3b7618311030b1af($be3ababca8b33dca$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $83226b83a5307e7b$export$b3c6f3d9661cffba($be3ababca8b33dca$export$ee8aa95bfab51c5),
    sequence: $83226b83a5307e7b$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $83226b83a5307e7b$var$_traverseWithIndex($be3ababca8b33dca$export$ee8aa95bfab51c5)
};
var $83226b83a5307e7b$var$_wither = /*#__PURE__*/ (0, $b333f781e2a19138$export$1f5c6f948d11a182)($83226b83a5307e7b$export$a0202666c3bda011, $83226b83a5307e7b$export$4a21ac48141ac3c9);
var $83226b83a5307e7b$var$_wilt = /*#__PURE__*/ (0, $b333f781e2a19138$export$f4cb42390e44d1d2)($83226b83a5307e7b$export$a0202666c3bda011, $83226b83a5307e7b$export$4a21ac48141ac3c9);
var $83226b83a5307e7b$export$748d317b4c426f96 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $83226b83a5307e7b$export$b3c6f3d9661cffba($be3ababca8b33dca$export$ee8aa95bfab51c5),
    sequence: $83226b83a5307e7b$export$49bb65c2ea163039,
    compact: $83226b83a5307e7b$export$8e16b83750b44988,
    separate: $83226b83a5307e7b$export$709f6946f4e97408,
    filter: $83226b83a5307e7b$export$ec7439dc64f73058,
    filterMap: $83226b83a5307e7b$export$e8609d6e184911e6,
    partition: $83226b83a5307e7b$export$8d112ad5a197e16a,
    partitionMap: $83226b83a5307e7b$export$f721fb25a1c72a8d,
    wither: $83226b83a5307e7b$var$_wither,
    wilt: $83226b83a5307e7b$var$_wilt
};
var $83226b83a5307e7b$export$9f200c4466975173 = $83226b83a5307e7b$export$ff82449ce381c54a;
function $83226b83a5307e7b$export$5a15a386532a5ea4(k, r) {
    return $54ef96f182e81a75$export$a4f4bb6b1453fff5.call(r === undefined ? this : r, k);
}
var $83226b83a5307e7b$export$74b9182b22de2bc1 = {
    URI: $83226b83a5307e7b$export$9156e739aa33e19f,
    map: $83226b83a5307e7b$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $83226b83a5307e7b$export$8eef5fdba9512999($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $83226b83a5307e7b$export$11b0d0e0b70641d9($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $83226b83a5307e7b$export$ec882fc9def9e5db($be3ababca8b33dca$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $83226b83a5307e7b$export$b3c6f3d9661cffba($be3ababca8b33dca$export$ee8aa95bfab51c5),
    sequence: $83226b83a5307e7b$export$49bb65c2ea163039,
    compact: $83226b83a5307e7b$export$8e16b83750b44988,
    separate: $83226b83a5307e7b$export$709f6946f4e97408,
    filter: $83226b83a5307e7b$export$ec7439dc64f73058,
    filterMap: $83226b83a5307e7b$export$e8609d6e184911e6,
    partition: $83226b83a5307e7b$export$8d112ad5a197e16a,
    partitionMap: $83226b83a5307e7b$export$f721fb25a1c72a8d,
    mapWithIndex: $83226b83a5307e7b$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$dd5ca3bcbad0b6af($be3ababca8b33dca$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$e08bbf939bdc3250($be3ababca8b33dca$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $83226b83a5307e7b$export$3b7618311030b1af($be3ababca8b33dca$export$ee8aa95bfab51c5),
    filterMapWithIndex: $83226b83a5307e7b$export$ac207938ecd8ddc4,
    filterWithIndex: $83226b83a5307e7b$export$560430393fed15de,
    partitionMapWithIndex: $83226b83a5307e7b$export$18034ec93490e9d2,
    partitionWithIndex: $83226b83a5307e7b$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $83226b83a5307e7b$var$_traverseWithIndex($be3ababca8b33dca$export$ee8aa95bfab51c5),
    wither: $83226b83a5307e7b$var$_wither,
    wilt: $83226b83a5307e7b$var$_wilt
};







/**
 * @since 2.0.0
 */ var $fd90eeabd2d59d9f$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};








var $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4 = $54ef96f182e81a75$export$eabcd2c8791e7bf4;
var $27fffa2a8aeaf6ce$export$79ffe56a765070d2 = $54ef96f182e81a75$export$79ffe56a765070d2;
var $27fffa2a8aeaf6ce$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, function(ma, f) {
    return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $27fffa2a8aeaf6ce$var$_map = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$871de8747c9eaa88(f));
};
var $27fffa2a8aeaf6ce$var$_ap = function(fab, fa) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fab, $27fffa2a8aeaf6ce$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $27fffa2a8aeaf6ce$var$_reduce = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $27fffa2a8aeaf6ce$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $27fffa2a8aeaf6ce$export$b66cdc0497d8a99a(M);
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $27fffa2a8aeaf6ce$var$_reduceRight = function(fa, b, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$7fef8bcdbb34f435(b, f));
};
var $27fffa2a8aeaf6ce$var$_traverse = function(F) {
    var traverseF = $27fffa2a8aeaf6ce$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(ta, traverseF(f));
    };
};
var $27fffa2a8aeaf6ce$var$_bimap = function(fa, f, g) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$eb54baf0b342cb1d(f, g));
};
var $27fffa2a8aeaf6ce$var$_mapLeft = function(fa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $27fffa2a8aeaf6ce$var$_alt = function(fa, that) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(fa, $27fffa2a8aeaf6ce$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $27fffa2a8aeaf6ce$var$_extend = function(wa, f) {
    return (0, $ee6b3436e10e8e67$export$a4627e546088548d)(wa, $27fffa2a8aeaf6ce$export$8b58be045bf06082(f));
};
var $27fffa2a8aeaf6ce$var$_chainRec = function(a, f) {
    return (0, $fd90eeabd2d59d9f$export$2e586eaa876dd2fd)(f(a), function(e) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(e) ? $27fffa2a8aeaf6ce$export$79ffe56a765070d2($27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(e.left)) : $27fffa2a8aeaf6ce$export$d649b6842e09f2b(e.right) ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(f(e.right.left)) : $27fffa2a8aeaf6ce$export$79ffe56a765070d2($27fffa2a8aeaf6ce$export$79ffe56a765070d2(e.right.right));
    });
};
var $27fffa2a8aeaf6ce$export$9156e739aa33e19f = 'Either';
var $27fffa2a8aeaf6ce$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $27fffa2a8aeaf6ce$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($27fffa2a8aeaf6ce$export$d649b6842e09f2b(x) ? $27fffa2a8aeaf6ce$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $27fffa2a8aeaf6ce$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $27fffa2a8aeaf6ce$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(y) ? x : $27fffa2a8aeaf6ce$export$d649b6842e09f2b(x) ? y : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $27fffa2a8aeaf6ce$export$cfae3069ac05ff4c = function(M) {
    var empty = $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(ma, ma) : $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma.right) ? (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.right.left), empty) : (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(empty, $27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $27fffa2a8aeaf6ce$export$a4e870b0a57ec14e = function(M) {
    var empty = $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(M.empty);
    var _a = $27fffa2a8aeaf6ce$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(ma, ma) : p(ma.right) ? (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(empty, $27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.right)) : (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        map: $27fffa2a8aeaf6ce$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma)) return (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(ma, ma);
            var e = f(ma.right);
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(e) ? (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)($27fffa2a8aeaf6ce$export$79ffe56a765070d2(e.left), empty) : (0, $4ddd06d7371e8509$export$beaabdf62f4a639d)(empty, $27fffa2a8aeaf6ce$export$79ffe56a765070d2(e.right));
        }
    };
};
var $27fffa2a8aeaf6ce$export$bb8ef26a634cac7b = function(M) {
    var F_ = $27fffa2a8aeaf6ce$export$a4e870b0a57ec14e(M);
    var C = $27fffa2a8aeaf6ce$export$cfae3069ac05ff4c(M);
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        map: $27fffa2a8aeaf6ce$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $27fffa2a8aeaf6ce$var$_traverse,
        sequence: $27fffa2a8aeaf6ce$export$49bb65c2ea163039,
        reduce: $27fffa2a8aeaf6ce$var$_reduce,
        foldMap: $27fffa2a8aeaf6ce$var$_foldMap,
        reduceRight: $27fffa2a8aeaf6ce$var$_reduceRight,
        wither: (0, $b333f781e2a19138$export$1f5c6f948d11a182)($27fffa2a8aeaf6ce$export$a0202666c3bda011, C),
        wilt: (0, $b333f781e2a19138$export$f4cb42390e44d1d2)($27fffa2a8aeaf6ce$export$a0202666c3bda011, C)
    };
};
var $27fffa2a8aeaf6ce$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        map: $27fffa2a8aeaf6ce$var$_map,
        ap: function(fab, fa) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fab) ? $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? fa : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608
    };
};
var $27fffa2a8aeaf6ce$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        map: $27fffa2a8aeaf6ce$var$_map,
        alt: function(me, that) {
            if ($27fffa2a8aeaf6ce$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ea) ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $27fffa2a8aeaf6ce$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? fa : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(f(fa.right));
    };
};
var $27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map
};
var $27fffa2a8aeaf6ce$export$6554612db691658e = (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, (0, $34b267f7755fe355$export$6554612db691658e)($27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61));
var $27fffa2a8aeaf6ce$export$9284b360ca18a0fd = (0, $34b267f7755fe355$export$9284b360ca18a0fd)($27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61);
var $27fffa2a8aeaf6ce$export$ba255e9e49e00608 = $27fffa2a8aeaf6ce$export$79ffe56a765070d2;
var $27fffa2a8aeaf6ce$export$59a71046037e6c20 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608
};
var $27fffa2a8aeaf6ce$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fab) ? fab : $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? fa : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $27fffa2a8aeaf6ce$export$2f6ca3d3b1f80bf5 = $27fffa2a8aeaf6ce$export$321be6e231de8eac;
var $27fffa2a8aeaf6ce$export$efc21ddc6aeb363d = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap
};
var $27fffa2a8aeaf6ce$export$1279d2b7807629fd = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608
};
var $27fffa2a8aeaf6ce$export$f18d5acc27d70423 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16
};
var $27fffa2a8aeaf6ce$export$fb641926d034ac7d = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608,
    chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16
};
var $27fffa2a8aeaf6ce$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $27fffa2a8aeaf6ce$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $27fffa2a8aeaf6ce$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $27fffa2a8aeaf6ce$export$41404b31838667c9 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    reduce: $27fffa2a8aeaf6ce$var$_reduce,
    foldMap: $27fffa2a8aeaf6ce$var$_foldMap,
    reduceRight: $27fffa2a8aeaf6ce$var$_reduceRight
};
var $27fffa2a8aeaf6ce$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ta) ? F.of($27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $27fffa2a8aeaf6ce$export$79ffe56a765070d2);
        };
    };
};
var $27fffa2a8aeaf6ce$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? F.of($27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $27fffa2a8aeaf6ce$export$79ffe56a765070d2);
    };
};
var $27fffa2a8aeaf6ce$export$a0202666c3bda011 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    reduce: $27fffa2a8aeaf6ce$var$_reduce,
    foldMap: $27fffa2a8aeaf6ce$var$_foldMap,
    reduceRight: $27fffa2a8aeaf6ce$var$_reduceRight,
    traverse: $27fffa2a8aeaf6ce$var$_traverse,
    sequence: $27fffa2a8aeaf6ce$export$49bb65c2ea163039
};
var $27fffa2a8aeaf6ce$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(f(fa.left)) : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(g(fa.right));
    };
};
var $27fffa2a8aeaf6ce$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $27fffa2a8aeaf6ce$export$fd0fe42029639505 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    bimap: $27fffa2a8aeaf6ce$var$_bimap,
    mapLeft: $27fffa2a8aeaf6ce$var$_mapLeft
};
var $27fffa2a8aeaf6ce$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $27fffa2a8aeaf6ce$export$228be17d80722ab = $27fffa2a8aeaf6ce$export$1517cca7889d6aaa;
var $27fffa2a8aeaf6ce$export$25ba4469a069167 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    alt: $27fffa2a8aeaf6ce$var$_alt
};
var $27fffa2a8aeaf6ce$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(wa) ? wa : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(f(wa));
    };
};
var $27fffa2a8aeaf6ce$export$5b5dd0e212d2a5bc = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    extend: $27fffa2a8aeaf6ce$var$_extend
};
var $27fffa2a8aeaf6ce$export$be58f7327716329d = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16,
    chainRec: $27fffa2a8aeaf6ce$var$_chainRec
};
var $27fffa2a8aeaf6ce$export$8bf7aba4a9e09055 = $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4;
var $27fffa2a8aeaf6ce$export$5f956d47d0619c3a = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608,
    chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16,
    throwError: $27fffa2a8aeaf6ce$export$8bf7aba4a9e09055
};
var $27fffa2a8aeaf6ce$export$825ea6cb6fc48d49 = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    fromEither: (0, $ee6b3436e10e8e67$export$f0954fd7d5368655)
};
var $27fffa2a8aeaf6ce$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $1f0befb2747eca52$export$23f31c55d7162b91)($27fffa2a8aeaf6ce$export$825ea6cb6fc48d49);
var $27fffa2a8aeaf6ce$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $1f0befb2747eca52$export$172ec0a6ebfeb6fa)($27fffa2a8aeaf6ce$export$825ea6cb6fc48d49);
var $27fffa2a8aeaf6ce$export$d649b6842e09f2b = $54ef96f182e81a75$export$d649b6842e09f2b;
var $27fffa2a8aeaf6ce$export$a9d71693f0c1a85d = $54ef96f182e81a75$export$a9d71693f0c1a85d;
var $27fffa2a8aeaf6ce$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $27fffa2a8aeaf6ce$export$ccb09033cefa61e8 = $27fffa2a8aeaf6ce$export$2d55ea551c238330;
var $27fffa2a8aeaf6ce$export$4659b591c19bdf3d = $27fffa2a8aeaf6ce$export$2d55ea551c238330;
var $27fffa2a8aeaf6ce$export$93e2b83da34ff82a = $27fffa2a8aeaf6ce$export$4659b591c19bdf3d;
var $27fffa2a8aeaf6ce$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $27fffa2a8aeaf6ce$export$8832081647a02ee7 = $27fffa2a8aeaf6ce$export$d8a997ff0e6436f3;
var $27fffa2a8aeaf6ce$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $34b267f7755fe355$export$18c957606d8bdf09)($27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61);
var $27fffa2a8aeaf6ce$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$5f28d9feedcfd46e)($27fffa2a8aeaf6ce$export$efc21ddc6aeb363d);
var $27fffa2a8aeaf6ce$export$ac044f4aa9961a4f = $27fffa2a8aeaf6ce$export$5f28d9feedcfd46e;
var $27fffa2a8aeaf6ce$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$ed01bc59c3d06bf3)($27fffa2a8aeaf6ce$export$efc21ddc6aeb363d);
var $27fffa2a8aeaf6ce$export$8a00020751233172 = $27fffa2a8aeaf6ce$export$ed01bc59c3d06bf3;
var $27fffa2a8aeaf6ce$export$3f23594af5f37336 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$d1699a1bbdf17835)(2, $b00b894e7b37435b$export$3f23594af5f37336($27fffa2a8aeaf6ce$export$f18d5acc27d70423));
var $27fffa2a8aeaf6ce$export$2409099f1fc434fb = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$5b8affa63fc6df16((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $27fffa2a8aeaf6ce$export$bffa455ba8c619a6 = $27fffa2a8aeaf6ce$export$2409099f1fc434fb;
var $27fffa2a8aeaf6ce$export$ecd5e8ace626722c = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$8b58be045bf06082((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $27fffa2a8aeaf6ce$export$a907462f448b49f8 = /*#__PURE__*/ (0, $1f0befb2747eca52$export$a907462f448b49f8)($27fffa2a8aeaf6ce$export$825ea6cb6fc48d49);
var $27fffa2a8aeaf6ce$export$12d26179deb6a68a = /*#__PURE__*/ (0, $1f0befb2747eca52$export$12d26179deb6a68a)($27fffa2a8aeaf6ce$export$825ea6cb6fc48d49, $27fffa2a8aeaf6ce$export$f18d5acc27d70423);
var $27fffa2a8aeaf6ce$export$377cc334277e5c3c = $27fffa2a8aeaf6ce$export$12d26179deb6a68a;
/** @internal */ var $27fffa2a8aeaf6ce$var$_FromEither = {
    fromEither: $27fffa2a8aeaf6ce$export$825ea6cb6fc48d49.fromEither
};
var $27fffa2a8aeaf6ce$export$cd139e14432f317b = /*#__PURE__*/ $54ef96f182e81a75$export$cd139e14432f317b($27fffa2a8aeaf6ce$var$_FromEither);
var $27fffa2a8aeaf6ce$export$ea4a22f93200df79 = /*#__PURE__*/ $54ef96f182e81a75$export$ea4a22f93200df79($27fffa2a8aeaf6ce$var$_FromEither);
/** @internal */ var $27fffa2a8aeaf6ce$var$_FlatMap = {
    flatMap: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16
};
var $27fffa2a8aeaf6ce$export$1a0515933c5c84fe = /*#__PURE__*/ $54ef96f182e81a75$export$1a0515933c5c84fe($27fffa2a8aeaf6ce$var$_FromEither, $27fffa2a8aeaf6ce$var$_FlatMap);
var $27fffa2a8aeaf6ce$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $54ef96f182e81a75$export$b5f02b7beb8ed7d8($27fffa2a8aeaf6ce$var$_FromEither, $27fffa2a8aeaf6ce$var$_FlatMap);
var $27fffa2a8aeaf6ce$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $1f0befb2747eca52$export$30af8ca9498ddf5b)($27fffa2a8aeaf6ce$export$825ea6cb6fc48d49, $27fffa2a8aeaf6ce$export$f18d5acc27d70423);
var $27fffa2a8aeaf6ce$export$84511cf4503ec9dd = $27fffa2a8aeaf6ce$export$30af8ca9498ddf5b;
var $27fffa2a8aeaf6ce$export$b0e76d9850c64156 = function(ma) {
    return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? $27fffa2a8aeaf6ce$export$79ffe56a765070d2(ma.left) : $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(ma.right);
};
var $27fffa2a8aeaf6ce$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $27fffa2a8aeaf6ce$export$41d1a04d78e7b141 = $27fffa2a8aeaf6ce$export$efd845e0c87089a6;
var $27fffa2a8aeaf6ce$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(e) : $27fffa2a8aeaf6ce$export$79ffe56a765070d2(a);
    };
};
var $27fffa2a8aeaf6ce$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $27fffa2a8aeaf6ce$export$79ffe56a765070d2(f());
    } catch (e) {
        return $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $27fffa2a8aeaf6ce$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $27fffa2a8aeaf6ce$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $27fffa2a8aeaf6ce$export$c69ca7b73fad45e1 = function(e) {
    var from = $27fffa2a8aeaf6ce$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(f, from);
    };
};
var $27fffa2a8aeaf6ce$export$c81f992c08fd0bf3 = function(e) {
    var from = $27fffa2a8aeaf6ce$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $27fffa2a8aeaf6ce$export$5b8affa63fc6df16(from(f));
    };
};
var $27fffa2a8aeaf6ce$export$a0886ed3a572729f = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$ccb09033cefa61e8((0, $ee6b3436e10e8e67$export$f0954fd7d5368655), (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
function $27fffa2a8aeaf6ce$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $27fffa2a8aeaf6ce$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $27fffa2a8aeaf6ce$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $27fffa2a8aeaf6ce$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $27fffa2a8aeaf6ce$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$ba255e9e49e00608($54ef96f182e81a75$export$4de80339753b012b);
var $27fffa2a8aeaf6ce$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $34b267f7755fe355$export$7c052ae73f8acff0)($27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61);
var $27fffa2a8aeaf6ce$export$5d537b797c421217 = /*#__PURE__*/ (0, $34b267f7755fe355$export$5d537b797c421217)($27fffa2a8aeaf6ce$export$bd5b6bfc5fa2ee61);
var $27fffa2a8aeaf6ce$export$2385a24977818dd0 = /*#__PURE__*/ $b00b894e7b37435b$export$2385a24977818dd0($27fffa2a8aeaf6ce$export$f18d5acc27d70423);
var $27fffa2a8aeaf6ce$export$e0d5b1cbe98976d9 = $27fffa2a8aeaf6ce$export$2385a24977818dd0;
var $27fffa2a8aeaf6ce$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$8cbfc0239f42bb49)($27fffa2a8aeaf6ce$export$efc21ddc6aeb363d);
var $27fffa2a8aeaf6ce$export$5c01f27714264b3d = $27fffa2a8aeaf6ce$export$8cbfc0239f42bb49;
var $27fffa2a8aeaf6ce$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$ba255e9e49e00608($54ef96f182e81a75$export$6ca726a2417e0f3f);
var $27fffa2a8aeaf6ce$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $54ef96f182e81a75$export$5fd5031fecdacec3(as));
        if ($27fffa2a8aeaf6ce$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($27fffa2a8aeaf6ce$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $27fffa2a8aeaf6ce$export$79ffe56a765070d2(out);
    };
};
var $27fffa2a8aeaf6ce$export$d4e79db5dc14cc1 = function(f) {
    var g = $27fffa2a8aeaf6ce$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $54ef96f182e81a75$export$a978c53b4062a525(as) ? g(as) : $27fffa2a8aeaf6ce$export$c74b6e34b2b6efb0;
    };
};
var $27fffa2a8aeaf6ce$export$104a2841e9cbad06 = $27fffa2a8aeaf6ce$export$d4e79db5dc14cc1;
var $27fffa2a8aeaf6ce$export$64f39b2a2b79e1b1 = function(f) {
    return $27fffa2a8aeaf6ce$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $27fffa2a8aeaf6ce$export$d330b60315c14cd1 = /*#__PURE__*/ $27fffa2a8aeaf6ce$export$64f39b2a2b79e1b1((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
var $27fffa2a8aeaf6ce$export$8e5885f0163d737a = $27fffa2a8aeaf6ce$export$5b8affa63fc6df16;
var $27fffa2a8aeaf6ce$export$e08e3b67e392101e = $27fffa2a8aeaf6ce$export$5b8affa63fc6df16;
var $27fffa2a8aeaf6ce$export$e3821ef4970c339c = $27fffa2a8aeaf6ce$export$3f23594af5f37336;
var $27fffa2a8aeaf6ce$export$5de78197fc44b933 = $27fffa2a8aeaf6ce$export$3f23594af5f37336;
function $27fffa2a8aeaf6ce$export$27924e57e9afff7f(s, onError) {
    return $27fffa2a8aeaf6ce$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $27fffa2a8aeaf6ce$export$702e019c6853c7a = function(u, onError) {
    return $27fffa2a8aeaf6ce$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $27fffa2a8aeaf6ce$export$5f5be1bb6cd1fded = {
    URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
    map: $27fffa2a8aeaf6ce$var$_map,
    of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608,
    ap: $27fffa2a8aeaf6ce$var$_ap,
    chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16,
    reduce: $27fffa2a8aeaf6ce$var$_reduce,
    foldMap: $27fffa2a8aeaf6ce$var$_foldMap,
    reduceRight: $27fffa2a8aeaf6ce$var$_reduceRight,
    traverse: $27fffa2a8aeaf6ce$var$_traverse,
    sequence: $27fffa2a8aeaf6ce$export$49bb65c2ea163039,
    bimap: $27fffa2a8aeaf6ce$var$_bimap,
    mapLeft: $27fffa2a8aeaf6ce$var$_mapLeft,
    alt: $27fffa2a8aeaf6ce$var$_alt,
    extend: $27fffa2a8aeaf6ce$var$_extend,
    chainRec: $27fffa2a8aeaf6ce$var$_chainRec,
    throwError: $27fffa2a8aeaf6ce$export$8bf7aba4a9e09055
};
var $27fffa2a8aeaf6ce$export$18979a515d2a828e = /*#__PURE__*/ (0, $4e77e1f8d7cf5551$export$18979a515d2a828e)($27fffa2a8aeaf6ce$export$efc21ddc6aeb363d);
var $27fffa2a8aeaf6ce$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $375caf5928a03f48$export$c8e1a8ea383fd0ff)($27fffa2a8aeaf6ce$export$1279d2b7807629fd);
var $27fffa2a8aeaf6ce$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $4e77e1f8d7cf5551$export$18979a515d2a828e)($27fffa2a8aeaf6ce$export$d9540e18497e6036(SE))(SA);
};
var $27fffa2a8aeaf6ce$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $375caf5928a03f48$export$c8e1a8ea383fd0ff)($27fffa2a8aeaf6ce$export$d9540e18497e6036(SE))(MA);
};
function $27fffa2a8aeaf6ce$export$6843f928420ce3e4(SE) {
    var ap = $27fffa2a8aeaf6ce$export$d9540e18497e6036(SE).ap;
    var alt = $27fffa2a8aeaf6ce$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $27fffa2a8aeaf6ce$export$9156e739aa33e19f,
        _E: undefined,
        map: $27fffa2a8aeaf6ce$var$_map,
        of: $27fffa2a8aeaf6ce$export$ba255e9e49e00608,
        chain: $27fffa2a8aeaf6ce$export$5b8affa63fc6df16,
        bimap: $27fffa2a8aeaf6ce$var$_bimap,
        mapLeft: $27fffa2a8aeaf6ce$var$_mapLeft,
        reduce: $27fffa2a8aeaf6ce$var$_reduce,
        foldMap: $27fffa2a8aeaf6ce$var$_foldMap,
        reduceRight: $27fffa2a8aeaf6ce$var$_reduceRight,
        extend: $27fffa2a8aeaf6ce$var$_extend,
        traverse: $27fffa2a8aeaf6ce$var$_traverse,
        sequence: $27fffa2a8aeaf6ce$export$49bb65c2ea163039,
        chainRec: $27fffa2a8aeaf6ce$var$_chainRec,
        throwError: $27fffa2a8aeaf6ce$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}



var $71e2e12449623c93$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $71e2e12449623c93$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $71e2e12449623c93$export$d001ee9513dee7c1 = function(sa) {
    return $71e2e12449623c93$export$21cde5187c2605a3(sa.get, (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.reverseGet, (0, $ee6b3436e10e8e67$export$c983f826f44ff86)));
};
var $71e2e12449623c93$export$fde8c5b9dff57abc = function(sa) {
    return $71e2e12449623c93$export$e469dcfea9910464((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.get, $1ed8bdeb457e19d0$export$ad14ef4001db2bcd), sa.reverseGet);
};
var $71e2e12449623c93$export$4d3db894cf45abd5 = function(sa) {
    return $71e2e12449623c93$export$516e28dec6a4b6d4((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.get, $1ed8bdeb457e19d0$export$ad14ef4001db2bcd), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.reverseGet, (0, $ee6b3436e10e8e67$export$c983f826f44ff86)));
};
var $71e2e12449623c93$export$e55a826b3ba968d2 = function(sa) {
    return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $71e2e12449623c93$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $71e2e12449623c93$export$bae94c671b4dc75d = function(sa) {
    return $71e2e12449623c93$export$516e28dec6a4b6d4((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.get, $1ed8bdeb457e19d0$export$ad14ef4001db2bcd), sa.set);
};
var $71e2e12449623c93$export$e5de01c31c85830c = function(sa) {
    return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $71e2e12449623c93$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $71e2e12449623c93$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$e469dcfea9910464((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.getOption, $1ed8bdeb457e19d0$export$e08e3b67e392101e(ab.getOption)), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ab.reverseGet, sa.reverseGet));
    };
};
var $71e2e12449623c93$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$8e08893559c32e38($71e2e12449623c93$export$70f4d204f3bdc8bd(ab))($71e2e12449623c93$export$bae94c671b4dc75d(sa));
    };
};
var $71e2e12449623c93$export$a4b03755c6673298 = function() {
    return $71e2e12449623c93$export$21cde5187c2605a3((0, $ee6b3436e10e8e67$export$f0954fd7d5368655), (0, $ee6b3436e10e8e67$export$c983f826f44ff86));
};
var $71e2e12449623c93$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $71e2e12449623c93$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $71e2e12449623c93$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $71e2e12449623c93$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $71e2e12449623c93$export$62d1b5266563d2b6($71e2e12449623c93$export$ba8573d258bae607().at(key)));
    };
};
var $71e2e12449623c93$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $71e2e12449623c93$export$70f4d204f3bdc8bd = function(sa) {
    return $71e2e12449623c93$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $71e2e12449623c93$export$97725fa315d6412c(a)(sa);
    });
};
var $71e2e12449623c93$export$18564f4597667b6a = function(sa) {
    return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.getOption(s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $71e2e12449623c93$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $71e2e12449623c93$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.getOption(s), $1ed8bdeb457e19d0$export$871de8747c9eaa88(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $71e2e12449623c93$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $71e2e12449623c93$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(g(s), $1ed8bdeb457e19d0$export$8832081647a02ee7(function() {
                return s;
            }));
        };
    };
};
var $71e2e12449623c93$export$97725fa315d6412c = function(a) {
    return $71e2e12449623c93$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $71e2e12449623c93$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$8e08893559c32e38($71e2e12449623c93$export$bae94c671b4dc75d(ab))($71e2e12449623c93$export$70f4d204f3bdc8bd(sa));
    };
};
var $71e2e12449623c93$export$258cc98aa6d7d21b = function() {
    return $71e2e12449623c93$export$e469dcfea9910464($1ed8bdeb457e19d0$export$b601f49376b4621a, (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
var $71e2e12449623c93$export$8f316a2f03469694 = function(predicate) {
    return $71e2e12449623c93$export$e469dcfea9910464($1ed8bdeb457e19d0$export$23f31c55d7162b91(predicate), (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
var $71e2e12449623c93$export$782e8b2fe031f968 = function() {
    return $71e2e12449623c93$export$e469dcfea9910464((0, $ee6b3436e10e8e67$export$f0954fd7d5368655), $1ed8bdeb457e19d0$export$ad14ef4001db2bcd);
};
var $71e2e12449623c93$export$929e170fdd93186c = function() {
    return $71e2e12449623c93$export$e469dcfea9910464($1ed8bdeb457e19d0$export$80c878c9b1d77917, $27fffa2a8aeaf6ce$export$79ffe56a765070d2);
};
var $71e2e12449623c93$export$97ae81cf28b21f26 = function() {
    return $71e2e12449623c93$export$e469dcfea9910464(function(s) {
        return $27fffa2a8aeaf6ce$export$d649b6842e09f2b(s) ? $1ed8bdeb457e19d0$export$ad14ef4001db2bcd(s.left) : $1ed8bdeb457e19d0$export$f883a24d5edde77c;
    }, $27fffa2a8aeaf6ce$export$eabcd2c8791e7bf4);
};
var $71e2e12449623c93$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $71e2e12449623c93$export$a595a5197cc37264 = function(sa) {
    return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.getOption(s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $71e2e12449623c93$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(optional.getOption(s), $1ed8bdeb457e19d0$export$871de8747c9eaa88(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $71e2e12449623c93$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $71e2e12449623c93$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(g(s), $1ed8bdeb457e19d0$export$8832081647a02ee7(function() {
                return s;
            }));
        };
    };
};
var $71e2e12449623c93$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$516e28dec6a4b6d4((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.getOption, $1ed8bdeb457e19d0$export$e08e3b67e392101e(ab.getOption)), function(b) {
            return $71e2e12449623c93$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $71e2e12449623c93$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $71e2e12449623c93$export$8e08893559c32e38($71e2e12449623c93$export$bb0c054375ca4b0().index(i)));
    };
};
var $71e2e12449623c93$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $71e2e12449623c93$export$8e08893559c32e38($71e2e12449623c93$export$165af7b747e6b1f1().index(i)));
    };
};
var $71e2e12449623c93$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $71e2e12449623c93$export$8e08893559c32e38($71e2e12449623c93$export$3c3468aec3b83bbf().index(key)));
    };
};
var $71e2e12449623c93$export$220673392b48821b = function(predicate) {
    return $71e2e12449623c93$export$516e28dec6a4b6d4($6ec673d1158159b2$export$9a2f228bed5035c2(predicate), function(a) {
        return function(s) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)($6ec673d1158159b2$export$de3a4d4a0d731119(predicate)(s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                return s;
            }, function(i) {
                return $6ec673d1158159b2$export$9c0c6889b1fa9bfc(i, a, s);
            }));
        };
    });
};
var $71e2e12449623c93$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $71e2e12449623c93$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $71e2e12449623c93$export$cf29cfc68de9a659 = function(predicate) {
    return $71e2e12449623c93$export$516e28dec6a4b6d4($6ec673d1158159b2$export$9a2f228bed5035c2(predicate), function(a) {
        return function(as) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)($6ec673d1158159b2$export$de3a4d4a0d731119(predicate)(as), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                return as;
            }, function(i) {
                return $71e2e12449623c93$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $71e2e12449623c93$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $71e2e12449623c93$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $71e2e12449623c93$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $ee6b3436e10e8e67$export$f0954fd7d5368655),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $71e2e12449623c93$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $71e2e12449623c93$export$126b5a87c58d3f9c(T) {
    return function() {
        return $71e2e12449623c93$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $71e2e12449623c93$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $71e2e12449623c93$export$35db6fcbd934c57(T) {
    return $71e2e12449623c93$export$2c68ab81171b083f($71e2e12449623c93$export$126b5a87c58d3f9c(T)());
}
var $71e2e12449623c93$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $71e2e12449623c93$export$bb0c054375ca4b0 = function() {
    return $71e2e12449623c93$export$b610b8812bbcded9(function(i) {
        return $71e2e12449623c93$export$516e28dec6a4b6d4(function(as) {
            return $6ec673d1158159b2$export$dfc7155ac0343b8(i, as);
        }, function(a) {
            return function(as) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)($6ec673d1158159b2$export$dfc7155ac0343b8(i, as), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return as;
                }, function() {
                    return $6ec673d1158159b2$export$9c0c6889b1fa9bfc(i, a, as);
                }));
            };
        });
    });
};
var $71e2e12449623c93$export$165af7b747e6b1f1 = function() {
    return $71e2e12449623c93$export$b610b8812bbcded9(function(i) {
        return $71e2e12449623c93$export$516e28dec6a4b6d4(function(as) {
            return $6ec673d1158159b2$export$dfc7155ac0343b8(i, as);
        }, function(a) {
            return function(as) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)($6ec673d1158159b2$export$dfc7155ac0343b8(i, as), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return as;
                }, function() {
                    return $71e2e12449623c93$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $71e2e12449623c93$export$3c3468aec3b83bbf = function() {
    return $71e2e12449623c93$export$b610b8812bbcded9(function(k) {
        return $71e2e12449623c93$export$516e28dec6a4b6d4(function(r) {
            return $83226b83a5307e7b$export$dfc7155ac0343b8(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $1ed8bdeb457e19d0$export$e56af863d5645d5f($83226b83a5307e7b$export$dfc7155ac0343b8(k, r))) return r;
                return $83226b83a5307e7b$export$9f200c4466975173(k, a)(r);
            };
        });
    });
};
var $71e2e12449623c93$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $71e2e12449623c93$export$ba8573d258bae607() {
    return $71e2e12449623c93$export$493d36ec626b6698(function(key) {
        return $71e2e12449623c93$export$21cde5187c2605a3(function(r) {
            return $83226b83a5307e7b$export$dfc7155ac0343b8(key, r);
        }, $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
            return $83226b83a5307e7b$export$90f9093465da3136(key);
        }, function(a) {
            return $83226b83a5307e7b$export$9f200c4466975173(key, a);
        }));
    });
}
$71e2e12449623c93$exports["iso"] = $71e2e12449623c93$export$1aba8f741a0eae06;
$71e2e12449623c93$exports["isoAsLens"] = $71e2e12449623c93$export$d001ee9513dee7c1;
$71e2e12449623c93$exports["lens"] = $71e2e12449623c93$export$21cde5187c2605a3;
$71e2e12449623c93$exports["isoAsPrism"] = $71e2e12449623c93$export$fde8c5b9dff57abc;
$71e2e12449623c93$exports["prism"] = $71e2e12449623c93$export$e469dcfea9910464;
$71e2e12449623c93$exports["isoAsOptional"] = $71e2e12449623c93$export$4d3db894cf45abd5;
$71e2e12449623c93$exports["optional"] = $71e2e12449623c93$export$516e28dec6a4b6d4;
$71e2e12449623c93$exports["isoAsTraversal"] = $71e2e12449623c93$export$e55a826b3ba968d2;
$71e2e12449623c93$exports["traversal"] = $71e2e12449623c93$export$8666ce7a134c2314;
$71e2e12449623c93$exports["lensAsOptional"] = $71e2e12449623c93$export$bae94c671b4dc75d;
$71e2e12449623c93$exports["lensAsTraversal"] = $71e2e12449623c93$export$e5de01c31c85830c;
$71e2e12449623c93$exports["lensComposeLens"] = $71e2e12449623c93$export$62d1b5266563d2b6;
$71e2e12449623c93$exports["prismComposePrism"] = $71e2e12449623c93$export$af9c087537c23eb1;
$71e2e12449623c93$exports["lensComposePrism"] = $71e2e12449623c93$export$ffffe1ca21811d93;
$71e2e12449623c93$exports["optionalComposeOptional"] = $71e2e12449623c93$export$8e08893559c32e38;
$71e2e12449623c93$exports["prismAsOptional"] = $71e2e12449623c93$export$70f4d204f3bdc8bd;
$71e2e12449623c93$exports["lensId"] = $71e2e12449623c93$export$a4b03755c6673298;
$71e2e12449623c93$exports["lensProp"] = $71e2e12449623c93$export$a6ba95b157529836;
$71e2e12449623c93$exports["lensProps"] = $71e2e12449623c93$export$c19575454e66bf5f;
$71e2e12449623c93$exports["lensComponent"] = $71e2e12449623c93$export$103f2a6258fae742;
$71e2e12449623c93$exports["lensAtKey"] = $71e2e12449623c93$export$fc68a3bfc89f0b98;
$71e2e12449623c93$exports["atReadonlyRecord"] = $71e2e12449623c93$export$ba8573d258bae607;
$71e2e12449623c93$exports["prismSet"] = $71e2e12449623c93$export$97725fa315d6412c;
$71e2e12449623c93$exports["prismAsTraversal"] = $71e2e12449623c93$export$18564f4597667b6a;
$71e2e12449623c93$exports["prismModifyOption"] = $71e2e12449623c93$export$ddb3ff54eaa1c530;
$71e2e12449623c93$exports["prismModify"] = $71e2e12449623c93$export$f545e0bcbe4b5ea7;
$71e2e12449623c93$exports["prismComposeLens"] = $71e2e12449623c93$export$dad01448ef670850;
$71e2e12449623c93$exports["prismFromNullable"] = $71e2e12449623c93$export$258cc98aa6d7d21b;
$71e2e12449623c93$exports["prismFromPredicate"] = $71e2e12449623c93$export$8f316a2f03469694;
$71e2e12449623c93$exports["prismSome"] = $71e2e12449623c93$export$782e8b2fe031f968;
$71e2e12449623c93$exports["prismRight"] = $71e2e12449623c93$export$929e170fdd93186c;
$71e2e12449623c93$exports["prismLeft"] = $71e2e12449623c93$export$97ae81cf28b21f26;
$71e2e12449623c93$exports["optionalAsTraversal"] = $71e2e12449623c93$export$a595a5197cc37264;
$71e2e12449623c93$exports["optionalModifyOption"] = $71e2e12449623c93$export$48aae8aebe6d3ee9;
$71e2e12449623c93$exports["optionalModify"] = $71e2e12449623c93$export$6d575f282c3c1d48;
$71e2e12449623c93$exports["optionalIndex"] = $71e2e12449623c93$export$47ac94aa95300c6f;
$71e2e12449623c93$exports["indexReadonlyArray"] = $71e2e12449623c93$export$bb0c054375ca4b0;
$71e2e12449623c93$exports["optionalIndexNonEmpty"] = $71e2e12449623c93$export$83e62439a4d30c4c;
$71e2e12449623c93$exports["indexReadonlyNonEmptyArray"] = $71e2e12449623c93$export$165af7b747e6b1f1;
$71e2e12449623c93$exports["optionalKey"] = $71e2e12449623c93$export$a6c26e1663200bf4;
$71e2e12449623c93$exports["indexReadonlyRecord"] = $71e2e12449623c93$export$3c3468aec3b83bbf;
$71e2e12449623c93$exports["optionalFindFirst"] = $71e2e12449623c93$export$220673392b48821b;
$71e2e12449623c93$exports["optionalFindFirstNonEmpty"] = $71e2e12449623c93$export$cf29cfc68de9a659;
$71e2e12449623c93$exports["traversalComposeTraversal"] = $71e2e12449623c93$export$2c68ab81171b083f;
$71e2e12449623c93$exports["ApplicativeIdentity"] = $71e2e12449623c93$export$7c4912ca011fa00e;
$71e2e12449623c93$exports["fromTraversable"] = $71e2e12449623c93$export$126b5a87c58d3f9c;
$71e2e12449623c93$exports["traversalTraverse"] = $71e2e12449623c93$export$35db6fcbd934c57;
$71e2e12449623c93$exports["index"] = $71e2e12449623c93$export$b610b8812bbcded9;
$71e2e12449623c93$exports["at"] = $71e2e12449623c93$export$493d36ec626b6698;


var $ad80c37a0e1ff8b2$export$493d36ec626b6698 = $71e2e12449623c93$export$493d36ec626b6698;
var $ad80c37a0e1ff8b2$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $ad80c37a0e1ff8b2$export$493d36ec626b6698(function(i) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(iso, $71e2e12449623c93$export$d001ee9513dee7c1, $71e2e12449623c93$export$62d1b5266563d2b6(sia.at(i)));
        });
    };
};
var $ad80c37a0e1ff8b2$export$ba8573d258bae607 = $71e2e12449623c93$export$ba8573d258bae607;
var $ad80c37a0e1ff8b2$export$3d6583cb45ca961e = function(E) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    var deleteAtE = $75d6b9af8d6f69d5$export$90f9093465da3136(E);
    var insertAtE = $75d6b9af8d6f69d5$export$9f200c4466975173(E);
    return function() {
        return $ad80c37a0e1ff8b2$export$493d36ec626b6698(function(key) {
            return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
                return lookupE(key, s);
            }, $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $ad80c37a0e1ff8b2$export$388a7d8e51ea972f = function(E) {
    var elemE = $8ef2d0b67d58fe22$export$5bf96401662340b7(E);
    var insertE = $8ef2d0b67d58fe22$export$21a5ca8aa77d35ff(E);
    var removeE = $8ef2d0b67d58fe22$export$cd7f480d6b8286c3(E);
    return $ad80c37a0e1ff8b2$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $71e2e12449623c93$export$21cde5187c2605a3(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $ad80c37a0e1ff8b2$export$1cfc761eca4929a9 = $71e2e12449623c93$export$ba8573d258bae607;





var $adab9da79892f477$export$1aba8f741a0eae06 = $71e2e12449623c93$exports.iso;
var $adab9da79892f477$export$d560c7e4a29451c2 = function() {
    return $adab9da79892f477$export$1aba8f741a0eae06((0, $ee6b3436e10e8e67$export$f0954fd7d5368655), (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
var $adab9da79892f477$export$ba6dbfc52e933ec = $71e2e12449623c93$exports.isoAsLens;
var $adab9da79892f477$export$6963d4cf5712e556 = $71e2e12449623c93$exports.isoAsPrism;
var $adab9da79892f477$export$81a625dd455a09de = $71e2e12449623c93$exports.isoAsOptional;
var $adab9da79892f477$export$ef38eac73d6f828f = $71e2e12449623c93$exports.isoAsTraversal;
var $adab9da79892f477$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $adab9da79892f477$export$1aba8f741a0eae06((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(sa.get, ab.get), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ab.reverseGet, sa.reverseGet));
    };
};
var $adab9da79892f477$export$220ad92d18dabdd7 = $adab9da79892f477$export$f672e0b6f7222cd7;
var $adab9da79892f477$export$f5c3e419c6a355ce = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ba6dbfc52e933ec, $71e2e12449623c93$exports.lensComposeLens(ab));
};
var $adab9da79892f477$export$c1dc05e399870f6 = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$6963d4cf5712e556, $71e2e12449623c93$exports.prismComposePrism(ab));
};
var $adab9da79892f477$export$323f76c400675c8b = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalComposeOptional(ab));
};
var $adab9da79892f477$export$aa978f69e007229f = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalComposeTraversal(ab));
};
var $adab9da79892f477$export$66c1ae025e96b4bc = function(sa) {
    return $adab9da79892f477$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $adab9da79892f477$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $adab9da79892f477$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $adab9da79892f477$export$b601f49376b4621a = function(sa) {
    return $adab9da79892f477$export$c1dc05e399870f6($71e2e12449623c93$exports.prismFromNullable())(sa);
};
function $adab9da79892f477$export$3dea766d36a8935f(predicate) {
    return $adab9da79892f477$export$c1dc05e399870f6($71e2e12449623c93$exports.prismFromPredicate(predicate));
}
var $adab9da79892f477$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ba6dbfc52e933ec, $71e2e12449623c93$exports.lensProp(prop));
};
var $adab9da79892f477$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ba6dbfc52e933ec, $71e2e12449623c93$exports.lensProps.apply($71e2e12449623c93$exports, props));
};
var $adab9da79892f477$export$d8556a2a8f973135 = function(prop) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ba6dbfc52e933ec, $71e2e12449623c93$exports.lensComponent(prop));
};
var $adab9da79892f477$export$b610b8812bbcded9 = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalIndex(i));
};
var $adab9da79892f477$export$84162b00c25b711c = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalIndexNonEmpty(i));
};
var $adab9da79892f477$export$df61b30b684217c0 = function(key) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalKey(key));
};
var $adab9da79892f477$export$976574c443b9185b = function(key) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ba6dbfc52e933ec, $71e2e12449623c93$exports.lensAtKey(key));
};
var $adab9da79892f477$export$ad14ef4001db2bcd = /*#__PURE__*/ $adab9da79892f477$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$exports.prismSome());
var $adab9da79892f477$export$79ffe56a765070d2 = /*#__PURE__*/ $adab9da79892f477$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$exports.prismRight());
var $adab9da79892f477$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $adab9da79892f477$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$exports.prismLeft());
function $adab9da79892f477$export$df3f009e3d155b20(T) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($adab9da79892f477$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalTraverse(T));
}
function $adab9da79892f477$export$9a2f228bed5035c2(predicate) {
    return $adab9da79892f477$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirst(predicate));
}
function $adab9da79892f477$export$28e1f787311e0a21(predicate) {
    return $adab9da79892f477$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirstNonEmpty(predicate));
}
var $adab9da79892f477$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $adab9da79892f477$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $adab9da79892f477$var$imap_ = function(ea, ab, ba) {
    return $adab9da79892f477$export$1aba8f741a0eae06((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ea.get, ab), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ba, ea.reverseGet));
};
var $adab9da79892f477$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $adab9da79892f477$export$dbdf692cc5737cfd = {
    URI: $adab9da79892f477$export$9156e739aa33e19f,
    imap: $adab9da79892f477$var$imap_
};
var $adab9da79892f477$export$67666a3fb7d250d8 = {
    URI: $adab9da79892f477$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $adab9da79892f477$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $adab9da79892f477$export$3a8840c5b2ecf003 = {
    URI: $adab9da79892f477$export$9156e739aa33e19f,
    compose: $adab9da79892f477$export$67666a3fb7d250d8.compose,
    id: $adab9da79892f477$export$d560c7e4a29451c2
};


/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 



var $d5e4bdb075616999$export$b610b8812bbcded9 = $71e2e12449623c93$export$b610b8812bbcded9;
var $d5e4bdb075616999$export$c4dd3e639c7af330 = function(at) {
    return $d5e4bdb075616999$export$b610b8812bbcded9(function(i) {
        return $71e2e12449623c93$export$ffffe1ca21811d93($71e2e12449623c93$export$782e8b2fe031f968())(at.at(i));
    });
};
var $d5e4bdb075616999$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $d5e4bdb075616999$export$b610b8812bbcded9(function(i) {
            return (0, $37dbc87cd4b95810$export$a4627e546088548d)(iso, $71e2e12449623c93$export$4d3db894cf45abd5, $71e2e12449623c93$export$8e08893559c32e38(sia.index(i)));
        });
    };
};
var $d5e4bdb075616999$export$bb0c054375ca4b0 = $71e2e12449623c93$export$bb0c054375ca4b0;
var $d5e4bdb075616999$export$165af7b747e6b1f1 = $71e2e12449623c93$export$165af7b747e6b1f1;
var $d5e4bdb075616999$export$3c3468aec3b83bbf = $71e2e12449623c93$export$3c3468aec3b83bbf;
var $d5e4bdb075616999$export$92da200d6ddb6846 = function(E) {
    var lookupE = $75d6b9af8d6f69d5$export$dfc7155ac0343b8(E);
    var insertAtE = $75d6b9af8d6f69d5$export$9f200c4466975173(E);
    return function() {
        return $d5e4bdb075616999$export$b610b8812bbcded9(function(key) {
            return $71e2e12449623c93$export$516e28dec6a4b6d4(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $37dbc87cd4b95810$export$a4627e546088548d)(lookupE(key, s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $d5e4bdb075616999$export$2cd1c249765cd0a4 = $71e2e12449623c93$export$bb0c054375ca4b0;
var $d5e4bdb075616999$export$720226bf1ef46cb2 = $71e2e12449623c93$export$3c3468aec3b83bbf;


var $a44c59c252525d57$exports = {};



var $a44c59c252525d57$export$21cde5187c2605a3 = $71e2e12449623c93$export$21cde5187c2605a3;
var $a44c59c252525d57$export$d560c7e4a29451c2 = $71e2e12449623c93$export$a4b03755c6673298;
var $a44c59c252525d57$export$81a625dd455a09de = $71e2e12449623c93$export$bae94c671b4dc75d;
var $a44c59c252525d57$export$ef38eac73d6f828f = $71e2e12449623c93$export$e5de01c31c85830c;
var $a44c59c252525d57$export$f672e0b6f7222cd7 = $71e2e12449623c93$export$62d1b5266563d2b6;
var $a44c59c252525d57$export$f5c3e419c6a355ce = $a44c59c252525d57$export$f672e0b6f7222cd7;
var $a44c59c252525d57$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$export$d001ee9513dee7c1, $a44c59c252525d57$export$f672e0b6f7222cd7);
var $a44c59c252525d57$export$c1dc05e399870f6 = $71e2e12449623c93$export$ffffe1ca21811d93;
var $a44c59c252525d57$export$323f76c400675c8b = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$81a625dd455a09de, $71e2e12449623c93$export$8e08893559c32e38(ab));
};
var $a44c59c252525d57$export$aa978f69e007229f = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$ef38eac73d6f828f, $71e2e12449623c93$export$2c68ab81171b083f(ab));
};
var $a44c59c252525d57$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $a44c59c252525d57$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $a44c59c252525d57$export$b601f49376b4621a = function(sa) {
    return $a44c59c252525d57$export$c1dc05e399870f6($71e2e12449623c93$export$258cc98aa6d7d21b())(sa);
};
function $a44c59c252525d57$export$3dea766d36a8935f(predicate) {
    return $a44c59c252525d57$export$c1dc05e399870f6($71e2e12449623c93$export$8f316a2f03469694(predicate));
}
var $a44c59c252525d57$export$977f3f6a9323c0f6 = $71e2e12449623c93$export$a6ba95b157529836;
var $a44c59c252525d57$export$8128bb6492cf3de7 = $71e2e12449623c93$export$c19575454e66bf5f;
var $a44c59c252525d57$export$d8556a2a8f973135 = $71e2e12449623c93$export$103f2a6258fae742;
var $a44c59c252525d57$export$b610b8812bbcded9 = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$81a625dd455a09de, $71e2e12449623c93$export$47ac94aa95300c6f(i));
};
var $a44c59c252525d57$export$84162b00c25b711c = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$81a625dd455a09de, $71e2e12449623c93$export$83e62439a4d30c4c(i));
};
var $a44c59c252525d57$export$df61b30b684217c0 = function(key) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$81a625dd455a09de, $71e2e12449623c93$export$a6c26e1663200bf4(key));
};
var $a44c59c252525d57$export$976574c443b9185b = $71e2e12449623c93$export$fc68a3bfc89f0b98;
var $a44c59c252525d57$export$ad14ef4001db2bcd = /*#__PURE__*/ $a44c59c252525d57$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$export$782e8b2fe031f968());
var $a44c59c252525d57$export$79ffe56a765070d2 = /*#__PURE__*/ $a44c59c252525d57$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$export$929e170fdd93186c());
var $a44c59c252525d57$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $a44c59c252525d57$export$c1dc05e399870f6(/*#__PURE__*/ $71e2e12449623c93$export$97ae81cf28b21f26());
function $a44c59c252525d57$export$df3f009e3d155b20(T) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($a44c59c252525d57$export$ef38eac73d6f828f, $71e2e12449623c93$export$35db6fcbd934c57(T));
}
function $a44c59c252525d57$export$9a2f228bed5035c2(predicate) {
    return $a44c59c252525d57$export$323f76c400675c8b($71e2e12449623c93$export$220673392b48821b(predicate));
}
function $a44c59c252525d57$export$28e1f787311e0a21(predicate) {
    return $a44c59c252525d57$export$323f76c400675c8b($71e2e12449623c93$export$cf29cfc68de9a659(predicate));
}
var $a44c59c252525d57$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $a44c59c252525d57$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $a44c59c252525d57$var$imap_ = function(ea, ab, ba) {
    return $a44c59c252525d57$export$21cde5187c2605a3((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ea.get, ab), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ba, ea.set));
};
var $a44c59c252525d57$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $a44c59c252525d57$export$dbdf692cc5737cfd = {
    URI: $a44c59c252525d57$export$9156e739aa33e19f,
    imap: $a44c59c252525d57$var$imap_
};
var $a44c59c252525d57$export$67666a3fb7d250d8 = {
    URI: $a44c59c252525d57$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $a44c59c252525d57$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $a44c59c252525d57$export$3a8840c5b2ecf003 = {
    URI: $a44c59c252525d57$export$9156e739aa33e19f,
    compose: $a44c59c252525d57$export$67666a3fb7d250d8.compose,
    id: $a44c59c252525d57$export$d560c7e4a29451c2
};
$a44c59c252525d57$exports["lens"] = $a44c59c252525d57$export$21cde5187c2605a3;
$a44c59c252525d57$exports["id"] = $a44c59c252525d57$export$d560c7e4a29451c2;
$a44c59c252525d57$exports["asOptional"] = $a44c59c252525d57$export$81a625dd455a09de;
$a44c59c252525d57$exports["asTraversal"] = $a44c59c252525d57$export$ef38eac73d6f828f;
$a44c59c252525d57$exports["compose"] = $a44c59c252525d57$export$f672e0b6f7222cd7;
$a44c59c252525d57$exports["composeLens"] = $a44c59c252525d57$export$f5c3e419c6a355ce;
$a44c59c252525d57$exports["composeIso"] = $a44c59c252525d57$export$220ad92d18dabdd7;
$a44c59c252525d57$exports["composePrism"] = $a44c59c252525d57$export$c1dc05e399870f6;
$a44c59c252525d57$exports["composeOptional"] = $a44c59c252525d57$export$323f76c400675c8b;
$a44c59c252525d57$exports["composeTraversal"] = $a44c59c252525d57$export$aa978f69e007229f;
$a44c59c252525d57$exports["modify"] = $a44c59c252525d57$export$3ff57735a52b8713;
$a44c59c252525d57$exports["modifyF"] = $a44c59c252525d57$export$a28005d3e6beb9a6;
$a44c59c252525d57$exports["fromNullable"] = $a44c59c252525d57$export$b601f49376b4621a;
$a44c59c252525d57$exports["filter"] = $a44c59c252525d57$export$3dea766d36a8935f;
$a44c59c252525d57$exports["prop"] = $a44c59c252525d57$export$977f3f6a9323c0f6;
$a44c59c252525d57$exports["props"] = $a44c59c252525d57$export$8128bb6492cf3de7;
$a44c59c252525d57$exports["component"] = $a44c59c252525d57$export$d8556a2a8f973135;
$a44c59c252525d57$exports["index"] = $a44c59c252525d57$export$b610b8812bbcded9;
$a44c59c252525d57$exports["indexNonEmpty"] = $a44c59c252525d57$export$84162b00c25b711c;
$a44c59c252525d57$exports["key"] = $a44c59c252525d57$export$df61b30b684217c0;
$a44c59c252525d57$exports["atKey"] = $a44c59c252525d57$export$976574c443b9185b;
$a44c59c252525d57$exports["some"] = $a44c59c252525d57$export$ad14ef4001db2bcd;
$a44c59c252525d57$exports["right"] = $a44c59c252525d57$export$79ffe56a765070d2;
$a44c59c252525d57$exports["left"] = $a44c59c252525d57$export$eabcd2c8791e7bf4;
$a44c59c252525d57$exports["traverse"] = $a44c59c252525d57$export$df3f009e3d155b20;
$a44c59c252525d57$exports["findFirst"] = $a44c59c252525d57$export$9a2f228bed5035c2;
$a44c59c252525d57$exports["findFirstNonEmpty"] = $a44c59c252525d57$export$28e1f787311e0a21;
$a44c59c252525d57$exports["imap"] = $a44c59c252525d57$export$b2517b0ab3a58435;
$a44c59c252525d57$exports["URI"] = $a44c59c252525d57$export$9156e739aa33e19f;
$a44c59c252525d57$exports["Invariant"] = $a44c59c252525d57$export$dbdf692cc5737cfd;
$a44c59c252525d57$exports["Semigroupoid"] = $a44c59c252525d57$export$67666a3fb7d250d8;
$a44c59c252525d57$exports["Category"] = $a44c59c252525d57$export$3a8840c5b2ecf003;






var $c2831fa19de0cc23$export$516e28dec6a4b6d4 = $71e2e12449623c93$exports.optional;
var $c2831fa19de0cc23$export$d560c7e4a29451c2 = function() {
    return $c2831fa19de0cc23$export$516e28dec6a4b6d4($1ed8bdeb457e19d0$export$ad14ef4001db2bcd, (0, $ee6b3436e10e8e67$export$c983f826f44ff86));
};
var $c2831fa19de0cc23$export$ef38eac73d6f828f = $71e2e12449623c93$exports.optionalAsTraversal;
var $c2831fa19de0cc23$export$f672e0b6f7222cd7 = $71e2e12449623c93$exports.optionalComposeOptional;
var $c2831fa19de0cc23$export$323f76c400675c8b = $c2831fa19de0cc23$export$f672e0b6f7222cd7;
var $c2831fa19de0cc23$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.isoAsOptional, $c2831fa19de0cc23$export$f672e0b6f7222cd7);
var $c2831fa19de0cc23$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.lensAsOptional, $71e2e12449623c93$exports.optionalComposeOptional);
var $c2831fa19de0cc23$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.prismAsOptional, $71e2e12449623c93$exports.optionalComposeOptional);
var $c2831fa19de0cc23$export$aa978f69e007229f = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($c2831fa19de0cc23$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalComposeTraversal(ab));
};
var $c2831fa19de0cc23$export$a2ef9d652875bdfa = $71e2e12449623c93$exports.optionalModifyOption;
var $c2831fa19de0cc23$export$b2a7969df3fe0aa3 = function(a) {
    return $c2831fa19de0cc23$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $c2831fa19de0cc23$export$3ff57735a52b8713 = $71e2e12449623c93$exports.optionalModify;
function $c2831fa19de0cc23$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.getOption(s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $c2831fa19de0cc23$export$b601f49376b4621a = /*#__PURE__*/ $c2831fa19de0cc23$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsOptional(/*#__PURE__*/ $71e2e12449623c93$exports.prismFromNullable()));
function $c2831fa19de0cc23$export$3dea766d36a8935f(predicate) {
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7($71e2e12449623c93$exports.prismAsOptional($71e2e12449623c93$exports.prismFromPredicate(predicate)));
}
var $c2831fa19de0cc23$export$977f3f6a9323c0f6 = function(prop) {
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProp(prop), $71e2e12449623c93$exports.lensAsOptional));
};
var $c2831fa19de0cc23$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProps.apply($71e2e12449623c93$exports, props), $71e2e12449623c93$exports.lensAsOptional));
};
var $c2831fa19de0cc23$export$d8556a2a8f973135 = function(prop) {
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensComponent(prop), $71e2e12449623c93$exports.lensAsOptional));
};
var $c2831fa19de0cc23$export$b610b8812bbcded9 = $71e2e12449623c93$exports.optionalIndex;
var $c2831fa19de0cc23$export$84162b00c25b711c = $71e2e12449623c93$exports.optionalIndexNonEmpty;
var $c2831fa19de0cc23$export$df61b30b684217c0 = $71e2e12449623c93$exports.optionalKey;
var $c2831fa19de0cc23$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $c2831fa19de0cc23$export$f672e0b6f7222cd7($71e2e12449623c93$exports.lensAsOptional($71e2e12449623c93$exports.atReadonlyRecord().at(key))));
    };
};
var $c2831fa19de0cc23$export$ad14ef4001db2bcd = /*#__PURE__*/ $c2831fa19de0cc23$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsOptional(/*#__PURE__*/ $71e2e12449623c93$exports.prismSome()));
var $c2831fa19de0cc23$export$79ffe56a765070d2 = /*#__PURE__*/ $c2831fa19de0cc23$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsOptional(/*#__PURE__*/ $71e2e12449623c93$exports.prismRight()));
var $c2831fa19de0cc23$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $c2831fa19de0cc23$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsOptional(/*#__PURE__*/ $71e2e12449623c93$exports.prismLeft()));
function $c2831fa19de0cc23$export$df3f009e3d155b20(T) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($c2831fa19de0cc23$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalTraverse(T));
}
function $c2831fa19de0cc23$export$9a2f228bed5035c2(predicate) {
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7($71e2e12449623c93$exports.optionalFindFirst(predicate));
}
function $c2831fa19de0cc23$export$28e1f787311e0a21(predicate) {
    return $c2831fa19de0cc23$export$f672e0b6f7222cd7($71e2e12449623c93$exports.optionalFindFirstNonEmpty(predicate));
}
var $c2831fa19de0cc23$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $c2831fa19de0cc23$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $c2831fa19de0cc23$var$imap_ = function(ea, ab, ba) {
    return $c2831fa19de0cc23$export$516e28dec6a4b6d4((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ea.getOption, $1ed8bdeb457e19d0$export$871de8747c9eaa88(ab)), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ba, ea.set));
};
var $c2831fa19de0cc23$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $c2831fa19de0cc23$export$dbdf692cc5737cfd = {
    URI: $c2831fa19de0cc23$export$9156e739aa33e19f,
    imap: $c2831fa19de0cc23$var$imap_
};
var $c2831fa19de0cc23$export$67666a3fb7d250d8 = {
    URI: $c2831fa19de0cc23$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $c2831fa19de0cc23$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $c2831fa19de0cc23$export$3a8840c5b2ecf003 = {
    URI: $c2831fa19de0cc23$export$9156e739aa33e19f,
    compose: $c2831fa19de0cc23$export$67666a3fb7d250d8.compose,
    id: $c2831fa19de0cc23$export$d560c7e4a29451c2
};






var $f6d94df68926eed5$export$e469dcfea9910464 = $71e2e12449623c93$exports.prism;
var $f6d94df68926eed5$export$d560c7e4a29451c2 = function() {
    return $f6d94df68926eed5$export$e469dcfea9910464($1ed8bdeb457e19d0$export$ad14ef4001db2bcd, (0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
var $f6d94df68926eed5$export$23f31c55d7162b91 = $71e2e12449623c93$exports.prismFromPredicate;
var $f6d94df68926eed5$export$81a625dd455a09de = $71e2e12449623c93$exports.prismAsOptional;
var $f6d94df68926eed5$export$ef38eac73d6f828f = $71e2e12449623c93$exports.prismAsTraversal;
var $f6d94df68926eed5$export$f672e0b6f7222cd7 = $71e2e12449623c93$exports.prismComposePrism;
var $f6d94df68926eed5$export$c1dc05e399870f6 = $f6d94df68926eed5$export$f672e0b6f7222cd7;
var $f6d94df68926eed5$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.isoAsPrism, $f6d94df68926eed5$export$f672e0b6f7222cd7);
var $f6d94df68926eed5$export$f5c3e419c6a355ce = $71e2e12449623c93$exports.prismComposeLens;
var $f6d94df68926eed5$export$323f76c400675c8b = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalComposeOptional(ab));
};
var $f6d94df68926eed5$export$aa978f69e007229f = function(ab) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalComposeTraversal(ab));
};
var $f6d94df68926eed5$export$adaa4cf7ef1b65be = $71e2e12449623c93$exports.prismSet;
var $f6d94df68926eed5$export$a2ef9d652875bdfa = $71e2e12449623c93$exports.prismModifyOption;
var $f6d94df68926eed5$export$3ff57735a52b8713 = $71e2e12449623c93$exports.prismModify;
function $f6d94df68926eed5$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa.getOption(s), $1ed8bdeb457e19d0$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $f6d94df68926eed5$export$b601f49376b4621a = /*#__PURE__*/ $f6d94df68926eed5$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismFromNullable());
function $f6d94df68926eed5$export$3dea766d36a8935f(predicate) {
    return $f6d94df68926eed5$export$f672e0b6f7222cd7($71e2e12449623c93$exports.prismFromPredicate(predicate));
}
var $f6d94df68926eed5$export$977f3f6a9323c0f6 = function(prop) {
    return $f6d94df68926eed5$export$f5c3e419c6a355ce((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProp(prop)));
}; // TODO: simplify?
var $f6d94df68926eed5$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $f6d94df68926eed5$export$f5c3e419c6a355ce((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProps.apply($71e2e12449623c93$exports, props)));
};
var $f6d94df68926eed5$export$d8556a2a8f973135 = function(prop) {
    return $f6d94df68926eed5$export$f5c3e419c6a355ce((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensComponent(prop)));
};
var $f6d94df68926eed5$export$b610b8812bbcded9 = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalIndex(i));
};
var $f6d94df68926eed5$export$84162b00c25b711c = function(i) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalIndexNonEmpty(i));
};
var $f6d94df68926eed5$export$df61b30b684217c0 = function(key) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$81a625dd455a09de, $71e2e12449623c93$exports.optionalKey(key));
};
var $f6d94df68926eed5$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $71e2e12449623c93$exports.prismComposeLens($71e2e12449623c93$exports.atReadonlyRecord().at(key))(sa);
    };
};
var $f6d94df68926eed5$export$ad14ef4001db2bcd = /*#__PURE__*/ $f6d94df68926eed5$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismSome());
var $f6d94df68926eed5$export$79ffe56a765070d2 = /*#__PURE__*/ $f6d94df68926eed5$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismRight());
var $f6d94df68926eed5$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $f6d94df68926eed5$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismLeft());
function $f6d94df68926eed5$export$df3f009e3d155b20(T) {
    return (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($f6d94df68926eed5$export$ef38eac73d6f828f, $71e2e12449623c93$exports.traversalTraverse(T));
}
function $f6d94df68926eed5$export$9a2f228bed5035c2(predicate) {
    return $f6d94df68926eed5$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirst(predicate));
}
function $f6d94df68926eed5$export$28e1f787311e0a21(predicate) {
    return $f6d94df68926eed5$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirstNonEmpty(predicate));
}
var $f6d94df68926eed5$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $f6d94df68926eed5$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $f6d94df68926eed5$var$imap_ = function(ea, ab, ba) {
    return $f6d94df68926eed5$export$e469dcfea9910464((0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ea.getOption, $1ed8bdeb457e19d0$export$871de8747c9eaa88(ab)), (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)(ba, ea.reverseGet));
};
var $f6d94df68926eed5$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $f6d94df68926eed5$export$dbdf692cc5737cfd = {
    URI: $f6d94df68926eed5$export$9156e739aa33e19f,
    imap: $f6d94df68926eed5$var$imap_
};
var $f6d94df68926eed5$export$67666a3fb7d250d8 = {
    URI: $f6d94df68926eed5$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $f6d94df68926eed5$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $f6d94df68926eed5$export$3a8840c5b2ecf003 = {
    URI: $f6d94df68926eed5$export$9156e739aa33e19f,
    compose: $f6d94df68926eed5$export$67666a3fb7d250d8.compose,
    id: $f6d94df68926eed5$export$d560c7e4a29451c2
};







var $8f7afd97e9e5f8f2$export$8666ce7a134c2314 = $71e2e12449623c93$exports.traversal;
var $8f7afd97e9e5f8f2$export$d560c7e4a29451c2 = function() {
    return $8f7afd97e9e5f8f2$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $8f7afd97e9e5f8f2$export$126b5a87c58d3f9c = $71e2e12449623c93$exports.fromTraversable;
var $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7 = $71e2e12449623c93$exports.traversalComposeTraversal;
var $8f7afd97e9e5f8f2$export$aa978f69e007229f = $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7;
var $8f7afd97e9e5f8f2$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.isoAsTraversal, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7);
var $8f7afd97e9e5f8f2$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.lensAsTraversal, $71e2e12449623c93$exports.traversalComposeTraversal);
var $8f7afd97e9e5f8f2$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.prismAsTraversal, $71e2e12449623c93$exports.traversalComposeTraversal);
var $8f7afd97e9e5f8f2$export$323f76c400675c8b = /*#__PURE__*/ (0, $ee6b3436e10e8e67$export$ccc7b0636abaffc3)($71e2e12449623c93$exports.optionalAsTraversal, $71e2e12449623c93$exports.traversalComposeTraversal);
var $8f7afd97e9e5f8f2$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($71e2e12449623c93$exports.ApplicativeIdentity)(f);
    };
};
var $8f7afd97e9e5f8f2$export$adaa4cf7ef1b65be = function(a) {
    return $8f7afd97e9e5f8f2$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $8f7afd97e9e5f8f2$export$b601f49376b4621a = function(sa) {
    return $8f7afd97e9e5f8f2$export$c1dc05e399870f6($71e2e12449623c93$exports.prismFromNullable())(sa);
};
function $8f7afd97e9e5f8f2$export$3dea766d36a8935f(predicate) {
    return $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7($71e2e12449623c93$exports.prismAsTraversal($71e2e12449623c93$exports.prismFromPredicate(predicate)));
}
var $8f7afd97e9e5f8f2$export$977f3f6a9323c0f6 = function(prop) {
    return $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProp(prop), $71e2e12449623c93$exports.lensAsTraversal));
};
var $8f7afd97e9e5f8f2$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensProps.apply($71e2e12449623c93$exports, props), $71e2e12449623c93$exports.lensAsTraversal));
};
var $8f7afd97e9e5f8f2$export$d8556a2a8f973135 = function(prop) {
    return $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)($71e2e12449623c93$exports.lensId(), $71e2e12449623c93$exports.lensComponent(prop), $71e2e12449623c93$exports.lensAsTraversal));
};
var $8f7afd97e9e5f8f2$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7($71e2e12449623c93$exports.optionalAsTraversal($71e2e12449623c93$exports.indexReadonlyArray().index(i))));
    };
};
var $8f7afd97e9e5f8f2$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7($71e2e12449623c93$exports.optionalAsTraversal($71e2e12449623c93$exports.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $8f7afd97e9e5f8f2$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7($71e2e12449623c93$exports.optionalAsTraversal($71e2e12449623c93$exports.indexReadonlyRecord().index(key))));
    };
};
var $8f7afd97e9e5f8f2$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $37dbc87cd4b95810$export$a4627e546088548d)(sa, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7($71e2e12449623c93$exports.lensAsTraversal($71e2e12449623c93$exports.atReadonlyRecord().at(key))));
    };
};
var $8f7afd97e9e5f8f2$export$ad14ef4001db2bcd = /*#__PURE__*/ $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsTraversal(/*#__PURE__*/ $71e2e12449623c93$exports.prismSome()));
var $8f7afd97e9e5f8f2$export$79ffe56a765070d2 = /*#__PURE__*/ $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsTraversal(/*#__PURE__*/ $71e2e12449623c93$exports.prismRight()));
var $8f7afd97e9e5f8f2$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(/*#__PURE__*/ $71e2e12449623c93$exports.prismAsTraversal(/*#__PURE__*/ $71e2e12449623c93$exports.prismLeft()));
var $8f7afd97e9e5f8f2$export$df3f009e3d155b20 = $71e2e12449623c93$exports.traversalTraverse;
function $8f7afd97e9e5f8f2$export$9a2f228bed5035c2(predicate) {
    return $8f7afd97e9e5f8f2$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirst(predicate));
}
function $8f7afd97e9e5f8f2$export$28e1f787311e0a21(predicate) {
    return $8f7afd97e9e5f8f2$export$323f76c400675c8b($71e2e12449623c93$exports.optionalFindFirstNonEmpty(predicate));
}
var $8f7afd97e9e5f8f2$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($44c3c1cb7d4112e4$export$1402880adb2295a7(M))(function(a) {
                return $44c3c1cb7d4112e4$export$dd44f18ab656f3bb(f(a));
            });
        };
    };
};
var $8f7afd97e9e5f8f2$export$93e2b83da34ff82a = function(M) {
    return $8f7afd97e9e5f8f2$export$b66cdc0497d8a99a(M)((0, $ee6b3436e10e8e67$export$f0954fd7d5368655));
};
var $8f7afd97e9e5f8f2$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $8f7afd97e9e5f8f2$export$b66cdc0497d8a99a($6ec673d1158159b2$export$c2a7ef2cc9b32b31())($6ec673d1158159b2$export$ba255e9e49e00608)(sa)(s);
    };
};
var $8f7afd97e9e5f8f2$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $8f7afd97e9e5f8f2$export$67666a3fb7d250d8 = {
    URI: $8f7afd97e9e5f8f2$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $8f7afd97e9e5f8f2$export$3a8840c5b2ecf003 = {
    URI: $8f7afd97e9e5f8f2$export$9156e739aa33e19f,
    compose: $8f7afd97e9e5f8f2$export$67666a3fb7d250d8.compose,
    id: $8f7afd97e9e5f8f2$export$d560c7e4a29451c2
};


//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($adab9da79892f477$export$66c1ae025e96b4bc(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $adab9da79892f477$export$3ff57735a52b8713(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($adab9da79892f477$export$ba6dbfc52e933ec(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($adab9da79892f477$export$6963d4cf5712e556(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($adab9da79892f477$export$81a625dd455a09de(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($adab9da79892f477$export$ef38eac73d6f828f(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($adab9da79892f477$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $adab9da79892f477$export$ba6dbfc52e933ec, $a44c59c252525d57$exports.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $adab9da79892f477$export$6963d4cf5712e556, $f6d94df68926eed5$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $adab9da79892f477$export$81a625dd455a09de, $c2831fa19de0cc23$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $adab9da79892f477$export$ef38eac73d6f828f, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $37dbc87cd4b95810$export$a4627e546088548d)($a44c59c252525d57$exports.id(), $a44c59c252525d57$exports.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $37dbc87cd4b95810$export$a4627e546088548d)($a44c59c252525d57$exports.id(), $a44c59c252525d57$exports.props.apply($a44c59c252525d57$exports, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $1ed8bdeb457e19d0$export$b601f49376b4621a)(s[k]);
                if ((0, $1ed8bdeb457e19d0$export$e56af863d5645d5f)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $a44c59c252525d57$exports.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($a44c59c252525d57$exports.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($a44c59c252525d57$exports.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($a44c59c252525d57$exports.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $a44c59c252525d57$exports.asOptional, $c2831fa19de0cc23$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $a44c59c252525d57$exports.asTraversal, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $a44c59c252525d57$exports.compose((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $adab9da79892f477$export$ba6dbfc52e933ec))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($a44c59c252525d57$exports.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($f6d94df68926eed5$export$23f31c55d7162b91(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $1ed8bdeb457e19d0$export$e56af863d5645d5f)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $1ed8bdeb457e19d0$export$a75d1723e6bda2ec).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($f6d94df68926eed5$export$81a625dd455a09de(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($f6d94df68926eed5$export$ef38eac73d6f828f(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $1ed8bdeb457e19d0$export$e56af863d5645d5f)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($f6d94df68926eed5$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $f6d94df68926eed5$export$81a625dd455a09de, $c2831fa19de0cc23$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $f6d94df68926eed5$export$ef38eac73d6f828f, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $f6d94df68926eed5$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $adab9da79892f477$export$6963d4cf5712e556))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($f6d94df68926eed5$export$f5c3e419c6a355ce(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $ee6b3436e10e8e67$export$f0954fd7d5368655), (0, $1ed8bdeb457e19d0$export$ad14ef4001db2bcd));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $1ed8bdeb457e19d0$export$b601f49376b4621a)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $c2831fa19de0cc23$export$3ff57735a52b8713(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $c2831fa19de0cc23$export$a2ef9d652875bdfa(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($c2831fa19de0cc23$export$ef38eac73d6f828f(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $1ed8bdeb457e19d0$export$e56af863d5645d5f)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($c2831fa19de0cc23$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $c2831fa19de0cc23$export$ef38eac73d6f828f, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $a44c59c252525d57$exports.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $f6d94df68926eed5$export$81a625dd455a09de))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $c2831fa19de0cc23$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $adab9da79892f477$export$81a625dd455a09de))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $8f7afd97e9e5f8f2$export$3ff57735a52b8713(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $8f7afd97e9e5f8f2$export$adaa4cf7ef1b65be(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($8f7afd97e9e5f8f2$export$3dea766d36a8935f(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $44c3c1cb7d4112e4$export$1402880adb2295a7)(M))(function(a) {
                    return (0, $44c3c1cb7d4112e4$export$dd44f18ab656f3bb)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($8f7afd97e9e5f8f2$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $a44c59c252525d57$exports.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $f6d94df68926eed5$export$ef38eac73d6f828f))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $37dbc87cd4b95810$export$a4627e546088548d)(this, $8f7afd97e9e5f8f2$export$f672e0b6f7222cd7((0, $37dbc87cd4b95810$export$a4627e546088548d)(ab, $adab9da79892f477$export$ef38eac73d6f828f))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($ad80c37a0e1ff8b2$export$3160d47a1ad63980(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($d5e4bdb075616999$export$c4dd3e639c7af330(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($d5e4bdb075616999$export$3160d47a1ad63980(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($c4094a3bee7a2fc6$export$c2a7ef2cc9b32b31())($c4094a3bee7a2fc6$export$ba255e9e49e00608);
        this.exist = foldMap((0, $ba0eb5f7cb7456fd$export$c147905ca5134122));
        this.all = foldMap((0, $ba0eb5f7cb7456fd$export$ea84ccdc68daa647));
        this.foldMapFirst = foldMap((0, $1ed8bdeb457e19d0$export$56cd0d85e73e688f)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $1ed8bdeb457e19d0$export$23f31c55d7162b91)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $ee6b3436e10e8e67$export$c983f826f44ff86)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $8f7afd97e9e5f8f2$export$126b5a87c58d3f9c(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});

parcelRegister("8ogUZ", function(module, exports) {
"use strict";
var $61bdb0342c28bc8c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61bdb0342c28bc8c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $61bdb0342c28bc8c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.MalformedJSON = module.exports.PartialJSON = module.exports.parseJSON = module.exports.parse = void 0;

Object.defineProperty(module.exports, "Allow", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cxirr")).Allow;
    }
});

$61bdb0342c28bc8c$var$__exportStar((parcelRequire("cxirr")), module.exports);
class $61bdb0342c28bc8c$var$PartialJSON extends Error {
}
module.exports.PartialJSON = $61bdb0342c28bc8c$var$PartialJSON;
class $61bdb0342c28bc8c$var$MalformedJSON extends Error {
}
module.exports.MalformedJSON = $61bdb0342c28bc8c$var$MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function $61bdb0342c28bc8c$var$parseJSON(jsonString, allowPartial = (parcelRequire("cxirr")).Allow.ALL) {
    if (typeof jsonString !== "string") throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return $61bdb0342c28bc8c$var$_parseJSON(jsonString.trim(), allowPartial);
}
module.exports.parseJSON = $61bdb0342c28bc8c$var$parseJSON;
const $61bdb0342c28bc8c$var$_parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new $61bdb0342c28bc8c$var$PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new $61bdb0342c28bc8c$var$MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON("Unexpected end of input");
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === "{") return parseObj();
        if (jsonString[index] === "[") return parseArr();
        if (jsonString.substring(index, index + 4) === "null" || (parcelRequire("cxirr")).Allow.NULL & allow && length - index < 4 && "null".startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === "true" || (parcelRequire("cxirr")).Allow.BOOL & allow && length - index < 4 && "true".startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === "false" || (parcelRequire("cxirr")).Allow.BOOL & allow && length - index < 5 && "false".startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === "Infinity" || (parcelRequire("cxirr")).Allow.INFINITY & allow && length - index < 8 && "Infinity".startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === "-Infinity" || (parcelRequire("cxirr")).Allow._INFINITY & allow && 1 < length - index && length - index < 9 && "-Infinity".startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === "NaN" || (parcelRequire("cxirr")).Allow.NAN & allow && length - index < 3 && "NaN".startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === "\\")){
            escape = jsonString[index] === "\\" ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if ((parcelRequire("cxirr")).Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("\\")) + '"');
        }
        markPartialJSON("Unterminated string literal");
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== "}"){
                skipBlank();
                if (index >= length && (parcelRequire("cxirr")).Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    obj[key] = value;
                } catch (e) {
                    if ((parcelRequire("cxirr")).Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("cxirr")).Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== "]"){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("cxirr")).Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === "-") throwMalformedError("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if ((parcelRequire("cxirr")).Allow.NUM & allow) try {
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf("e")));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === "-") index++;
        while(jsonString[index] && ",]}".indexOf(jsonString[index]) === -1)index++;
        if (index == length && !((parcelRequire("cxirr")).Allow.NUM & allow)) markPartialJSON("Unterminated number literal");
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === "-") markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("e")));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && " \n\r\t".includes(jsonString[index]))index++;
    };
    return parseAny();
};
const $61bdb0342c28bc8c$var$parse = $61bdb0342c28bc8c$var$parseJSON;
module.exports.parse = $61bdb0342c28bc8c$var$parse;

});

parcelRegister("cxirr", function(module, exports) {
"use strict";
/**
 * Sometimes you don't allow every type to be partially parsed.
 * For example, you may not want a partial number because it may increase its size gradually before it's complete.
 * In this case, you can use the `Allow` object to control what types you allow to be partially parsed.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.ALL = module.exports.COLLECTION = module.exports.ATOM = module.exports.SPECIAL = module.exports.INF = module.exports._INFINITY = module.exports.INFINITY = module.exports.NAN = module.exports.BOOL = module.exports.NULL = module.exports.OBJ = module.exports.ARR = module.exports.NUM = module.exports.STR = void 0;
/**
 * allow partial strings like `"hello \u12` to be parsed as `"hello "`
 */ module.exports.STR = 1;
/**
 * allow partial numbers like `123.` to be parsed as `123`
 */ module.exports.NUM = 2;
/**
 * allow partial arrays like `[1, 2,` to be parsed as `[1, 2]`
 */ module.exports.ARR = 4;
/**
 * allow partial objects like `{"a": 1, "b":` to be parsed as `{"a": 1}`
 */ module.exports.OBJ = 8;
/**
 * allow `nu` to be parsed as `null`
 */ module.exports.NULL = 16;
/**
 * allow `tr` to be parsed as `true`, and `fa` to be parsed as `false`
 */ module.exports.BOOL = 32;
/**
 * allow `Na` to be parsed as `NaN`
 */ module.exports.NAN = 64;
/**
 * allow `Inf` to be parsed as `Infinity`
 */ module.exports.INFINITY = 128;
/**
 * allow `-Inf` to be parsed as `-Infinity`
 */ module.exports._INFINITY = 256;
module.exports.INF = module.exports.INFINITY | module.exports._INFINITY;
module.exports.SPECIAL = module.exports.NULL | module.exports.BOOL | module.exports.INF | module.exports.NAN;
module.exports.ATOM = module.exports.STR | module.exports.NUM | module.exports.SPECIAL;
module.exports.COLLECTION = module.exports.ARR | module.exports.OBJ;
module.exports.ALL = module.exports.ATOM | module.exports.COLLECTION;
/**
 * Control what types you allow to be partially parsed.
 * The default is to allow all types to be partially parsed, which in most casees is the best option.
 * @example
 * If you don't want to allow partial objects, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, Allow.ARR); // [ { a: 1, b: 2 } ]
 * ```
 * Or you can use `~` to disallow a type:
 * ```ts
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, ~Allow.OBJ); // [ { a: 1, b: 2 } ]
 * ```
 * @example
 * If you don't want to allow partial strings, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`["complete string", "incompl`, ~Allow.STR); // [ 'complete string' ]
 * ```
 */ module.exports.Allow = {
    STR: module.exports.STR,
    NUM: module.exports.NUM,
    ARR: module.exports.ARR,
    OBJ: module.exports.OBJ,
    NULL: module.exports.NULL,
    BOOL: module.exports.BOOL,
    NAN: module.exports.NAN,
    INFINITY: module.exports.INFINITY,
    _INFINITY: module.exports._INFINITY,
    INF: module.exports.INF,
    SPECIAL: module.exports.SPECIAL,
    ATOM: module.exports.ATOM,
    COLLECTION: module.exports.COLLECTION,
    ALL: module.exports.ALL
};
module.exports.default = module.exports.Allow;

});


//# sourceMappingURL=FullPageEditorComponent.8b345e13.js.map
